(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("UmUI", [], factory);
	else if(typeof exports === 'object')
		exports["UmUI"] = factory();
	else
		root["UmUI"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 26);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(31)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "UmComment",
  data: function data() {
    return {
      reviewtype: 0,
      usercomments: '',
      page: 0,
      pagesize: 10,
      totalpage: 0,
      total: 0,
      umid: '',
      parentreviewid: '',
      review: [],
      textareafocus: false
    };
  },

  props: ["avatar", "sumname", "sid", "appid", "reviewcount"],
  mounted: function mounted() {
    var that = this;
    that.umid = $UMCore.uncompile("umid");
    var waitReady = function waitReady() {
      if (that.sid != '' && that.sid != undefined) {
        that.getreview();
        if ($UMCore.uncompile('token') != null) {
          var commenttype = localStorage.getItem("commenttype");
          if (commenttype == 1) {
            that.usercomments = localStorage.getItem("comment");
            that.usercommentsfun();
          } else if (commenttype == 2) {
            var sid = localStorage.getItem("commentsid");
            that.cai(sid);
          } else if (commenttype == 3) {
            var sid = localStorage.getItem("commentsid");
            that.ding(sid);
          }
        }
        localStorage.removeItem("commenttype");
        localStorage.removeItem("comment");
        localStorage.removeItem("commentsid");
      } else {
        setTimeout(function () {
          waitReady();
        }, 20);
      }
    };
    setTimeout(function () {
      waitReady();
    }, 50);
  },

  methods: {
    setTextAreaFocus: function setTextAreaFocus(val) {
      console.log(val);
      var that = this;
      that.textareafocus = val;
    },
    getreview: function getreview() {
      var that = this;
      console.log(JSON.stringify({
        functionname: "comments_getlist",
        dappuuid: that.sid,
        page: that.page,
        pagesize: that.pagesize,
        umid: that.umid
      }));
      $UMCore.post("/route.lua", {
        data: JSON.stringify({
          functionname: "comments_getlist",
          dappuuid: that.sid,
          page: that.page,
          pagesize: that.pagesize,
          umid: that.umid
        })
      }).then(function (response) {
        if (response.data.code == 0) {
          that.totalpage = response.data.totalpage;
          that.total = response.data.total;
          that.review = response.data.slist;
          for (var i = 0; i < that.review.length; i++) {
            that.$set(that.review[i], 'clickNum', -1);
            that.$set(that.review[i], 'clickNum1', -1);
          }
        } else if (response.data.code == 1) {
          that.$message.error("网络错误2！");
        } else {
          that.$message.error("请登录！");
        }
      }).catch(function (error) {
        console.log(error);
        that.$message.error("网络错误3！");
        return false;
      });
    },

    /**
     * 获取新闻相关内容（详情，评论）
     */
    api: function api() {
      var that = this;
      $UMCore.post("/route.lua", {
        data: JSON.stringify({
          functionname: "comments_set",
          dappid: that.appid,
          edittype: that.edittype,
          dappuuid: that.sid,
          itype: that.reviewtype,
          stext: that.usercomments,
          umid: that.umid,
          parentid: that.parentreviewid
        })
      }).then(function (response) {
        if (response.data.status) {
          that.usercomments = '';
          if (that.reviewtype == 1) {
            that.getreview();
          }
        } else {
          that.$message({ message: '失败', type: 'error', customClass: 'popupMessage' });
        }
      }).catch(function (error) {
        console.log(error);
        that.$message.error("网络错误！");
        return false;
      });
    },

    /**
     * 发送新闻评论内容
     */
    usercommentsfun: function usercommentsfun() {
      var that = this;
      if ($UMCore.uncompile('token') == null) {
        // this.openloginview()
      } else {
        var that = this;
        that.reviewtype = 1;
        if (that.usercomments != '') {
          that.api();
          // that.detailInfo.reviewcount=parseInt(that.detailInfo.reviewcount)+1;
          that.reviewcount = parseInt(that.reviewcount) + 1;
          this.$emit('retcomment', that.reviewcount);
        } else {
          that.$message({ message: '不能发送空信息', type: 'error', customClass: 'popupMessage' });
        }
      }
    },
    caifun: function caifun(id) {
      var that = this;
      that.parentreviewid = id;
      that.reviewtype = 3;
      that.api();
      for (var j = 0; j < that.review.length; j++) {
        if (id == that.review[j].sid) {
          if (that.review[j].minecai === '1') {
            that.review[j].minecai = '0';
            that.review[j].caicount = that.review[j].caicount - 1;
            break;
          } else if (that.review[j].minecai === '0' && that.review[j].mineding === '1') {
            that.review[j].caicount = parseInt(that.review[j].caicount) + 1;
            that.review[j].dingcount = that.review[j].dingcount - 1;
            that.review[j].minecai = '1';
            that.review[j].mineding = '0';
            break;
          } else {
            that.review[j].minecai = '1';
            that.review[j].caicount = parseInt(that.review[j].caicount) + 1;
            break;
          }
        }
      }
    },

    /**
     * 新闻评论顶
     */
    dingfun: function dingfun(id) {
      var that = this;
      that.parentreviewid = id;
      that.reviewtype = 2;
      that.api();
      for (var j = 0; j < that.review.length; j++) {
        if (id == that.review[j].sid) {
          if (that.review[j].mineding === '1') {
            that.review[j].mineding = '0';
            that.review[j].dingcount = that.review[j].dingcount - 1;
            break;
          } else if (that.review[j].minecai === '1' && that.review[j].mineding === '0') {
            that.review[j].caicount = that.review[j].caicount - 1;
            that.review[j].dingcount = parseInt(that.review[j].dingcount) + 1;
            that.review[j].minecai = '0';
            that.review[j].mineding = '1';
            break;
          } else {
            that.review[j].mineding = '1';
            that.review[j].dingcount = parseInt(that.review[j].dingcount) + 1;
            break;
          }
        }
      }
    },
    changepage: function changepage(event) {
      var that = this;
      that.page = event - 1;
      that.getreview();
    },
    getShortName: function getShortName(sname) {
      if (sname != undefined && sname.length > 2) {
        return sname.substr(sname.length - 2, 2);
      }
      if (this.umid == '' || this.umid == undefined) {
        return '未登录';
      }
      return sname;
    },
    send: function send() {
      // this.$emit('retusercomments',this.usercomments);
      if ($UMCore.uncompile('token') == null) {
        localStorage.setItem("commenttype", 1);
        localStorage.setItem("comment", this.usercomments);
        this.$emit('unlogin', '');
      } else {
        this.usercommentsfun();
        this.usercomments = '';
      }
    },
    cai: function cai(sid) {
      // this.$emit('retcai',sid);
      if ($UMCore.uncompile('token') == null) {
        localStorage.setItem("commenttype", 2);
        localStorage.setItem("commentsid", sid);
        this.$emit('unlogin', '');
      } else {
        this.caifun(sid);
      }
    },
    ding: function ding(sid) {
      // this.$emit('retding',sid);
      if ($UMCore.uncompile('token') == null) {
        localStorage.setItem("commenttype", 3);
        localStorage.setItem("commentsid", sid);
        this.$emit('unlogin', '');
      } else {
        this.dingfun(sid);
      }
    }
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import lrz from "lrz";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "UmImg",
  data: function data() {
    return {
      imageUrl: "",
      avatarname: [],
      fileList: []
    };
  },
  mounted: function mounted() {
    this.imageUrl = this.uploadlogo;
  },

  props: ["uploadlogo", "submitStatus"],
  watch: {
    uploadlogo: function uploadlogo(val) {
      this.imageUrl = val;
    },
    submitStatus: function submitStatus(val) {
      var _this = this;

      if (val) {
        if (this.fileList.length > 0) {
          var formData = new FormData(); //  用FormData存放上传文件
          this.fileList.forEach(function (file, index) {
            formData.append("filename" + index, file.raw); //此处一定是append file.raw 上传文件只需维护fileList file.raw.name要加上
          });
          $UMCore.post(window.fileurl, formData).then(function (res) {
            _this.fileList = [];
            _this.$emit("submit-file", res.data[0]);
          }).catch(function (error) {
            _this.$message.error("上传失败！");
            return false;
          });
        } else {
          this.fileList = [];
          this.$emit("submit-file", '');
        }
      }
    }
  },
  methods: {
    onChange: function onChange(file, fileList) {
      var _this2 = this;

      //这里做一些文件控制，注意：就算一次选取多个文件，这里依旧会执行多次
      // this.fileList = fileList;
      lrz(file.raw).then(function (rst) {
        // 处理成功会执行
        file.raw = _this2.dataURLtoFile(rst.base64, file.raw.name);
        if (file.size / 1024 / 1024 > 100) {
          _this2.$message.error("文件上传不能超过100M！");
        } else {
          if (_this2.imageUrl) {
            _this2.imageUrl = URL.createObjectURL(file.raw);
          }
          _this2.fileList = [];
          _this2.fileList.push(file);
          _this2.$emit("getImgSrc", URL.createObjectURL(file.raw));
        }
      }).catch(function (err) {
        _this2.$message.error("目前仅支持jpg,png,gif,jpeg格式！");
        // this.fileList.push(file);
        // 处理失败会执行
      }).always(function () {
        // 不管是成功失败，都会执行
      });
    },
    dataURLtoFile: function dataURLtoFile(dataurl, filename) {
      //将base64转换为文件
      var arr = dataurl.split(",");
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      //转换成file对象
      return new File([u8arr], filename, { type: mime });
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.avatarname.push(res[0].filename);
      this.$emit("getImgSrc", res[0]);
    },
    error: function error(res) {
      this.$message.error("文件上传失败！");
      this.$emit("getImgSrc", "");
    },
    remove: function remove() {
      this.$emit("getImgSrc", "");
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/gif";
      var isLt2M = file.size / 1024 / 1024 < 100;

      if (!isJPG) {
        this.$message.error("目前仅支持jpg,png,gif格式！");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 100MB！");
      }
      return isJPG && isLt2M;
    }
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "UmAnimate",
  data: function data() {
    return {
      type: 0,
      amount: 0
    };
  },

  // props:['anbox',"anbox1"],
  mounted: function mounted() {
    var that = this;
    var a = {
      paymentnotice: function paymentnotice(ummsg) {
        that.type = ummsg.noticetype;
        that.amount = ummsg.Amount;
        setTimeout(function () {
          that.type = 0;
        }, 3500);
      }
    };
    $UMCore.on(['msg'], a);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'UmList',
    data: function data() {
        return {};
    },

    props: ["newsInfo"],
    methods: {
        showDeatil: function showDeatil(item) {
            localStorage.setItem('newsid', item.newsid);
            this.$emit('retiteminfo', item);
        }
    }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "umAttachment",
  data: function data() {
    return {
      file: [],
      fileList: []
    };
  },

  props: ["submitStatus"],
  watch: {
    submitStatus: function submitStatus(val) {
      var _this = this;

      if (val) {
        if (this.file.length > 0) {
          var formData = new FormData(); //  用FormData存放上传文件
          this.file.forEach(function (file, index) {
            formData.append("filename" + index, file.raw); //此处一定是append file.raw 上传文件只需维护fileList file.raw.name要加上
          });
          $UMCore.post(window.fileurl, formData).then(function (res) {
            _this.$emit("submit-file", res.data);
          }).catch(function (error) {
            _this.$message.error("上传失败！");
            return false;
          });
        } else {
          this.$emit("submit-file", '');
        }
      }
    }
  },
  methods: {
    onChange: function onChange(file, fileList) {
      //这里做一些文件控制，注意：就算一次选取多个文件，这里依旧会执行多次
      if (file.size / 1024 / 1024 > 100) {
        this.$message.error("文件上传不能超过100M！");
        this.fileList = [];
      } else {
        this.file = Object.assign(this.file, fileList);
      }
    },
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning("\u5F53\u524D\u9650\u5236\u9009\u62E9 1 \u4E2A\u6587\u4EF6\uFF0C\u672C\u6B21\u9009\u62E9\u4E86 " + files.length + " \u4E2A\u6587\u4EF6\uFF0C\u5171\u9009\u62E9\u4E86 " + (files.length + fileList.length) + " \u4E2A\u6587\u4EF6");
    },
    success: function success(res) {
      this.file.push(res[0].filename);
      this.$emit("getfileSrc", this.file);
      this.$emit("getfileInfo", res);
    },
    error: function error(res) {
      this.$message.error("文件上传失败！");
      this.$emit("getfileInfo", []);
    },
    remove: function remove(res) {
      // this.file.forEach((element, index) => {
      //   if (element === res.filename) {
      //     this.file.splice(index, 1);
      //   }
      // });
      this.fileList = [];
      this.file = [];
      this.$emit("getfileInfo", []);
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global $UMCore */
/* eslint handle-callback-err: "warn" */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UmSelectuser',
  data: function data() {
    return {
      props1: {
        label: 'name'
      },
      flist: [],
      filterText: '',
      icon: 'el-icon-success'
    };
  },

  props: ["checkArray", "total"],
  /**
   * 监听过滤词变化
   */
  watch: {
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    },
    checkArray: function checkArray(val) {
      this.$refs.tree.setCheckedNodes(val);
    },
    total: function total(val) {
      this.totalPeople = val;
    }
  },
  mounted: function mounted() {
    var that = this;
    var arr = [];
    that.checkArray.forEach(function (m) {
      // if(m.id!=$UMCore.uncompile('umid')){
      arr.push(m.id);
      // }
    });
    that.$refs.tree.setCheckedKeys(arr);
    var result = {
      __event_name: 'selectors',
      userlist_get_result: function userlist_get_result(ummsg) {
        if (ummsg.data.itype === '0') {
          $UMCore.msg({
            cmd: 'fun',
            op: 'userresult',
            info: '',
            data: { status: true, flist: ummsg.data.slist }
          });
        } else {
          that.flist = ummsg.data.slist;
          $UMCore.msg({
            cmd: 'fun',
            op: 'userresult1',
            info: '',
            data: { status: true, flist: ummsg.data.slist }
          });
        }
      }
    };
    $UMCore.on(['fun'], result);
  },

  methods: {
    loadNode1: function loadNode1(node, resolve) {
      var that = this;
      if (node.level === 0) {
        $UMCore.post('route.lua', {
          data: JSON.stringify({
            functionname: 'userlist_get',
            itype: 0,
            umid: $UMCore.uncompile('umid'),
            page: 0,
            pagesize: 5,
            disabled: 3
          })
        }).then(function (res) {
          if (res.data.status) {
            var arr = res.data.slist;
            return resolve(arr);
          }
        }).catch(function (error) {});
      }

      if (node.level > 0) {
        if (node.data.type !== '1') {
          $UMCore.post('route.lua', {
            data: JSON.stringify({
              functionname: 'userlist_get',
              itype: node.data.itype,
              umid: $UMCore.uncompile('umid'),
              orgid: node.data.orgid,
              deptno: node.data.deptno,
              disabled: 3
            })
          }).then(function (res) {
            if (res.data.status) {
              var arr = res.data.slist;
              var arrq = [];
              that.checkArray.forEach(function (m) {
                arrq.push(m.id);
              });
              that.$refs.tree.setCheckedKeys(arrq);
              return resolve(arr);
            }
          }).catch(function (error) {});
        } else {
          return resolve([]);
        }
      }
    },

    /**
     * 获取选中的node节点
     */
    getCheckedNodes: function getCheckedNodes() {
      console.log(this.$refs.tree.getCheckedNodes());
      console.log(this.$refs.tree.getCheckedKeys());
    },

    /**
     * 根据关键词检索列表
     */
    filterNode: function filterNode(value, data, node) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    handleCheckChange: function handleCheckChange(data, checked, indeterminate) {
      var that = this;
      var checklist = that.$refs.tree.getCheckedNodes();
      var s = '';
      for (var i = 0; i < checklist.length; i++) {
        if (data.id === checklist[i].id) {
          if (data.type === '1') {
            data.usercount = 1;
          }
          s = 'add';
        }
      }
      if (s === 'add') {
        that.totalPeople = that.totalPeople + parseInt(data.usercount);
      } else if (s === '') {
        that.totalPeople = that.totalPeople - parseInt(data.usercount);
      }
      that.$emit('check', data, that.totalPeople);
    }
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "umDialog",
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {
    var that = this;
    that.$nextTick(function () {
      //使用nextTick为了保证dom元素都已经渲染完毕 
      //声明需要用到的变量
      var mx = 0,
          my = 0; //鼠标x、y轴坐标（相对于left，top）
      var dx = 0,
          dy = 0; //对话框坐标（同上）
      var isDraging = false; //不可拖动
      var dialogW, dialogH, dialog;
      //鼠标按下
      $(".move_part1").mousedown(function (e) {
        e = e || window.event;
        mx = e.clientX; //点击时鼠标X坐标
        my = e.clientY; //点击时鼠标Y坐标
        if (e.target.tagName == 'DIV') {
          dialog = e.target.parentElement;
        } else {
          dialog = e.target.parentElement.parentElement;
        }
        dialogW = dialog.offsetLeft;
        dialogH = dialog.offsetTop;
        dx = dialogW - document.documentElement.scrollLeft;
        dy = dialogH - document.documentElement.scrollTop;
        isDraging = true; //标记对话框可拖动
      });

      //鼠标移动更新窗口位置
      $(document).mousemove(function (e) {
        var e = e || window.event;
        var x1 = e.clientX; //移动时鼠标X坐标
        var y1 = e.clientY; //移动时鼠标Y坐标
        if (isDraging) {
          //判断对话框能否拖动

          var moveX = dx + x1 - mx; //移动后对话框新的left值
          var moveY = dy + y1 - my; //移动后对话框新的top值
          //设置拖动范围
          var pageW = $(window).width();
          var pageH = $(window).height();
          var dialog1W = dialog.offsetWidth;
          var dialog1H = dialog.offsetHeight;
          var maxX = pageW - dialog1W; //X轴可拖动最大值
          var maxY = pageH - dialog1H; //Y轴可拖动最大值
          moveX = Math.min(Math.max(0, moveX), maxX); //X轴可拖动范围
          moveY = Math.min(Math.max(0, moveY), maxY); //Y轴可拖动范围
          // 重新设置对话框的left、top
          dialog.style.left = moveX + 'px';
          dialog.style.top = moveY + 'px';
        };
      });

      //鼠标离开
      $(".move_part1").mouseup(function () {
        isDraging = false;
      });
      var open = {
        openiframe1: function openiframe1(ummsg) {
          if (ummsg.data.width && ummsg.data.height) {
            $('.dialog1_content .popup-content').css({ "width": ummsg.data.width, "height": ummsg.data.height });
          } else {
            $('.dialog1_content .popup-content').css({ "width": '800px', "height": '550px' });
          }
          $('.dialog1_head span').text(ummsg.data.title);
          if (that.show) {
            that.$nextTick(function () {
              //使用nextTick为了保证dom元素都已经渲染完毕 
              that.autoCenter(that.$refs.dialog);
            });
          }
        }
      };
      $UMCore.on(["iframe"], open);
    });
  },

  // watch:{
  //   show(val){
  //     this.$nextTick(() => { //使用nextTick为了保证dom元素都已经渲染完毕 
  //         this.autoCenter(this.$refs.dialog)
  //     });
  //   }
  // },
  props: ['show'],
  methods: {
    autoCenter: function autoCenter(el) {
      this.$nextTick(function () {
        //使用nextTick为了保证dom元素都已经渲染完毕 
        var bodyW = $(window).width();
        var bodyH = $(window).height();
        var elW = el.offsetWidth;
        var elH = el.offsetHeight;
        el.style.left = (bodyW - elW) / 2 + 'px';
        el.style.top = (bodyH - elH) / 2 + 'px';
      });
    },
    close: function close() {
      this.$emit('showchange', false);
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(71);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "umAddlist",
  data: function data() {
    return {
      checkArray: [],
      total: 0,
      groupForm: {
        groupname: "",
        grouptype: "0",
        groupinfo: "",
        logopath: "/img/default/group/defaultIcon1.png"
      },
      groupupload: "",
      orgid: "",
      dappupload: "",
      orgupload: "",
      defaultIcon: [{ id: 1, path: "/img/default/org/defaultIcon1.png" }, { id: 2, path: "/img/default/org/defaultIcon2.png" }, { id: 3, path: "/img/default/org/defaultIcon3.png" }, { id: 4, path: "/img/default/org/defaultIcon4.png" }, { id: 5, path: "/img/default/org/defaultIcon5.png" }, { id: 6, path: "/img/default/org/defaultIcon6.png" }, { id: 7, path: "/img/default/org/defaultIcon7.png" }, { id: 8, path: "/img/default/org/defaultIcon8.png" }, { id: 9, path: "/img/default/org/defaultIcon9.png" }, { id: 10, path: "/img/default/org/defaultIcon10.png" }, { id: 11, path: "/img/default/org/defaultIcon11.png" }, { id: 12, path: "/img/default/org/defaultIcon12.png" }],
      defaultIcon1: [{ id: 1, path: "/img/default/group/defaultIcon1.png" }, { id: 2, path: "/img/default/group/defaultIcon2.png" }, { id: 3, path: "/img/default/group/defaultIcon3.png" }, { id: 4, path: "/img/default/group/defaultIcon4.png" }, { id: 5, path: "/img/default/group/defaultIcon5.png" }, { id: 6, path: "/img/default/group/defaultIcon6.png" }, { id: 7, path: "/img/default/group/defaultIcon7.png" }, { id: 8, path: "/img/default/group/defaultIcon8.png" }, { id: 9, path: "/img/default/group/defaultIcon9.png" }, { id: 10, path: "/img/default/group/defaultIcon10.png" }, { id: 11, path: "/img/default/group/defaultIcon11.png" }, { id: 12, path: "/img/default/group/defaultIcon12.png" }],
      defaultIcon2: [{ id: 1, path: "/img/default/dapp/defaultIcon1.png" }, { id: 2, path: "/img/default/dapp/defaultIcon2.png" }, { id: 3, path: "/img/default/dapp/defaultIcon3.png" }, { id: 4, path: "/img/default/dapp/defaultIcon4.png" }, { id: 5, path: "/img/default/dapp/defaultIcon5.png" }, { id: 6, path: "/img/default/dapp/defaultIcon6.png" }, { id: 7, path: "/img/default/dapp/defaultIcon7.png" }, { id: 8, path: "/img/default/dapp/defaultIcon8.png" }, { id: 9, path: "/img/default/dapp/defaultIcon9.png" }, { id: 10, path: "/img/default/dapp/defaultIcon10.png" }, { id: 11, path: "/img/default/dapp/defaultIcon11.png" }, { id: 12, path: "/img/default/dapp/defaultIcon12.png" }],
      candidate: false,
      usertype: [],
      tagsFriend: [],
      tagsOrg: [],
      tagsGroup: [],
      tagshy: [],
      tagsdq: [],
      showRightList: -1,
      selectcolor: 1,
      value: 0,
      showid: false,
      options: [{
        value: 0,
        label: "普通群"
      }, {
        value: 1,
        label: "部门群"
      }],
      actaddress: "",
      address: {
        province: "",
        city: "",
        area: ""
      },
      adduserText: "好友推荐",
      tabactiveid: 0,
      userlist: [{ avatar: "", sumname: "蔡威泽", sphone: "17825449615" }, {
        avatar: "",
        sumname: "蔡威泽",
        job: "web前端可开发工程师",
        company: "青岛天狗物联科技有限公司",
        sphone: "17825449615"
      }, {
        avatar: "",
        sumname: "蔡威泽",
        job: "web前端可开发工程师",
        company: "青岛天狗物联科技有限公司",
        sphone: "17825449615"
      }, {
        sumname: "蔡威泽",
        job: "web前端可开发工程师",
        company: "青岛天狗物联科技有限公司",
        sphone: "17825449615"
      }],
      isphone: false,
      isfriend: false,
      searchText: "",
      validationMsg: "",
      rules: {
        orgname: [{ required: true, message: "组织名称", trigger: "blur" }],
        value: [{ required: true, message: "组织类型", trigger: "change" }]
      },
      dialogInfo: {},
      mine: 0,
      submitBtn: "立即创建",
      strangermsg: 1,
      submitImgStatus: false,
      sNum: 0,
      squarelist: [{
        name: "推荐",
        id: 0,
        list: [],
        total: 1,
        shownum: 8,
        page: 0
      }, {
        name: "共同好友",
        id: 1,
        list: [],
        total: 1,
        shownum: 8,
        page: 0
      }, {
        name: "同城",
        id: 2,
        list: [],
        total: 1,
        shownum: 8,
        page: 0
      }, { name: "同乡", id: 3, list: [], total: 1, shownum: 8, page: 0 }, {
        name: "同行",
        id: 4,
        list: [],
        total: 1,
        shownum: 8,
        page: 0
      }, {
        name: "校友",
        id: 5,
        list: [],
        total: 1,
        shownum: 8,
        page: 0
      }],
      squarelist2: [{
        name: "群推荐",
        id: 1,
        list: [],
        total: 1,
        shownum: 8,
        page: 0
      }],
      squarelist1: [{
        name: "组织推荐",
        id: 1,
        list: [],
        total: 1,
        shownum: 8,
        page: 0
      }],
      apply_group: false,
      apply_org: false,
      validationGroupMsg: "",
      validationOrgMsg: "",
      applyroomid: 0,
      applyorgid: 0,
      gxtype: 0,
      searchBoxshow: false,
      searchuserlist: [],
      squaretab: [{ id: 0, name: "找人" }, { id: 1, name: "找组织" }, { id: 2, name: "找群组"
        // {id:3,name:'找服务'},
        // {id:4,name:'找商机'}
      }],
      setad: Object,
      setstatus: false,
      next: false,
      dappmodulelist: [],
      dappstylelist: [],
      dapptypelist1: []
    };
  },
  mounted: function mounted() {
    var that = this;
    if (that.choosedtype) {
      that.usertype = [].concat(_toConsumableArray(that.choosedtype));
    }
    that.mine = $UMCore.uncompile("umid");
    that.squarelistFun(0);
    that.squarelistFun1(0);
    that.squarelistFun2(0);
    var m = {
      editorginfo: function editorginfo(ummsg) {
        that.submitBtn = "立即修改";
        that.setad = {
          province: ummsg.data.orginfo.province,
          city: ummsg.data.orginfo.city,
          district: ummsg.data.orginfo.area
        };
        that.setstatus = true;
      }
    };
    $UMCore.on(["org"], m);
    that.tagsFriend = [];
    that.tagsFriend.push({
      id: $UMCore.uncompile("umid"),
      name: $UMCore.uncompile("sumname")
    });
    if (this.formdapp) {
      that.getdappModule();
      that.getdappsquare();
    }
  },

  props: ["searchUserText", "unionStatus", "gxorgid", "chooseorg", "customClass", "addDailog", "groupTitle", "form", "formdapp", "createtype", "submitStatus", "fileinfo", "address", "hpform", "toumid", "toname", "showPeople", "choosedtype"],
  watch: {
    form: {
      handler: function handler(newval, oldval) {
        if (this.addDailog) {
          if (newval.logopath && newval.logopath != "") {
            for (var i = 1; i < this.defaultIcon.length; i++) {
              if (this.defaultIcon[i - 1].path == newval.logopath) {
                this.selectcolor = i;
                break;
              } else {
                this.selectcolor = -1;
              }
            }
          }
        }
      },

      immediate: true,
      deep: true
    },
    formdapp: {
      handler: function handler(newval, oldval) {
        if (this.addDailog) {
          if (newval.logopath && newval.logopath != "") {
            for (var i = 1; i < this.defaultIcon2.length; i++) {
              if (this.defaultIcon2[i - 1].path == newval.logopath) {
                this.selectcolor = i;
                break;
              } else {
                this.selectcolor = -1;
              }
            }
          }
        }
      },

      immediate: true,
      deep: true
    },
    searchUserText: {
      handler: function handler(newval, oldval) {
        this.searchText = newval;
        if (this.searchText != "") {
          this.searchfriends();
        } else {
          this.squarelistFun(0);
        }
      },

      immediate: true,
      deep: true
    },
    active: {
      handler: function handler(newval, oldval) {
        if (newval) {
          this.tabactiveid = newval;
          this.changetab(newval);
        } else {
          this.tabactiveid = 0;
          this.changetab(0);
        }
      },

      immediate: true,
      deep: true
    },
    "formdapp.dappmodule": {
      handler: function handler(newval, oldval) {
        if (newval == "58c66a66240c07432a41691e2b6f1a7b") {
          this.formdapp.istyle = "c9a4ae48acfd67565bc1ea5706bf5c4d";
        } else {
          if (this.dappstylelist.length > 0) {
            this.formdapp.istyle = this.dappstylelist[0].sid;
          }
        }
      },

      immediate: false,
      deep: true
    },
    addDailog: {
      handler: function handler(newval, oldval) {
        var _this = this;

        this.submitImgStatus = false;
        if (newval && this.createtype == "org") {
          // console.log(74526,mm)
          Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* mm */])(this.customClass, this.setstatus, this.setad);
        }
        if (newval && this.createtype == "dapp" || newval && this.createtype == "copydapp" || newval && this.createtype == "editdapp") {
          // console.log(74526,mm)
          this.tagsFriend = [];
          this.tagsGroup = [];
          this.tagshy = [];
          this.tagsdq = [];
        }
        if (this.createtype == "editdapp") {
          this.submitBtn = "提交";
          if (this.formdapp.rangelist) {
            this.formdapp.rangelist.forEach(function (m) {
              if (m.type == "21") {
                _this.tagsFriend.push({
                  name: m.name,
                  id: m.items
                });
              } else if (m.type == "22") {
                _this.tagsGroup.push({
                  name: m.name,
                  id: m.items
                });
              } else if (m.type == "31") {
                _this.tagshy.push({
                  name: m.name,
                  code: m.items,
                  id: m.extid
                });
              } else if (m.type == "41") {
                _this.tagsdq.push({
                  name: m.name,
                  code: m.items,
                  id: m.extid
                });
              }
            });
          }
        } else if (this.createtype == "copydapp") {
          this.submitBtn = "立即复制";
        } else if (this.createtype == "dapp") {
          this.submitBtn = "立即创建";
        }
      },

      immediate: true,
      deep: true
    },
    toumid: function toumid() {
      this.tagsFriend = [];
      this.tagsFriend.push({ id: $UMCore.uncompile("umid"), name: $UMCore.uncompile("sumname") }, { id: this.toumid, name: this.toname });
    },

    showPeople: {
      handler: function handler(newval, oldval) {
        this.candidate = newval;
      },

      deep: true
    }
  },
  methods: {
    rightList: function rightList(i, event) {
      this.showRightList = i;
    },
    rightListhide: function rightListhide() {
      this.showRightList = -1, this.status = -1;
    },
    selectOrgFun: function selectOrgFun(orgid, identitytype) {
      if (identitytype == "1") {
        this.formdapp.item = $UMCore.uncompile("umid");
      } else {
        this.formdapp.item = orgid;
      }
    },
    opencandidateFun: function opencandidateFun(type) {
      this.candidate = true;
      this.usertype = [].concat(_toConsumableArray(type));
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    getdappModule: function getdappModule() {
      var _this2 = this;

      $UMCore.post("/route.lua", {
        data: JSON.stringify({
          protocoltype: 3,
          address: {},
          operation: { prot_opercode: -13 },
          protocol: {}
        })
      }).then(function (res) {
        _this2.dappmodulelist = res.data.dappmodule;
        _this2.formdapp.dappmodule = _this2.dappmodulelist[0].sid;
        _this2.getdappstyle(_this2.formdapp.dappmodule);
      });
    },
    getdappsquare: function getdappsquare() {
      var _this3 = this;

      $UMCore.post("/route.lua", {
        data: JSON.stringify({
          modulename: "dapplist",
          functionname: "dapp_getdappsquaretype"
        })
      }).then(function (res) {
        _this3.dapptypelist = res.data.data.dappsquaretype;
        var a = JSON.parse(JSON.stringify(_this3.dapptypelist));
        a.shift();
        _this3.dapptypelist1 = a;
        _this3.formdapp.type = _this3.dapptypelist1[0].itype;
      }).catch(function (error) {});
    },
    getdappstyle: function getdappstyle(modid) {
      var _this4 = this;

      $UMCore.post("/route.lua", {
        data: JSON.stringify({
          protocoltype: 3,
          address: {},
          operation: { prot_opercode: -14 },
          protocol: {
            itype: 1,
            modid: modid
          }
        })
      }).then(function (res) {
        _this4.dappstylelist = res.data.dappstyle;
        _this4.formdapp.istyle = _this4.dappstylelist[0].sid;
      });
    },
    search1: function search1(data) {
      Object(__WEBPACK_IMPORTED_MODULE_0__map__["b" /* search */])(data);
    },
    changetab: function changetab(id) {
      this.tabactiveid = id;
      this.searchBoxshow = false;
    },
    hidenum: function hidenum(num) {
      return num.substr(0, 3) + "****" + num.substr(7);
    },
    sizeChange: function sizeChange(val, id) {
      this.squarelistFun(id, val);
    },
    sizeChange1: function sizeChange1(val, id) {
      this.squarelistFun1(id, val);
    },
    sizeChange2: function sizeChange2(val, id) {
      this.squarelistFun2(id, val);
    },
    squarelistmore: function squarelistmore(itype) {
      if (this.squarelist[itype - 1].shownum == 8 && this.squarelist[itype - 1].list.length > 8) {
        this.squarelist[itype - 1].shownum = 20;
      } else {
        this.squarelist[itype - 1].shownum = 8;
      }
    },
    squarelistmore1: function squarelistmore1(itype) {
      if (this.squarelist1[itype - 1].shownum == 8 && this.squarelist1[itype - 1].list.length > 8) {
        this.squarelist1[itype - 1].shownum = 20;
      } else {
        this.squarelist1[itype - 1].shownum = 8;
      }
    },
    squarelistmore2: function squarelistmore2(itype) {
      if (this.squarelist2[itype - 1].shownum == 8 && this.squarelist2[itype - 1].list.length > 8) {
        this.squarelist2[itype - 1].shownum = 20;
      } else {
        this.squarelist2[itype - 1].shownum = 8;
      }
    },
    squarelistFun: function squarelistFun(itype, currentpage) {
      var _this5 = this;

      var itype = itype,
          page;
      if (itype == 0) {
        page = 0;
      } else {
        this.squarelist[itype - 1].page = currentpage - 1;
        page = this.squarelist[itype - 1].page;
      }
      $UMCore.post("/route.lua", {
        data: JSON.stringify({
          functionname: "userlist_square",
          umid: $UMCore.uncompile("umid"),
          itype: itype,
          pagesize: 20,
          page: page
        })
      }).then(function (res) {
        if (itype == 0) {
          _this5.squarelist[0].list = res.data.slist.recommend;
          _this5.squarelist[1].list = res.data.slist.sfriends;
          _this5.squarelist[1].total = res.data.slist.sfriendpagesize;
          _this5.squarelist[2].list = res.data.slist.arealist;
          _this5.squarelist[2].total = res.data.slist.areapagesize;
          _this5.squarelist[4].list = res.data.slist.sjobs;
          _this5.squarelist[4].total = res.data.slist.jobpagesize;
          _this5.squarelist[3].list = res.data.slist.homelist;
          _this5.squarelist[3].total = res.data.slist.homepagesize;
          _this5.squarelist[5].list = res.data.slist.schoollist;
          _this5.squarelist[5].total = res.data.slist.schoolpagesize;
        } else if (itype == 1) {
          _this5.squarelist[1].list = res.data.slist.sfriends;
          _this5.squarelist[1].total = res.data.slist.sfriendpagesize;
        } else if (itype == 2) {
          _this5.squarelist[2].list = res.data.slist.arealist;
          _this5.squarelist[2].total = res.data.slist.areapagesize;
        } else if (itype == 3) {
          _this5.squarelist[3].list = res.data.slist.homelist;
          _this5.squarelist[3].total = res.data.slist.homepagesize;
        } else if (itype == 4) {
          _this5.squarelist[4].list = res.data.slist.sjobs;
          _this5.squarelist[4].total = res.data.slist.jobpagesize;
        } else if (itype == 5) {
          _this5.squarelist[5].list = res.data.slist.schoollist;
          _this5.squarelist[5].total = res.data.slist.schoolpagesize;
        }
      });
    },
    squarelistFun1: function squarelistFun1(itype, currentpage) {
      var _this6 = this;

      var itype = itype,
          page;
      if (itype == 0) {
        page = 0;
      } else if (itype == 1) {
        this.squarelist1[0].page = currentpage - 1;
        page = this.squarelist1[0].page;
      } else if (itype == 3) {
        this.squarelist1[2].page = currentpage - 1;
        page = this.squarelist1[2].page;
      }
      $UMCore.post("/route.lua", {
        data: JSON.stringify({
          functionname: "org_srhorg",
          modulename: "org",
          umid: $UMCore.uncompile("umid"),
          itype: 0,
          pagelimit: 20,
          page: page
        })
      }).then(function (res) {
        _this6.squarelist1[0].list = res.data.data.slist;
        _this6.squarelist1[0].total = res.data.data.total;
      });
    },
    squarelistFun2: function squarelistFun2(itype, currentpage) {
      var _this7 = this;

      var itype = itype,
          page;
      if (itype == 0) {
        page = 0;
      } else if (itype == 1) {
        this.squarelist2[0].page = currentpage - 1;
        page = this.squarelist2[0].page;
      } else if (itype == 3) {
        this.squarelist2[2].page = currentpage - 1;
        page = this.squarelist2[2].page;
      }
      $UMCore.post("/route.lua", {
        data: JSON.stringify({
          functionname: "room_srhroom",
          modulename: "room",
          umid: $UMCore.uncompile("umid"),
          itype: 0,
          pagelimit: 20,
          page: page
        })
      }).then(function (res) {
        _this7.squarelist2[0].list = res.data.data.slist;
        _this7.squarelist2[0].total = res.data.data.total;
      });
    },
    applyappid: function applyappid() {
      var _this8 = this;

      $UMCore.post("/route.lua", {
        data: JSON.stringify({
          functionname: "dapp_getappid",
          modulename: "dapplist"
        })
      }).then(function (response) {
        if (response.data.code == 0) {
          _this8.formdapp.appid = response.data.data;
        }
      }).catch(function (error) {});
    },
    upload1: function upload1() {
      $("." + this.customClass + " .chooselist .el-upload").click();
    },
    showchangeFun: function showchangeFun() {
      this.showid = false;
    },
    opencandidate: function opencandidate(type) {
      this.showPeople = true;
      this.usertype = [].concat(_toConsumableArray(type));
    },
    closecandidateFun: function closecandidateFun(f, g, o, h, d) {
      this.showPeople = false;
      this.candidate = false;
      this.tagsFriend = f;
      this.tagsGroup = g;
      this.tagsOrg = o;
      this.tagshy = h;
      this.tagsdq = d;
      this.$emit("peopleStatus", this.showPeople);
    },
    submitcandidateFun: function submitcandidateFun(f, g, o, h, d) {
      this.tagsFriend = f;
      this.tagsGroup = g;
      this.tagsOrg = o;
      this.tagshy = h;
      this.tagsdq = d;
      this.showPeople = false;
      this.candidate = false;
      this.$emit("peopleStatus", this.showPeople);
      if (this.createtype == "audiochat" || this.createtype == "videochat") {
        var arr = [];
        f.forEach(function (val) {
          if (val.id) {
            arr.push(val.id);
          }
        });
        o.forEach(function (val) {
          if (val.id) {
            arr.push(val.id);
          }
        });
        this.$emit("voiceCallUser", arr);
      }
      console.log(f, g, o);
    },
    choosecolor: function choosecolor(item, type) {
      this.selectcolor = item.id;
      if (type == "g") {
        this.groupForm.logopath = item.path;
      } else if (type == "o") {
        this.form.logopath = item.path;
      } else if (type == "d") {
        this.formdapp.imageUrl = item.path;
      }
    },
    groupImg: function groupImg(val) {
      if (this.groupupload == "") {
        this.groupupload = undefined;
      } else {
        this.groupupload = "";
      }
      this.groupForm.logopath = val;
      this.selectcolor = -1;
    },
    orgImg: function orgImg(val) {
      if (this.orgupload == "") {
        this.orgupload = undefined;
      } else {
        this.orgupload = "";
      }
      this.form.logopath = val;
      this.selectcolor = -1;
    },
    dappImg: function dappImg(val) {
      if (this.dappupload == "") {
        this.dappupload = undefined;
      } else {
        this.dappupload = "";
      }
      this.formdapp.imageUrl = val;
      this.selectcolor = -1;
    },

    /**
     * 选人组件向父组件传值
     */
    checkFun: function checkFun(data, total) {
      var index = -1;
      if (this.checkArray.length > 0) {
        this.checkArray.forEach(function (m, i) {
          if (m.id == data.id) {
            index = i;
          }
        });
        if (index != -1) {
          this.checkArray.splice(index, 1);
        } else {
          this.checkArray.push(data);
        }
      } else {
        this.checkArray.push(data);
      }
      this.total = total;
    },

    /**上传图片 */
    receiveChildSum: function receiveChildSum(src) {
      this.fileinfo = src.path;
    },
    avaname: function avaname(name) {
      return name.substr(name.length - 2, 2);
    },
    setvalue: function setvalue() {
      this.validationMsg = "我是";
    },

    /**tag表签删除 */
    handleClose: function handleClose(item, index) {
      this.tagsFriend.splice(index, 1);
    },
    selectProvince: function selectProvince(value) {
      this.address.province = value.value;
    },
    selectCity: function selectCity(value) {
      this.address.city = value.value;
    },
    selectArea: function selectArea(value) {
      this.address.area = value.value;
    },

    /**拼接地址 */
    onSelectedAddress: function onSelectedAddress(data) {
      this.actaddress = data.province.value + "-" + data.city.value + "-" + data.area.value;
    },
    receiveImgSrc: function receiveImgSrc(val) {
      this.form.companybackground = val;
    },

    /**关闭弹窗操作 */
    closenew: function closenew() {
      var that = this;
      that.setstatus = false;
      that.setad = {};
      that.addDailog = false;
      that.submitBtn = "立即创建";
      that.groupTitle = "";
      if (that.createtype == "group") {
        that.tagsFriend = [];
        that.tagsFriend.push({
          id: $UMCore.uncompile("umid"),
          name: $UMCore.uncompile("sumname")
        });
        that.groupname = "";
        that.selectcolor = 1;
        this.$refs["groupForm"].resetFields();
        that.value = 0;
      } else if (that.createtype == "org") {
        that.form.orgname = "";
        that.form.orgshortname = "";
        that.form.orghomepage = "";
        that.form.orgemial = "";
        that.form.orgdesc = "";
        that.form.orgtel = "";
        that.form.value = "1";
        that.address.province = "";
        that.form.companybackground = "";
        that.address.city = "";
        that.address.area = "";
        that.$refs["form"].resetFields();
        that.selectcolor = 1;
      } else if (that.createtype == "user") {
        that.searchBoxshow = false;
        that.searchText = that.searchUserText;
        if (that.searchText == "") {
          that.squarelistFun(0);
        } else {
          that.searchfriends();
        }
      } else if (that.createtype == "dapp" || that.createtype == "copydapp" || that.createtype == "editdapp") {
        that.resetForm("formdapp");
        that.formdapp.newtitle = "";
        that.formdapp.appinfo = "";
        that.formdapp.rangetype = "1";
        that.formdapp.rangelist = [];
        that.formdapp.identitytype = "1";
        that.formdapp.item = "";
        that.formdapp.imageUrl = "/img/default/dapp/defaultIcon1.png";
        that.getdappModule();
        that.getdappsquare();
      }
      that.$emit("closenew", that.addDailog);
    },
    confirm: function confirm() {
      this.submitImgStatus = true;
    },
    confirmhomepage: function confirmhomepage(t) {
      var _this9 = this;

      if (t == "homepage") {
        this.$emit("confirmhomepage", this.hpform);
      } else if (t == "copyhomepage") {
        if (this.hpform.curorgid == "0") {
          this.$message.error("请选择正确的组织！");
          return false;
        }
        this.hpform.mineorg.forEach(function (m, i) {
          if (m.orgid == _this9.hpform.curorgid) {
            _this9.hpform.curhomepage = m.homepage;
          }
        });
        if (this.hpform.curhomepage != "" && this.hpform.curhomepage != "nil") {
          this.$confirm("该组织已经存在主页，此操作将替换主页, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(function () {
            _this9.hpform.orgid = _this9.hpform.curorgid;
            _this9.$emit("confirmhomepage", _this9.hpform);
          }).catch(function () {
            _this9.submitStatus = true;
          });
        } else {
          this.hpform.orgid = this.hpform.curorgid;
          this.$emit("confirmhomepage", this.hpform);
        }
      }
    },
    confirmgroup: function confirmgroup(e, t) {
      var that = this;
      this.submitStatus = false;
      this.submitImgStatus = false;
      if (t == "group") {
        if (e != "") {
          this.groupForm.logopath = e.fullpath;
        }
        this.$emit("confirmgroup", this.tagsFriend, this.groupForm);
      } else if (t == "dapp" || t == "copydapp" || t == "editdapp") {
        if (e != "") {
          this.formdapp.imageUrl = e.fullpath;
        }
        if (that.formdapp.rangetype == "2") {
          that.formdapp.rangelist = [];
          for (var j = 0; j < that.tagsFriend.length; j++) {
            var tagitem = {};
            tagitem.type = 21;
            tagitem.item = that.tagsFriend[j].umid;
            tagitem.name = that.tagsFriend[j].name;
            that.formdapp.rangelist.push(tagitem);
          }
          for (var j = 0; j < that.tagsGroup.length; j++) {
            var tagitem = {};
            tagitem.type = 22;
            tagitem.item = that.tagsGroup[j].id;
            tagitem.name = that.tagsGroup[j].name;
            that.formdapp.rangelist.push(tagitem);
          }
          for (var j = 0; j < that.tagshy.length; j++) {
            var tagitem = {};
            tagitem.type = 31;
            tagitem.item = that.tagshy[j].code;
            tagitem.name = that.tagshy[j].name;
            tagitem.extid = that.tagshy[j].id;
            that.formdapp.rangelist.push(tagitem);
          }
          for (var j = 0; j < that.tagsdq.length; j++) {
            var tagitem = {};
            tagitem.type = 41;
            tagitem.item = that.tagsdq[j].code;
            tagitem.name = that.tagsdq[j].name;
            tagitem.extid = that.tagsdq[j].id;
            that.formdapp.rangelist.push(tagitem);
          }
          for (var j = 0; j < that.tagsOrg.length; j++) {
            var tagitem = {};
            if (that.tagsOrg[j].type == "2") {
              tagitem.type = 24;
            } else {
              tagitem.type = 23;
            }
            tagitem.item = that.tagsOrg[j].id;
            tagitem.name = that.tagsOrg[j].name;
            that.formdapp.rangelist.push(tagitem);
          }
        }
        this.$emit("confirmdapp", this.formdapp, t);
      }
    },
    confirmgroup1: function confirmgroup1(e, t) {
      if (e != "") {
        this.form.logopath = e.fullpath;
        this.sNum++;
        this.next = true;
      } else {
        this.next = true;
      }
      this.confirmgroup2();
    },
    confirmgroup2: function confirmgroup2() {
      this.actaddress = $("." + this.customClass + " #province option:selected").text() + "-" + $("." + this.customClass + " #city option:selected").text() + "-" + $("." + this.customClass + " #district option:selected").text();
      if (this.sNum == 1 || this.sNum == 0) {
        if (this.form.logopath == "") {
          this.$message.error("请上传组织logo！");
          this.submitStatus = true;
          this.submitImgStatus = false;
          return false;
        } else if (this.form.orgname == "" || this.form.value == "") {
          this.$message.error("请完整填写必填项！");
          this.submitStatus = true;
          this.submitImgStatus = false;
          return false;
        } else {
          this.sNum = 0;
          this.$emit("confirmorg", this.form, this.fileinfo, this.actaddress);
        }
      }
      this.next = false;
    },

    /**
     * 查找好友
     */
    searchfriends: function searchfriends() {
      var that = this;
      var data;
      if (that.searchText == "") {
        that.searchBoxshow = false;
      } else {
        if (that.tabactiveid == 0 && !that.unionStatus) {
          data = JSON.stringify({
            modulename: "friends",
            functionname: "sys_user_searchfriend",
            umid: $UMCore.uncompile("umid"),
            swhere: that.searchText,
            page: 0,
            pagesize: 20
          });
        } else if (that.tabactiveid == 1 && !that.unionStatus) {
          data = JSON.stringify({
            modulename: "org",
            functionname: "org_srhorg",
            umid: $UMCore.uncompile("umid"),
            swhere: that.searchText,
            itype: 1,
            page: 0,
            pagesize: 20
          });
        } else if (that.tabactiveid == 2 && !that.unionStatus) {
          data = JSON.stringify({
            modulename: "room",
            functionname: "room_srhroom",
            umid: $UMCore.uncompile("umid"),
            swhere: that.searchText,
            itype: 1,
            page: 0,
            pagesize: 20
          });
        } else if (that.unionStatus) {
          data = JSON.stringify({
            modulename: "org",
            functionname: "org_srhorg",
            umid: $UMCore.uncompile("umid"),
            swhere: that.searchText,
            itype: 1,
            page: 0,
            pagesize: 20,
            orgid: that.gxorgid
          });
        }
      }
      $UMCore.post("route.lua", {
        data: data
      }).then(function (res) {
        if (res.data.code == 0) {
          console.log(9898, res.data.data.slist);
          if (res.data.data.slist.length > 0) {
            that.searchBoxshow = true;
            that.searchuserlist = res.data.data.slist;
          } else {
            that.$message.error("没找到相符的信息！");
          }
        }
      }).catch(function (error) {});
    },

    /**
     * 添加好友弹窗
     */
    addfriend: function addfriend(umid, userinfo, item) {
      var that = this;
      that.$set(that.dialogInfo, "umid", umid);
      that.$set(that.dialogInfo, "item", item);
      $UMCore.post("route.lua", {
        data: JSON.stringify({
          modulename: "friends",
          functionname: "sys_user_checkfriend",
          umid: $UMCore.uncompile("umid"),
          toumid: umid
        })
      }).then(function (res) {
        if (res.data.code == 0) {
          if (res.data.data.status) {
            that.isfriend = true;
            $UMCore.msg({
              cmd: "iframe",
              op: "openiframe1",
              info: "",
              data: { title: "验证消息", width: "400px", height: "100px" }
            });
          } else {
            that.isfriend = false;
            $UMCore.msg({
              cmd: "iframe",
              op: "openiframe1",
              info: "",
              data: { title: "验证消息", width: "400px", height: "220px" }
            });
          }
          if (that.dialogInfo.umid == that.mine) {
            $UMCore.msg({
              cmd: "iframe",
              op: "openiframe1",
              info: "",
              data: { title: "验证消息", width: "400px", height: "100px" }
            });
          }
          that.showid = true;
        }
      }).catch(function (error) {
        that.$message.error("发送验证失败！请重试");
      });
    },
    applygroup: function applygroup(id) {
      var that = this;
      $UMCore.msg({
        cmd: "iframe",
        op: "openiframe1",
        info: "",
        data: {
          title: "验证消息",
          width: "400px",
          height: "220px"
        }
      });
      that.showid = true;
      that.apply_group = true;
      that.apply_org = false;
      that.applyroomid = id;
    },
    applyorg: function applyorg(id, type) {
      var that = this;
      $UMCore.msg({
        cmd: "iframe",
        op: "openiframe1",
        info: "",
        data: {
          title: "验证消息",
          width: "400px",
          height: "220px"
        }
      });
      that.showid = true;
      that.apply_org = true;
      that.apply_group = false;
      that.applyorgid = id;
      that.gxtype = type;
    },


    /**
     * 发送好友申请
     */
    sendApply: function sendApply(id) {
      var that = this,
          applyfrom = "";
      if (that.apply_group && !that.apply_org) {
        $UMCore.post("/route.lua", {
          data: JSON.stringify({
            modulename: "room",
            functionname: "room_setuserapply",
            umid: $UMCore.uncompile("umid"),
            roomid: id,
            msg: that.validationGroupMsg
          })
        }).then(function (res) {
          that.showid = false;
          that.$message({
            message: "发送请求成功！",
            type: "success",
            onClose: function onClose() {
              that.validationGroupMsg = "";
            }
          });
        });
      } else if (!that.apply_group && that.apply_org && !that.unionStatus) {
        $UMCore.post("/route.lua", {
          data: JSON.stringify({
            modulename: "org",
            functionname: "org_setuserapply",
            umid: $UMCore.uncompile("umid"),
            orgid: id,
            msg: that.validationOrgMsg
          })
        }).then(function (res) {
          that.showid = false;
          that.$message({
            message: "发送请求成功！",
            type: "success",
            onClose: function onClose() {
              that.validationOrgMsg = "";
            }
          });
        });
      } else if (!that.apply_group && that.apply_org && that.unionStatus) {
        $UMCore.post("/route.lua", {
          data: JSON.stringify({
            modulename: "org",
            functionname: "org_setorgtoorgapply",
            toorgid: id,
            orgid: that.gxorgid,
            type: that.gxtype,
            msg: that.validationOrgMsg
          })
        }).then(function (res) {
          that.showid = false;
          that.$message({
            message: "发送请求成功！",
            type: "success",
            onClose: function onClose() {
              that.validationOrgMsg = "";
              that.gxtype = 0;
            }
          });
        });
      } else {
        if (that.isphone) {
          applyfrom = "手机号码搜索";
        } else {
          applyfrom = "UMID搜索";
        }
        $UMCore.post("route.lua", {
          data: JSON.stringify({
            modulename: "friends",
            functionname: "sys_user_setfriendapply",
            umid: $UMCore.uncompile("umid"),
            toumid: id,
            msg: that.validationMsg,
            desname: that.desname,
            applyfrom: applyfrom
          })
        }).then(function (res) {
          if (res.data.code == 0) {
            that.showid = false;
            that.$message({
              message: "发送请求成功！",
              type: "success",
              onClose: function onClose() {
                that.validationMsg = "", that.desname = "";
              }
            });
          }
        }).catch(function (error) {
          that.$message.error("发送验证失败！请重试");
        });
      }
    },
    openchatroom: function openchatroom(i) {
      this.showid = false;
      $UMCore.msg({
        cmd: "header",
        op: "type1",
        info: "info",
        data: { type: "message" }
      });
      var user = {
        id: i.roomid,
        avatar: i.logopath,
        name: i.roomname,
        type: "1",
        itype: "2",
        createumid: i.createumid,
        op_type: "roommsg"
      };
      $UMCore.msg({ cmd: "umid", op: "info", info: "info", data: user });
    },


    /**
     *点击发送消息按钮打开互动聊天窗口
     */
    openchat: function openchat(item, type, info) {
      var that = this;
      that.showid = false;
      $UMCore.post("route.lua", {
        data: JSON.stringify({
          modulename: "friends",
          functionname: "sys_user_checkfriend",
          umid: $UMCore.uncompile("umid"),
          toumid: info.umid
        })
      }).then(function (res) {
        if (res.data.code == 0) {
          if (res.data.data.status) {
            that.strangermsg = 1;
          } else {
            that.strangermsg = 0;
          }
          $UMCore.msg({
            cmd: "header",
            op: "type1",
            info: "info",
            data: { type: "message" }
          });
          if (item && type) {
            that.userinfo = item;
            that.itype = type;
          }
          if (info) {
            var data = {
              userinfo: info,
              caogao: "",
              itype: that.itype,
              op_type: "msg",
              umid: info.umid,
              avatar: info.avatar,
              sumname: info.sumname,
              strangermsg: that.strangermsg
            };
          } else {
            var data = {
              userinfo: that.carduserInfo,
              usersub: that.cardusersub,
              caogao: "",
              itype: that.itype,
              op_type: "msg",
              umid: that.carduserInfo.umid,
              avatar: that.carduserInfo.avatar,
              sumname: that.carduserInfo.sumname,
              strangermsg: that.strangermsg
            };
          }
          $UMCore.msg({ cmd: "umid", op: "info", info: "info", data: data });
          that.addDailog = false;
          that.$emit("closenew", that.addDailog, "chat");
        }
      }).catch(function (error) {
        that.$message.error("发送验证失败！请重试");
      });
    },
    curHpItemCheckedChange: function curHpItemCheckedChange(index) {
      console.log("curHpItemCheckedChange" + index);
      var that = this;
      if (that.hpform.navlist[index].checked == true) {
        that.hpform.navlist[index].checked = false;
      } else {
        that.hpform.navlist[index].checked = true;
      }
    },
    editHpItem: function editHpItem(item, index) {
      this.hpform.curindex = index;
      this.hpform.edititem.caption = item.sname;
      this.hpform.edititem.itype = item.itype;
      this.hpform.edititem.url = item.surl;
      this.hpform.edititem.dappid = item.dappid;
      this.hpform.edititem.appid = item.appid;
    },
    delHpItem: function delHpItem(index) {
      this.hpform.navlist.splice(index, 1);
      this.checkSelectItem();
    },
    commitEditHpItem: function commitEditHpItem(index) {
      this.hpform.curindex = -1;
      this.hpform.navlist[index].sname = this.hpform.edititem.caption;
      this.hpform.navlist[index].itype = this.hpform.edititem.itype;
      this.hpform.navlist[index].surl = this.hpform.edititem.url;
      this.hpform.navlist[index].dappid = this.hpform.edititem.dappid;
      this.hpform.navlist[index].appid = this.hpform.edititem.appid;
    },
    checkSelectItem: function checkSelectItem() {
      this.sellist = [];
      for (var i = 0; i < this.hpform.dapplist.length; i++) {
        this.hpform.dapplist[i].checked = false;
        for (var j = 0; j < this.hpform.navlist.length; j++) {
          console.log(this.hpform.dapplist[i]);
          console.log(this.hpform.navlist[j]);
          console.log(this.hpform.dapplist[i].indexname + " - " + this.hpform.navlist[j].sname);
          if (this.hpform.dapplist[i].indexname == this.hpform.navlist[j].sname) {
            this.hpform.dapplist[i].checked = true;
            this.sellist.push(this.hpform.dapplist[i].indexname);
            break;
          }
        }
      }
      console.log("%%%%%%%%%%%%%%%%%%%%%%%");
      console.log(this.sellist);
    },
    selectHpItem: function selectHpItem(item) {
      var newItem = {};
      newItem.sname = item.indexname;
      newItem.itype = item.indextype;
      newItem.surl = item.indexid;
      newItem.dappid = item.dappid;
      newItem.appid = item.appid;
      newItem.checked = true;
      this.hpform.navlist.push(newItem);
      this.checkSelectItem();
    },
    addNewHpItem: function addNewHpItem() {
      this.hpform.showNewView = false;
      var newItem = {};
      newItem.sname = this.hpform.newitem.caption;
      newItem.itype = this.hpform.newitem.itype;
      newItem.surl = this.hpform.newitem.url;
      newItem.dappid = this.hpform.newitem.dappid;
      newItem.appid = this.hpform.newitem.appid;
      this.hpform.navlist.push(newItem);
      this.checkSelectItem();
      this.hpform.newitem.caption = "";
      this.hpform.newitem.itype = "0";
      this.hpform.newitem.url = "";
      this.hpform.newitem.dappid = "";
      this.hpform.newitem.appid = "";
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "umCandidate",
  props: ["isradio", "candidate", "usertype", "friend", "org", "group", "hy", "dq", "chooseorg", "createtype", "limit", "title", "orgname", "orgid"],
  data: function data() {
    return {
      checklist: [],
      usertypeActive: this.usertype[0],
      userlist: [],
      tagsFriend: [],
      tagsGroup: [],
      tagsOrg: [],
      tagshy: [],
      tagsdq: [],
      dtagsFriend: [],
      dtagsGroup: [],
      dtagsOrg: [],
      dtagshy: [],
      dtagsdq: [],
      breadcrumb: [],
      radioStatus: false,
      isIndeterminate: true,
      searchText: "",
      total: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.usertypeActive == 0) {
      this.changetype("0");
    } else if (this.usertypeActive == 1) {
      this.changetype("1");
    } else if (this.usertypeActive == 2) {
      this.changetype("2");
    } else if (this.usertypeActive == 3) {
      if (this.createtype == "orgadmin" || this.createtype == "orgnewadmin" || this.createtype == "orgdept" || this.createtype == "soldierinfo") {
        this.nextdept(this.orgname, this.orgid, "", 3);
      } else {
        this.changetype("3");
      }
    } else if (this.usertypeActive == 4) {} else if (this.usertypeActive == 5) {} else if (this.usertypeActive == 6) {
      if (this.createtype == "administrators") {
        this.friend.forEach(function (m) {
          if (m.id != $UMCore.uncompile("umid")) {
            _this.userlist.push(m);
          }
        });
        this.friend = [];
        this.userlist.forEach(function (m) {
          if (m.usertype == "1") {
            _this.friend.push(m);
          }
        });
      } else if (this.createtype == "estoppeluser") {
        this.friend.forEach(function (m) {
          if (m.id != $UMCore.uncompile("umid")) {
            _this.userlist.push(m);
          }
        });
        this.friend = [];
        this.userlist.forEach(function (m) {
          if (m.gagorder == 1) {
            _this.friend.push(m);
          }
        });
      } else if (this.createtype == "assignment") {
        this.friend.forEach(function (m) {
          if (m.id != $UMCore.uncompile("umid")) {
            _this.userlist.push(m);
          }
        });
        this.friend = [];
      } else {
        this.userlist = this.friend;
        this.friend = [];
      }
    } else if (this.usertypeActive == 7) {
      this.changetype("3");
    } else if (this.usertypeActive == 8) {
      this.changetype("3");
    }
    this.friend.forEach(function (m) {
      _this.checklist.push(m.id);
    });
    this.org.forEach(function (m) {
      _this.checklist.push(m.id);
    });
    this.group.forEach(function (m) {
      _this.checklist.push(m.id);
    });
    this.hy.forEach(function (m) {
      _this.checklist.push(m.id);
    });
    this.dq.forEach(function (m) {
      _this.checklist.push(m.id);
    });
    if (this.createtype != "audiochat" && this.createtype != "videochat") {
      this.dtagsFriend = [].concat(_toConsumableArray(this.friend));
      this.dtagsGroup = [].concat(_toConsumableArray(this.group));
      this.dtagsOrg = [].concat(_toConsumableArray(this.org));
      this.dtagshy = [].concat(_toConsumableArray(this.hy));
      this.dtagsdq = [].concat(_toConsumableArray(this.dq));
      this.tagsFriend = this.tagsFriend.concat(this.dtagsFriend);
      this.tagsGroup = this.tagsGroup.concat(this.dtagsGroup);
      this.tagsOrg = this.tagsOrg.concat(this.dtagsOrg);
      this.tagshy = this.tagshy.concat(this.dtagshy);
      this.tagsdq = this.tagsdq.concat(this.dtagsdq);
      if (this.createtype == "addFriend") {
        this.tagsFriend.forEach(function (m) {
          _this.friend.forEach(function (n) {
            if (m.id == n.id) {
              m.disabled = true;
            }
          });
        });
        this.compare(1);
      }
    }
  },

  methods: {
    /**
     * 搜索
     */
    candidateSearch: function candidateSearch() {
      this.nextdept(this.breadcrumb[0].name, this.breadcrumb[0].orgid, this.breadcrumb[this.breadcrumb.length - 1].deptno, 3);
    },
    next: function next(i, id, name) {
      var _this2 = this;

      if (i == "7") {
        $UMCore.post(window.zt_server + "/route.lua", {
          data: JSON.stringify({
            modulename: "industry",
            functionname: "get",
            pid: id
          })
        }).then(function (res) {
          _this2.userlist = res.data.data.slist;
          _this2.compare(i);
          var s = false;
          _this2.$nextTick(function () {
            if (_this2.breadcrumb.length > 0) {
              for (var index = 0; index < _this2.breadcrumb.length; index++) {
                if (id == _this2.breadcrumb[index].id) {
                  s = true;
                  _this2.breadcrumb = _this2.breadcrumb.slice(0, index + 1);
                  break;
                }
              }
            } else {
              _this2.breadcrumb.push({
                id: id,
                name: name
              });
            }
          });
          if (!s) {
            _this2.breadcrumb.push({
              id: id,
              name: name
            });
          }
        });
      } else if (i == "8") {
        $UMCore.post(window.zt_server + "/route.lua", {
          data: JSON.stringify({
            modulename: "area",
            functionname: "get",
            pid: id
          })
        }).then(function (res) {
          _this2.userlist = res.data.data.slist;
          _this2.compare(i);
          var s = false;
          _this2.$nextTick(function () {
            if (_this2.breadcrumb.length > 0) {
              for (var index = 0; index < _this2.breadcrumb.length; index++) {
                if (id == _this2.breadcrumb[index].id) {
                  s = true;
                  _this2.breadcrumb = _this2.breadcrumb.slice(0, index + 1);
                  break;
                }
              }
            } else {
              _this2.breadcrumb.push({
                id: id,
                name: name
              });
            }
          });
          if (!s) {
            _this2.breadcrumb.push({
              id: id,
              name: name
            });
          }
        });
      }
    },
    avaname: function avaname(name) {
      if (name != undefined) {
        return name.substr(name.length - 2, 2);
      }
    },
    checkall: function checkall(val, list) {
      if (val) {
        for (var i = 0; i < list.length; i++) {
          this.checklist.push(list[i].id);
          if (list[i].itype == "1" || list[i].type == "1" && list[i].itype == "3") {
            for (var j = 0; j < this.tagsFriend.length; j++) {
              if (list[i].id == this.tagsFriend[j].id) {
                this.tagsFriend.splice(j, 1);
                j = j - 1;
              }
            }
            this.tagsFriend.push(list[i]);
          } else if (list[i].itype == "2") {
            this.tagsGroup.push(list[i]);
          } else if (list[i].itype == "3" && list[i].type != "1") {
            this.tagsOrg.push(list[i]);
          }
        }
      } else {
        for (var i = 0; i < list.length; i++) {
          this.checklist = [];
          if (list[i].itype == "1" || list[i].type == "1" && list[i].itype == "3") {
            for (var j = 0; j < this.tagsFriend.length; j++) {
              if (list[i].id == this.tagsFriend[j].id) {
                this.tagsFriend.splice(j, 1);
                j = j - 1;
              }
            }
          } else if (list[i].itype == "2") {
            for (var j = 0; j < this.tagsGroup.length; j++) {
              if (list[i].id == this.tagsGroup[j].id) {
                this.tagsGroup.splice(j, 1);
                j = j - 1;
              }
            }
          } else if (list[i].itype == "3" && list[i].type != "1") {
            for (var j = 0; j < this.tagsOrg.length; j++) {
              if (list[i].id == this.tagsOrg[j].id) {
                this.tagsOrg.splice(j, 1);
                j = j - 1;
              }
            }
          }
        }
      }
    },
    closecandidate: function closecandidate() {
      this.$emit("closecandidate", this.dtagsFriend, this.dtagsGroup, this.dtagsOrg, this.dtagshy, this.dtagsdq);
    },
    changetype: function changetype(i) {
      var _this3 = this;

      this.usertypeActive = i;
      this.breadcrumb = [];
      if (i == "1" || i == "2" || i == "3") {
        $UMCore.post("/route.lua", {
          data: JSON.stringify({
            functionname: "userlist_get",
            itype: i,
            umid: $UMCore.uncompile("umid"),
            page: 0,
            pagesize: 10
          })
        }).then(function (res) {
          if (res.data.status) {
            _this3.userlist = res.data.slist;
            if (_this3.usertypeActive === '3') {
              _this3.total = parseInt(res.data.recordcount);
            }
            if (_this3.createtype == "addFriend") {
              _this3.userlist.forEach(function (m) {
                _this3.friend.forEach(function (n) {
                  if (m.id == n.id) {
                    m.disabled = true;
                  }
                });
              });
            }
            _this3.compare(i);
          }
        });
      } else if (i == "0") {
        $UMCore.post("/route.lua", {
          data: JSON.stringify({
            functionname: "msg_getdisuser",
            umid: $UMCore.uncompile("umid")
          })
        }).then(function (res) {
          var list = res.data.result.slice(0, 10),
              a = [];
          list.forEach(function (m) {
            if (m.type == 1) {
              a.push({
                id: m.users.umid,
                name: m.users.sumname,
                avatar: m.users.avatar,
                type: "1",
                itype: "1"
              });
            } else {
              a.push({
                id: m.roominfo.roomid,
                name: m.roominfo.roomname,
                avatar: m.roominfo.logopath,
                type: "1",
                itype: "2"
              });
            }
          });
          _this3.userlist = a;
          if (_this3.createtype == "addFriend") {
            _this3.userlist.forEach(function (m) {
              _this3.friend.forEach(function (n) {
                if (m.id == n.id) {
                  m.disabled = true;
                }
              });
            });
          }
          _this3.compare(i);
        });
      } else if (i == "7") {
        $UMCore.post(window.zt_server + "/route.lua", {
          data: JSON.stringify({
            modulename: "industry",
            functionname: "get",
            pid: 0
          })
        }).then(function (res) {
          _this3.userlist = res.data.data.slist;
          _this3.compare(i);
        });
      } else if (i == "8") {
        $UMCore.post(window.zt_server + "/route.lua", {
          data: JSON.stringify({
            modulename: "area",
            functionname: "get",
            pid: 0
          })
        }).then(function (res) {
          _this3.userlist = res.data.data.slist;
          _this3.compare(i);
        });
      }
    },
    equar: function equar(a, b) {
      // 判断数组的长度
      var c = [];
      if (a.length !== b.length) {
        a.forEach(function (m) {
          b.forEach(function (n) {
            if (m == n) {
              c.push(m);
            }
          });
        });
        if (c.length == a.length) {
          return true;
        } else {
          return false;
        }
      } else {
        // 循环遍历数组的值进行比较
        for (var i = 0; i < a.length; i++) {
          if (b.indexOf(a[i]) == -1) {
            return false;
          }
        }
        return true;
      }
    },
    compare: function compare(i) {
      var list = [],
          list1 = [];
      if (i == "1") {
        this.tagsFriend.forEach(function (m) {
          list.push(m.id);
        });
      } else if (i == "2") {
        this.tagsGroup.forEach(function (m) {
          list.push(m.id);
        });
      } else if (i == "3") {
        this.tagsOrg.forEach(function (m) {
          list.push(m.id);
        });
        this.tagsFriend.forEach(function (m) {
          list.push(m.id);
        });
      } else if (i == "7") {
        this.tagshy.forEach(function (m) {
          list.push(m.id);
        });
      } else if (i == "8") {
        this.tagsdq.forEach(function (m) {
          list.push(m.id);
        });
      }

      this.userlist.forEach(function (m) {
        list1.push(m.id);
      });
      this.checklist = list;
      if (this.equar(list1, list) && this.checklist.length != 0) {
        this.radioStatus = true;
      } else {
        this.radioStatus = false;
      }
    },
    closeTag: function closeTag(type, index, tag) {
      var _this4 = this;

      if (type == 1) {
        this.tagsFriend.splice(index, 1);
      } else if (type == 2) {
        this.tagsGroup.splice(index, 1);
      } else if (type == 3) {
        this.tagsOrg.splice(index, 1);
      } else if (type == 7) {
        this.tagshy.splice(index, 1);
      } else if (type == 8) {
        this.tagsdq.splice(index, 1);
      }
      this.checklist.forEach(function (m, i) {
        if (m == tag.id) {
          _this4.checklist.splice(i, 1);
        }
      });
      this.compare(type);
    },
    checkChange: function checkChange(val, m) {
      var _this5 = this;

      if (val) {
        if (m.itype == "1" || m.itype == "3" && m.type == "1") {
          if (this.isradio) {
            if (this.tagsFriend.length == 0 && this.tagsGroup.length == 0) {
              this.tagsFriend.push(m);
            } else {
              this.$message.error("仅支持单选！");
            }
          } else {
            this.tagsFriend.push(m);
          }
        } else if (m.itype == "2") {
          if (this.isradio) {
            if (this.tagsFriend.length == 0 && this.tagsGroup.length == 0) {
              this.tagsGroup.push(m);
            } else {
              this.$message.error("消息转发仅支持单一对象！");
            }
          } else {
            this.tagsGroup.push(m);
          }
        } else if (m.itype == "3") {
          this.tagsOrg.push(m);
        } else if (this.usertypeActive == "7") {
          this.tagshy.push(m);
        } else if (this.usertypeActive == "8") {
          this.tagsdq.push(m);
        }
      } else {
        if (m.itype == "1" || m.itype == "3" && m.type == "1") {
          this.tagsFriend.forEach(function (e, i) {
            if (m.id == e.id) {
              _this5.tagsFriend.splice(i, 1);
            }
          });
        } else if (m.itype == "2") {
          this.tagsGroup.forEach(function (e, i) {
            if (m.id == e.id) {
              _this5.tagsGroup.splice(i, 1);
            }
          });
        } else if (m.itype == "3") {
          this.tagsOrg.forEach(function (e, i) {
            if (m.id == e.id) {
              _this5.tagsOrg.splice(i, 1);
            }
          });
        } else if (this.usertypeActive == "7") {
          this.tagshy.forEach(function (e, i) {
            if (m.id == e.id) {
              _this5.tagshy.splice(i, 1);
            }
          });
        } else if (this.usertypeActive == "8") {
          this.tagsdq.forEach(function (e, i) {
            if (m.id == e.id) {
              _this5.tagsdq.splice(i, 1);
            }
          });
        }
      }
      if (this.usertypeActive == "7" || this.usertypeActive == "8") {
        this.compare(this.usertypeActive);
      } else {
        this.compare(m.itype);
      }
    },
    currentChange: function currentChange(val) {
      var _this6 = this;

      $UMCore.post("/route.lua", {
        data: JSON.stringify({
          functionname: 'userlist_get',
          itype: '3',
          umid: $UMCore.uncompile("umid"),
          orgid: this.breadcrumb[0].orgid,
          deptno: this.breadcrumb[this.breadcrumb.length - 1].deptno,
          swhere: this.searchText,
          page: val - 1,
          pagesize: 10
        })
      }).then(function (res) {
        if (res.data.status) {
          _this6.userlist = res.data.slist;
          if (_this6.usertypeActive === '3') {
            _this6.total = parseInt(res.data.recordcount);
          }
        }
      });
    },
    nextdept: function nextdept(name, orgid, deptno, type) {
      var _this7 = this;

      $UMCore.post("/route.lua", {
        data: JSON.stringify({
          functionname: "userlist_get",
          itype: "3",
          umid: $UMCore.uncompile("umid"),
          orgid: orgid,
          deptno: deptno,
          swhere: this.searchText,
          page: 0,
          pagesize: 10
        })
      }).then(function (res) {
        if (res.data.status) {
          _this7.userlist = res.data.slist;
          if (_this7.usertypeActive === '3') {
            _this7.total = parseInt(res.data.recordcount);
          }
          var s = false;
          _this7.$nextTick(function () {
            if (_this7.breadcrumb.length > 0) {
              for (var index = 0; index < _this7.breadcrumb.length; index++) {
                if (deptno == _this7.breadcrumb[index].deptno) {
                  s = true;
                  _this7.breadcrumb = _this7.breadcrumb.slice(0, index + 1);
                  break;
                }
              }
            } else {
              _this7.breadcrumb.push({
                name: name,
                orgid: orgid,
                deptno: deptno,
                type: type
              });
            }
          });
          if (!s) {
            _this7.breadcrumb.push({
              name: name,
              orgid: orgid,
              deptno: deptno,
              type: type
            });
          }
        }
      });
    },
    submitcandidate: function submitcandidate() {
      this.$emit("submitcandidate", this.tagsFriend, this.tagsGroup, this.tagsOrg, this.tagshy, this.tagsdq);
    }
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import lrz from "lrz";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "UmSimg",
  data: function data() {
    return {
      imageUrl: "",
      avatarname: [],
      fileList: []
    };
  },
  mounted: function mounted() {
    this.imageUrl = this.uploadlogo;
  },

  props: ["uploadlogo", "submitStatus"],
  watch: {
    uploadlogo: function uploadlogo(val) {
      this.imageUrl = val;
    },

    submitStatus: {
      handler: function handler(newval, oldval) {
        var _this = this;

        if (newval) {
          if (this.fileList.length > 0) {
            var formData = new FormData(); //  用FormData存放上传文件
            this.fileList.forEach(function (file, index) {
              formData.append("filename" + index, file.raw); //此处一定是append file.raw 上传文件只需维护fileList file.raw.name要加上
            });
            $UMCore.post(window.fileurl, formData).then(function (res) {
              _this.fileList = [];
              _this.$emit("submit-file", res.data[0]);
            }).catch(function (error) {
              _this.$message.error("上传失败！");
              return false;
            });
          } else {
            this.fileList = [];
            this.$emit("submit-file", "");
          }
        }
      },

      immediate: true,
      deep: true
    }
  },
  methods: {
    onChange: function onChange(file, fileList) {
      var _this2 = this;

      //这里做一些文件控制，注意：就算一次选取多个文件，这里依旧会执行多次
      // this.fileList = fileList;
      lrz(file.raw).then(function (rst) {
        // 处理成功会执行
        file.raw = _this2.dataURLtoFile(rst.base64, file.raw.name);
        if (file.size / 1024 / 1024 > 50) {
          _this2.$message.error("文件上传不能超过50M!");
        } else {
          _this2.imageUrl = URL.createObjectURL(file.raw);
          _this2.fileList = [];
          _this2.fileList.push(file);
          _this2.$emit("getImgSrc", _this2.imageUrl);
        }
      }).catch(function (err) {
        // this.fileList.push(file);
        _this2.$message.error("目前仅支持jpg,png,gif,jpeg格式!");
        // 处理失败会执行
      }).always(function () {
        // 不管是成功失败，都会执行
      });
    },
    dataURLtoFile: function dataURLtoFile(dataurl, filename) {
      //将base64转换为文件
      var arr = dataurl.split(",");
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      //转换成file对象
      return new File([u8arr], filename, { type: mime });
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.avatarname.push(res[0].filename);
      this.$emit("getImgSrc", res[0]);
    },
    error: function error(res) {
      this.$message.error("文件上传失败");
      this.$emit("getImgSrc", "");
    },
    remove: function remove() {
      this.$emit("getImgSrc", "");
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/gif";
      var isLt2M = file.size / 1024 / 1024 < 20;

      if (!isJPG) {
        this.$message.error("目前仅支持jpg,png,gif格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 20MB!");
      }
      return isJPG && isLt2M;
    }
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Alphabetical_sort_js__ = __webpack_require__(91);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "umMselector",
  props: {
    usertype: {
      type: String,
      default: ""
    },
    createtype: {
      type: String,
      default: ""
    },
    limit: {
      type: Number,
      default: -1
    },
    friend: {
      type: Array,
      default: []
    },
    roomuser: {
      type: Array,
      default: []
    },
    group: {
      type: Array,
      default: []
    },
    org: {
      type: Array,
      default: []
    },
    hy: {
      type: Array,
      default: []
    },
    dq: {
      type: Array,
      default: []
    },
    ban_org: {
      // 用于屏蔽掉群、组织、部门，但是保留组织中的人
      type: Boolean,
      default: false
    },
    showRecentGroup: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      result: [],
      slist: [],
      recentIdArr: [],
      status: true,
      friend_status: true,
      group_status: true,
      org_status: true,
      hy_status: true,
      dq_status: true,
      letters: [],
      friend_list: [],
      group_list: [],
      org_list: [],
      hy_list: [],
      dq_list: [],
      breadArr: [],
      orgmember: [],
      orgRoot: true,
      hyRoot: true,
      dqRoot: true,
      orgid: "",
      branchId: "",
      detailArr: [],
      peopleTotal: 0,
      groupTotal: 0,
      orgTotal: 0,
      branchTotal: 0,
      dqTotal: 0,
      hyTotal: 0,
      allTotal: 0,
      choosedStatus: true,
      choosedList: [],
      peopleList: [],
      groupList: [],
      orgList: [],
      hyList: [],
      dqList: [],
      branchList: [],
      clickFriend: true,
      clickGroup: true,
      clickOrg: true,
      clickhy: true,
      clickdq: true,
      openType: this.usertype,
      choosedPeople: [],
      choosedRoomuser: [],
      choosedGroup: [],
      choosedOrg: [],
      choosedhy: [],
      chooseddq: [],
      choosedBranch: [],
      trueBtnStatus: false,
      strChineseFirstPY: __WEBPACK_IMPORTED_MODULE_0__Alphabetical_sort_js__["a" /* default */].strChineseFirstPY(),
      oMultiDiff: __WEBPACK_IMPORTED_MODULE_0__Alphabetical_sort_js__["a" /* default */].oMultiDiff(),
      peopleStatus: false,
      branchStatus: false
    };
  },
  created: function created() {
    this.getRecent();
  },

  watch: {
    peopleList: function peopleList(val, oldval) {
      this.peopleTotal = val.length;
    },
    groupList: function groupList(val, oldval) {
      this.groupTotal = val.length;
    },
    orgList: function orgList(val, oldval) {
      this.orgTotal = val.length;
    },
    branchList: function branchList(val, oldval) {
      this.branchTotal = val.length;
    },
    dqList: function dqList(val, oldval) {
      this.dqTotal = val.length;
    },
    hyList: function hyList(val, oldval) {
      this.hyTotal = val.length;
    }
  },
  mounted: function mounted() {
    var that = this;
    window.goBack = that.goBack;
    if (that.openType == "people") {
      that.getMyFriend();
    } else if (that.openType == "group") {
      that.getMyGroup();
    } else if (that.openType == "org") {
      that.getMyOrg();
    } else if (that.openType == "roomuser") {
      that.status = false;
      that.friend_status = false;
      that.friend_list = that.roomuser;
      that.peopleList = [];
      var obj = {};
      var arr = [];
      var arr1 = [];
      that.friend_list.forEach(function (value, index, array) {
        value.avatar = value.userinfo.avatar;
        value.capitalize = that.makePy(value.name)[0].toUpperCase().substr(0, 1);
        var reg = /^[A-Z]+$/;
        if (!value.capitalize.match(reg)) {
          value.capitalize = "#";
        }
        if (!obj[value.capitalize]) {
          obj[value.capitalize] = true;
          arr.push(value.capitalize);
        }
        if (that.createtype == 'administrators') {
          if (value.usertype == '1') {
            arr1.push(value);
            that.peopleList.push(parseInt(value.umid));
          }
        } else if (that.createtype == 'assignment') {
          if (value.usertype == '0') {
            arr1.push(value);
            that.peopleList.push(parseInt(value.umid));
          }
        }
      });
      //字母列表排序
      that.letters = arr.sort();
      that.choosedRoomuser = arr1;
    }
    that.friend.forEach(function (item) {
      if (item.unit) {
        that.result.push(parseInt(item.unit.unitId));
        that.peopleList.push(parseInt(item.unit.unitId));
      } else if (item.umid) {
        that.result.push(parseInt(item.umid));
        that.peopleList.push(parseInt(item.umid));
      }
    });
    that.group.forEach(function (item) {
      if (item.unit) {
        that.result.push(item.unit.unitId);
        that.groupList.push(item.unit.unitId);
      } else {
        that.result.push(item.id);
        that.groupList.push(item.id);
      }
    });
    that.dq.forEach(function (item) {
      that.result.push(item.id);
      that.dqList.push(item.id);
    });
    that.hy.forEach(function (item) {
      that.result.push(item.id);
      that.hyList.push(item.id);
    });
    that.org.forEach(function (item) {
      if (item.itype == "3" && item.type == "2") {
        that.branchList.push(parseInt(item.id));
        that.choosedBranch.push(item);
      } else if (item.itype == "3" && item.type == "3") {
        that.orgList.push(parseInt(item.id));
        that.choosedOrg.push(item);
      }
    });
    that.choosedPeople = that.friend;
    that.choosedGroup = that.group;
    that.chooseddq = that.dq;
    that.choosedhy = that.hy;
    if (window.localStorage.getItem("trueBtn") == 1) {
      that.trueBtnStatus = true;
    }
  },
  updated: function updated() {
    this.allTotal = this.peopleTotal + this.groupTotal + this.orgTotal + this.branchTotal + this.dqTotal + this.hyTotal;
  },

  methods: {
    chooseCheck: function chooseCheck(val, item) {
      var _this = this;

      var that = this;
      if (val) {
        if (item.itype == "1" || item.itype == "3" && item.type == "1") {
          this.choosedPeople.push(item);
          that.result.push(parseInt(item.umid));
        } else if (item.itype == "2") {
          this.choosedGroup.push(item);
          this.result.push(item.id);
        } else if (item.itype == "3" && item.type === "3") {
          this.choosedOrg.push(item);
        } else if (item.itype == "3" && item.type === "2") {
          this.choosedBranch.push(item);
        } else if (!that.dq_status) {
          item.itype = "5";
          this.chooseddq.push(item);
        } else if (!that.hy_status) {
          item.itype = "6";
          this.choosedhy.push(item);
        } else {
          this.choosedRoomuser.push(item);
        }
      } else {
        if (item.itype == "1" || item.itype == "3" && item.type == "1") {
          this.choosedPeople.forEach(function (m, i) {
            if (item.id == m.id) {
              _this.choosedPeople.splice(i, 1);
            }
          });
          this.result.forEach(function (m, i) {
            if (m == item.umid) {
              _this.result.splice(i, 1);
            }
          });
        } else if (item.itype == "2") {
          this.choosedGroup.forEach(function (m, i) {
            if (item.id == m.id) {
              _this.choosedGroup.splice(i, 1);
            }
          });
          this.result.forEach(function (m, i) {
            if (m == item.id) {
              _this.result.splice(i, 1);
            }
          });
        } else if (item.itype == "3" && item.type === "3") {
          this.choosedOrg.forEach(function (m, i) {
            if (item.id == m.id) {
              _this.choosedOrg.splice(i, 1);
            }
          });
        } else if (item.itype == "3" && item.type === "2") {
          this.choosedBranch.forEach(function (m, i) {
            if (item.id == m.id) {
              _this.choosedBranch.splice(i, 1);
            }
          });
        } else if (!that.dq_status) {
          this.chooseddq.forEach(function (m, i) {
            if (item.id == m.id) {
              _this.chooseddq.splice(i, 1);
            }
          });
        } else if (!that.hy_status) {
          this.choosedhy.forEach(function (m, i) {
            if (item.id == m.id) {
              _this.choosedhy.splice(i, 1);
            }
          });
        } else {
          this.choosedRoomuser.forEach(function (m, i) {
            if (item.umid == m.umid) {
              _this.choosedRoomuser.splice(i, 1);
            }
          });
        }
      }
    },
    recentChange: function recentChange(val, item) {
      var that = this;
      if (val) {
        if (item.type == 1) {
          this.peopleList.push(parseInt(item.users.umid));
          this.choosedPeople.push(item);
        } else if (item.type == 2) {
          this.groupList.push(item.roominfo.roomid);
          this.choosedGroup.push(item);
        }
      } else {
        if (item.type == 1) {
          for (var i = 0; i < that.peopleList.length; i++) {
            if (item.users.umid == that.peopleList[i]) {
              that.peopleList.splice(i, 1);
              that.choosedPeople.splice(i, 1);
            }
          }
        } else if (item.type == 2) {
          for (var _i = 0; _i < that.groupList.length; _i++) {
            if (item.roominfo.roomid == that.groupList[_i]) {
              that.groupList.splice(_i, 1);
              that.choosedGroup.splice(_i, 1);
            }
          }
        }
      }
    },
    goBack1: function goBack1() {
      this.choosedStatus = true;
    },
    removeThis: function removeThis(val, index, type) {
      var that = this;
      console.log(val.itype, val.type, type);
      if (val.itype == "1" || val.type === 1) {
        that.peopleList.splice(index, 1);
        that.choosedPeople.splice(index, 1);
        if (val.unit) {
          that.result.splice(index, 1);
        }
      } else if (val.itype == "2" || val.type === 2) {
        that.groupList.splice(index, 1);
        that.choosedGroup.splice(index, 1);
        if (val.unit) {
          that.result.splice(index, 1);
        }
      } else if (val.itype == "3" && val.type === "3") {
        that.orgList.splice(index, 1);
        that.choosedOrg.splice(index, 1);
      } else if (val.itype == "3" && val.type === "2") {
        that.branchList.splice(index, 1);
        that.choosedBranch.splice(index, 1);
      } else if (type == 1) {
        that.dqList.splice(index, 1);
        that.chooseddq.splice(index, 1);
      } else if (type == 0) {
        that.hyList.splice(index, 1);
        that.choosedhy.splice(index, 1);
      } else if (type == 3) {
        that.peopleList.splice(index, 1);
        that.choosedRoomuser.splice(index, 1);
      }
    },
    removeAll: function removeAll(type) {
      var that = this;
      if (type == 1) {
        this.peopleList = [];
        this.choosedPeople = [];
        this.result = [];
      } else if (type == 2) {
        this.groupList = [];
        this.choosedGroup = [];
        this.result = [];
      } else if (type == 3) {
        this.orgList = [];
        this.choosedOrg = [];
      } else if (type == 4) {
        this.branchList = [];
        this.choosedBranch = [];
      } else if (type == 5) {
        this.hyList = [];
        this.choosedhy = [];
      } else if (type == 6) {
        this.dqList = [];
        this.chooseddq = [];
      }
    },
    goBack: function goBack() {
      if (window.localStorage.getItem("msgToCre") == 1) {
        $(".hudong").show();
        $(".tongxunlu").hide();
        $UMCore.msg({
          cmd: "restart",
          op: "restartTabbar",
          data: { type: "tongxunlu" }
        });
        $UMCore.msg({
          cmd: "showTabbar",
          op: "isShowTabbar",
          data: { show: true }
        });
      } else if (window.localStorage.getItem("mcreGroupType") == 1) {
        $UMCore.msg({
          cmd: "restart",
          op: "restartTabbar",
          data: { type: "tongxunlu" }
        });
        $UMCore.msg({
          cmd: "showTabbar",
          op: "isShowTabbar",
          data: { show: true }
        });
      } else if (window.localStorage.getItem("listToCre") == 1) {
        $UMCore.msg({ cmd: "toGroupList", op: "isShowGroupList" });
      }
      this.$emit("closeSelector");
      this.$emit("createQrcode");
      window.localStorage.removeItem("msgToCre");
      window.localStorage.removeItem("mcreGroupType");
      window.localStorage.removeItem("trueBtn");
      window.localStorage.removeItem("listToCre");
    },
    submit: function submit() {
      if (window.localStorage.getItem("trueBtn") == 1) {
        $UMCore.compile("chooseDetail", JSON.stringify(this.choosedPeople));
        $UMCore.msg({ cmd: "toGroupChat", op: "showGroupChat" });
      } else {
        // id混合数组
        var arr = this.peopleList.concat(this.groupList);
        var newArr = arr.concat(this.orgList);
        var newArr1 = newArr.concat(this.hyList);
        var newArr2 = newArr1.concat(this.dqList);
        var new_arr = newArr2.concat(this.branchList);

        //item组合成的数组
        var itemArr = this.choosedPeople.concat(this.choosedGroup);
        var newItemArr = itemArr.concat(this.choosedOrg);
        var newItemArr3 = newItemArr.concat(this.choosedRoomuser);
        var newItemArr1 = newItemArr3.concat(this.chooseddq);
        var newItemArr2 = newItemArr1.concat(this.choosedhy);
        var new_item_arr = newItemArr2.concat(this.choosedBranch);
        this.goBack();
      }
      this.$emit("choosedId", new_arr);
      this.$emit("choosedItem", new_item_arr);
    },

    // 最近联系人
    getRecent: function getRecent() {
      var that = this;
      var recentId = [];
      var recentType = [];
      $UMCore.post("route.lua", {
        data: JSON.stringify({
          functionname: "msg_getdisuser",
          umid: $UMCore.uncompile("umid")
        })
      }).then(function (response) {
        if (response.data.status) {
          that.slist = response.data.result.slice(0, 10);
          that.slist.forEach(function (val, index) {
            if (val.type == 1 && val.users.umid == $UMCore.uncompile("umid")) {
              that.slist.splice(index, 1);
            }
          });
          for (var i = 0; i < that.slist.length; i++) {
            if (that.slist[i].type == 1) {
              recentId.push(that.slist[i].users.umid);
              recentType.push(that.slist[i].type);
            } else if (that.slist[i].type == 2) {
              recentId.push(that.slist[i].roominfo.roomid);
              recentType.push(that.slist[i].type);
            }
          }
          for (var _i2 = 0; _i2 < recentId.length; _i2++) {
            var obj = {};
            obj.unitId = recentId[_i2];
            obj.type = recentType[_i2];
            that.slist[_i2].unit = obj;
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    changeStatus: function changeStatus() {
      this.status = true;
      this.friend_status = true;
      this.group_status = true;
      this.org_status = true;
      this.hy_status = true;
      this.dq_status = true;
      this.breadArr = [];
      this.branchId = "";
      this.org_list = [];
      this.orgmember = [];
    },

    /**
      获取我的好友
     */
    getMyFriend: function getMyFriend() {
      var that = this;
      var obj = {};
      obj.name = "我的好友";
      that.breadArr.push(obj);
      that.status = false;
      that.friend_status = false;
      var umid = $UMCore.uncompile("umid");
      if (that.clickFriend) {
        $UMCore.post("route.lua", {
          data: JSON.stringify({
            functionname: "userlist_get",
            itype: 1,
            umid: umid
          })
        }).then(function (res) {
          if (res.data.result === 0) {
            that.friend_list = res.data.slist;
            that.clickFriend = false;
            var _obj = {};
            var arr = [];
            that.friend_list.forEach(function (value, index, array) {
              value.capitalize = that.makePy(value.name)[0].toUpperCase().substr(0, 1);
              var reg = /^[A-Z]+$/;
              if (!value.capitalize.match(reg)) {
                value.capitalize = "#";
              }
              if (!_obj[value.capitalize]) {
                _obj[value.capitalize] = true;
                arr.push(value.capitalize);
              }
            });
            //字母列表排序
            that.letters = arr.sort();
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    makePy: function makePy(str) {
      if (typeof str != "string") throw new Error(-1, "函数makePy需要字符串类型参数!");
      var arrResult = new Array(); //保存中间结果的数组
      for (var i = 0, len = str.length; i < len; i++) {
        //获得unicode码
        var ch = str.charAt(i);
        //检查该unicode码是否在处理范围之内,在则返回该码对映汉字的拼音首字母,不在则调用其它函数处理
        arrResult.push(this.checkCh(ch));
      }
      //处理arrResult,返回所有可能的拼音首字母串数组
      return this.mkRslt(arrResult);
    },
    checkCh: function checkCh(ch) {
      var uni = ch.charCodeAt(0);
      //如果不在汉字处理范围之内,返回原字符,也可以调用自己的处理函数
      if (uni > 40869 || uni < 19968) return ch; //dealWithOthers(ch);
      //检查是否是多音字,是按多音字处理,不是就直接在this.strChineseFirstPY字符串中找对应的首字母
      return this.oMultiDiff[uni] ? this.oMultiDiff[uni] : this.strChineseFirstPY.charAt(uni - 19968);
    },
    mkRslt: function mkRslt(arr) {
      var arrRslt = [""];
      for (var i = 0, len = arr.length; i < len; i++) {
        var str = arr[i];
        var strlen = str.length;
        if (strlen == 1) {
          for (var k = 0; k < arrRslt.length; k++) {
            arrRslt[k] += str;
          }
        } else {
          var tmpArr = arrRslt.slice(0);
          arrRslt = [];
          for (var _k = 0; _k < strlen; _k++) {
            //复制一个相同的arrRslt
            var tmp = tmpArr.slice(0);
            //把当前字符str[k]添加到每个元素末尾
            for (var j = 0; j < tmp.length; j++) {
              tmp[j] += str.charAt(_k);
            }
            //把复制并修改后的数组连接到arrRslt上
            arrRslt = arrRslt.concat(tmp);
          }
        }
      }
      return arrRslt;
    },
    getMyGroup: function getMyGroup() {
      var that = this;
      var obj = {};
      obj.name = "我的群组";
      that.breadArr.push(obj);
      that.status = false;
      that.group_status = false;
      if (that.clickGroup) {
        $UMCore.post("route.lua", {
          data: JSON.stringify({
            functionname: "userlist_get",
            itype: 2,
            umid: $UMCore.uncompile("umid")
          })
        }).then(function (res) {
          that.group_list = res.data.slist;
          that.clickGroup = false;
        }).catch(function (error) {
          console.log(error);
        });
      }
    },

    // 面包屑任意一级
    goSon: function goSon(e, item) {
      var that = this;
      for (var i = 0; i < that.breadArr.length; i++) {
        if (item.id == that.breadArr[i].id) {
          that.breadArr.splice(i + 1);
        }
      }
      if (item.type != undefined) {
        var umid = $UMCore.uncompile("umid");
        var orgid = item.orgid;
        var deptno = item.deptno;
        $UMCore.post("route.lua", {
          data: JSON.stringify({
            functionname: "userlist_get",
            itype: 3,
            umid: umid,
            orgid: orgid,
            deptno: deptno
          })
        }).then(function (res) {
          if (res.data.status) {
            that.orgmember = res.data.slist;
            that.orgmember.forEach(function (val, index) {
              if (val.type == "1") {
                that.peopleStatus = true;
              } else if (val.type == "2") {
                that.branchStatus = true;
              }
            });
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        that.getMyOrg(1);
      }
    },

    // 面包屑任意一级
    godqSon: function godqSon(e, item) {
      var that = this;

      if (item.id == 0) {
        that.getdq();
      } else {
        var _e = {
          id: item.id,
          name: item.name
        };
        that.getBranchdq(_e);
      }
      for (var i = 0; i < that.breadArr.length; i++) {
        if (item.id == that.breadArr[i].id) {
          that.breadArr.splice(i + 1);
        }
      }
    },

    // 面包屑任意一级
    gohySon: function gohySon(e, item) {
      var that = this;

      if (item.id == 0) {
        that.gethy();
      } else {
        var _e2 = {
          id: item.id,
          name: item.name
        };
        that.getBranchhy(_e2);
      }
      for (var i = 0; i < that.breadArr.length; i++) {
        if (item.id == that.breadArr[i].id) {
          that.breadArr.splice(i + 1);
        }
      }
    },

    // 获取组织
    getMyOrg: function getMyOrg() {
      var inData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var that = this;
      if (inData == null) {
        var obj = {};
        obj.name = "我的组织";
        that.breadArr.push(obj);
      }
      that.status = false;
      that.org_status = false;
      that.orgRoot = true;
      that.orgmember = [];
      var umid = $UMCore.uncompile("umid");
      if (that.clickOrg) {
        $UMCore.post("route.lua", {
          data: JSON.stringify({
            functionname: "userlist_get",
            umid: umid,
            itype: 3
          })
        }).then(function (res) {
          if (res.data.result === 0) {
            that.org_list = res.data.slist;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },

    // 获取地区
    getdq: function getdq() {
      var _this2 = this;

      var inData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var that = this;
      if (inData == null) {
        var obj = {};
        obj.name = "地区";
        that.breadArr.push(obj);
      }
      that.status = false;
      that.dq_status = false;
      that.dqRoot = true;
      that.dqmember = [];
      var umid = $UMCore.uncompile("umid");
      if (that.clickdq) {
        $UMCore.post(window.zt_server + "/route.lua", {
          data: JSON.stringify({
            modulename: "area",
            functionname: "get",
            pid: 0
          })
        }).then(function (res) {
          _this2.dq_list = res.data.data.slist;
        });
        // $UMCore.post('route.lua', {
        //   data:JSON.stringify({
        //     functionname: 'userlist_get',
        //     umid: umid,
        //     itype: 3
        //   })
        // })
        // .then(function(res){
        //   if (res.data.result === 0) {
        //     that.org_list = res.data.slist
        //   }
        // })
        // .catch(function (error) {
        //   console.log(error)
        // })
      }
    },

    // 获取行业
    gethy: function gethy() {
      var _this3 = this;

      var inData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var that = this;
      if (inData == null) {
        var obj = {};
        obj.name = "行业";
        that.breadArr.push(obj);
      }
      that.status = false;
      that.hy_status = false;
      that.hyRoot = true;
      that.hymember = [];
      var umid = $UMCore.uncompile("umid");
      if (that.clickhy) {
        $UMCore.post(window.zt_server + "/route.lua", {
          data: JSON.stringify({
            modulename: "industry",
            functionname: "get",
            pid: 0
          })
        }).then(function (res) {
          _this3.hy_list = res.data.data.slist;
        });
      }
    },
    getBranch: function getBranch(e) {
      var that = this;
      this.orgRoot = false;
      this.orgid = e.orgid;
      this.breadArr.push(e);
      var umid = $UMCore.uncompile("umid");
      // type值为1的时候  不在继续请求
      if (e.type !== "1") {
        that.branchId = e.deptno;
        $UMCore.post("route.lua", {
          data: JSON.stringify({
            functionname: "userlist_get",
            itype: 3,
            umid: umid,
            orgid: that.orgid,
            deptno: that.branchId
          })
        }).then(function (res) {
          if (res.data.status) {
            that.orgmember = res.data.slist;
            if (that.orgmember.length == 0) {
              that.peopleStatus = false;
              that.branchStatus = false;
            } else {
              that.orgmember.forEach(function (val, index) {
                if (val.type == "1") {
                  that.peopleStatus = true;
                } else if (val.type == "2") {
                  that.branchStatus = true;
                }
              });
            }
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    getBranchhy: function getBranchhy(e) {
      var that = this;
      this.hyRoot = false;
      this.breadArr.push(e);
      var umid = $UMCore.uncompile("umid");
      // type值为1的时候  不在继续请求
      $UMCore.post(window.zt_server + "/route.lua", {
        data: JSON.stringify({
          modulename: "industry",
          functionname: "get",
          pid: e.id
        })
      }).then(function (res) {
        that.hymember = res.data.data.slist;
        that.$forceUpdate();
      });
    },
    getBranchdq: function getBranchdq(e) {
      var that = this;
      this.dqRoot = false;
      this.breadArr.push(e);
      var umid = $UMCore.uncompile("umid");
      // type值为1的时候  不在继续请求
      $UMCore.post(window.zt_server + "/route.lua", {
        data: JSON.stringify({
          modulename: "area",
          functionname: "get",
          pid: e.id
        })
      }).then(function (res) {
        that.dqmember = res.data.data.slist;
        that.$forceUpdate();
      });
    },
    toChoosedPeople: function toChoosedPeople() {
      this.choosedStatus = false;
    }
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "UmZan",
  data: function data() {
    return {
      reviewtype: 0,
      umid: '',
      // minezan: 0,
      // praisecount: 0,
      edittype: 0
    };
  },

  props: ["sid", "appid", "minezan", "praisecount"],
  mounted: function mounted() {
    var that = this;
    that.umid = $UMCore.uncompile("umid");
    var waitReady = function waitReady() {
      if (that.sid != '' && that.sid != undefined) {
        if ($UMCore.uncompile('token') != null) {
          var opt = localStorage.getItem("newsoperate");
          if (opt == 1) {
            that.praise();
          }
        }
        localStorage.removeItem("newsoperate");
      } else {
        setTimeout(function () {
          waitReady();
        }, 20);
      }
    };
    setTimeout(function () {
      waitReady();
    }, 50);
  },

  methods: {
    /**
     * 获取新闻相关内容（详情，评论）
     */
    api: function api() {
      var that = this;
      $UMCore.post("/route.lua", {
        data: JSON.stringify({
          functionname: "comments_set",
          dappid: that.appid,
          edittype: that.edittype,
          dappuuid: that.sid,
          itype: that.reviewtype,
          stext: "",
          umid: that.umid,
          parentid: ""
        })
      }).then(function (response) {
        if (response.data.status) {
          that.usercomments = '';
        } else {
          that.$message({ message: '失败', type: 'error', customClass: 'popupMessage' });
        }
      }).catch(function (error) {
        console.log(error);
        that.$message.error("网络错误！");
        return false;
      });
    },

    /**
     * 新闻详情的点赞切换
     */
    praise: function praise() {
      if ($UMCore.uncompile('token') == null) {
        localStorage.setItem("newsoperate", 1);
        this.$emit('unlogin', '');
        // this.openloginview()
      } else {
        if (this.minezan == '0') {
          this.praisecount = parseInt(this.praisecount) + 1;
          this.minezan = '1';
          this.reviewtype = '0';
          this.api();
        } else {
          this.praisecount = parseInt(this.praisecount) - 1;
          this.minezan = '0';
          this.reviewtype = '0';
          this.api();
        }
      }
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "UmReadcount",
  data: function data() {
    return {
      readcount: 0
    };
  },

  props: ["sid", "appid"],
  mounted: function mounted() {
    var that = this;
    that.umid = $UMCore.uncompile("umid");
    var waitReady = function waitReady() {
      if (that.appid != '' && that.appid != undefined) {
        that.readNews();
      } else {
        setTimeout(function () {
          waitReady();
        }, 20);
      }
    };
    setTimeout(function () {
      waitReady();
    }, 50);
  },

  methods: {
    readNews: function readNews() {
      var that = this;
      $UMCore.post("/route.lua", {
        data: JSON.stringify({
          functionname: 'extension_readcount',
          appid: that.appid,
          dappuuid: that.sid,
          readcount: 1
        })
      }).then(function (response) {
        if (response.data.status === true) {
          that.readcount = response.data.readcount;
        } else {
          that.$message.error('网络错误！');
          return false;
        }
      }).catch(function (error) {});
    }
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "UmMcomment",
  data: function data() {
    return {
      reviewtype: 0,
      usercomments: '',
      page: 0,
      pagesize: 4,
      totalpage: 0,
      total: 0,
      umid: '',
      parentreviewid: '',
      review: [],
      loadStatus: true,
      status: true
    };
  },

  props: {
    avatar: String,
    sumname: String,
    sid: String,
    appid: String,
    reviewcount: String,
    showNewComment: {
      type: Boolean,
      default: true
    }
  },
  mounted: function mounted() {
    var that = this;
    // that.umid=$UMCore.uncompile("umid")
    var waitReady = function waitReady() {
      if (that.sid != '' && that.sid != undefined) {
        that.umid = $UMCore.uncompile("umid");
        that.getreview();
        if ($UMCore.uncompile('token') != null) {
          var commenttype = localStorage.getItem("commenttype");
          if (commenttype == 1) {
            that.usercomments = localStorage.getItem("comment");
            that.usercommentsfun();
          } else if (commenttype == 2) {
            var sid = localStorage.getItem("commentsid");
            that.cai(sid);
          } else if (commenttype == 3) {
            var sid = localStorage.getItem("commentsid");
            that.ding(sid);
          }
        }
        localStorage.removeItem("commenttype");
        localStorage.removeItem("comment");
        localStorage.removeItem("commentsid");
      } else {
        setTimeout(function () {
          waitReady();
        }, 20);
      }
    };
    setTimeout(function () {
      waitReady();
    }, 50);
  },

  methods: {
    getreview: function getreview() {
      var that = this;
      that.umid = $UMCore.uncompile("umid");
      $UMCore.post("/route.lua", {
        data: JSON.stringify({
          functionname: "comments_getlist",
          dappuuid: that.sid,
          page: that.page,
          pagesize: that.pagesize,
          umid: that.umid
        })
      }).then(function (response) {
        if (response.data.code == 0) {
          that.totalpage = response.data.totalpage;
          that.total = response.data.total;
          // that.review = response.data.slist
          var arr = response.data.slist;
          if (arr.length == 0) {
            that.loadStatus = false;
            that.status = true;
          } else {
            arr.forEach(function (val) {
              that.review.push(val);
            });
            that.status = true;
          }
          // for (var i = 0; i < that.review.length; i++) {
          //   that.$set(that.review[i], 'clickNum', -1)
          //   that.$set(that.review[i], 'clickNum1', -1)
          // }
        } else if (response.data.code == 1) {
          that.$message.error("网络错误2！");
        } else {
          that.$message.error("请登录！");
        }
      }).catch(function (error) {
        console.log(error);
        that.$message.error("网络错误3！");
        return false;
      });
    },

    /**
     * 获取新闻相关内容（详情，评论）
     */
    api: function api() {
      var that = this;
      that.umid = $UMCore.uncompile("umid");
      console.log(JSON.stringify({
        functionname: "comments_set",
        dappid: that.appid,
        edittype: that.edittype,
        dappuuid: that.sid,
        itype: that.reviewtype,
        stext: that.usercomments,
        umid: that.umid,
        parentid: that.parentreviewid
      }));
      $UMCore.post("/route.lua", {
        data: JSON.stringify({
          functionname: "comments_set",
          dappid: that.appid,
          edittype: that.edittype,
          dappuuid: that.sid,
          itype: that.reviewtype,
          stext: that.usercomments,
          umid: that.umid,
          parentid: that.parentreviewid
        })
      }).then(function (response) {
        if (response.data.status) {
          that.usercomments = '';
          if (that.reviewtype == 1) {
            that.loadStatus = true;
            that.status = true;
            that.page = 0;
            that.review = [];
            that.getreview();
            that.$emit("resetList", "");
          }
        } else {
          that.$message({ message: '失败', type: 'error', customClass: 'popupMessage' });
        }
      }).catch(function (error) {
        console.log(error);
        that.$message.error("网络错误！");
        return false;
      });
    },

    /**
     * 发送新闻评论内容
     */
    usercommentsfun: function usercommentsfun() {
      var that = this;
      if ($UMCore.uncompile('token') == null) {
        // this.openloginview()
      } else {
        var that = this;
        that.reviewtype = 1;
        if (that.usercomments != '') {
          that.api();
          // that.detailInfo.reviewcount=parseInt(that.detailInfo.reviewcount)+1;
          that.reviewcount = parseInt(that.reviewcount) + 1;
          this.$emit('retcomment', that.reviewcount);
          // that.loadStatus = true;
          // that.status = true;
          // that.page=0
          // that.review=[]
          // that.getreview()
        } else {
          that.$message({ message: '不能发送空信息', type: 'error', customClass: 'popupMessage' });
        }
      }
    },
    caifun: function caifun(id) {
      var that = this;
      that.parentreviewid = id;
      that.reviewtype = 3;
      that.api();
      for (var j = 0; j < that.review.length; j++) {
        if (id == that.review[j].sid) {
          if (that.review[j].minecai === '1') {
            that.review[j].minecai = '0';
            that.review[j].caicount = that.review[j].caicount - 1;
            break;
          } else if (that.review[j].minecai === '0' && that.review[j].mineding === '1') {
            that.review[j].caicount = parseInt(that.review[j].caicount) + 1;
            that.review[j].dingcount = that.review[j].dingcount - 1;
            that.review[j].minecai = '1';
            that.review[j].mineding = '0';
            break;
          } else {
            that.review[j].minecai = '1';
            that.review[j].caicount = parseInt(that.review[j].caicount) + 1;
            break;
          }
        }
      }
    },

    /**
     * 新闻评论顶
     */
    dingfun: function dingfun(id) {
      var that = this;
      that.parentreviewid = id;
      that.reviewtype = 2;
      that.api();
      for (var j = 0; j < that.review.length; j++) {
        if (id == that.review[j].sid) {
          if (that.review[j].mineding === '1') {
            that.review[j].mineding = '0';
            that.review[j].dingcount = that.review[j].dingcount - 1;
            break;
          } else if (that.review[j].minecai === '1' && that.review[j].mineding === '0') {
            that.review[j].caicount = that.review[j].caicount - 1;
            that.review[j].dingcount = parseInt(that.review[j].dingcount) + 1;
            that.review[j].minecai = '0';
            that.review[j].mineding = '1';
            break;
          } else {
            that.review[j].mineding = '1';
            that.review[j].dingcount = parseInt(that.review[j].dingcount) + 1;
            break;
          }
        }
      }
    },
    changepage: function changepage() {
      var that = this;
      if (that.loadStatus && that.status) {
        that.status = false;
        that.page++;
        that.getreview();
      }
    },
    getShortName: function getShortName(sname) {
      if (sname != undefined && sname.length > 2) {
        return sname.substr(sname.length - 2, 2);
      }
      if (this.umid == '' || this.umid == undefined) {
        return '未登录';
      }
      return sname;
    },
    send: function send() {
      // this.$emit('retusercomments',this.usercomments);
      if ($UMCore.uncompile('token') == null) {
        localStorage.setItem("commenttype", 1);
        localStorage.setItem("comment", this.usercomments);
        this.$emit('unlogin', '');
      } else {
        this.usercommentsfun();
        this.usercomments = '';
      }
    },
    cai: function cai(sid) {
      // this.$emit('retcai',sid);
      if ($UMCore.uncompile('token') == null) {
        localStorage.setItem("commenttype", 2);
        localStorage.setItem("commentsid", sid);
        this.$emit('unlogin', '');
      } else {
        this.caifun(sid);
      }
    },
    ding: function ding(sid) {
      // this.$emit('retding',sid);
      if ($UMCore.uncompile('token') == null) {
        localStorage.setItem("commenttype", 3);
        localStorage.setItem("commentsid", sid);
        this.$emit('unlogin', '');
      } else {
        this.dingfun(sid);
      }
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "UmCollect",
    data: function data() {
        return {
            umid: ''
        };
    },

    props: ["sid", "appid", "favorites", "title", "favoritessid"],
    mounted: function mounted() {
        var that = this;
        that.umid = $UMCore.uncompile("umid");
        // var waitReady = function() {
        //   if (that.appid != '' && that.appid != undefined) {
        //     that.collect(); 
        //   } else {
        //     setTimeout(function() {
        //       waitReady();
        //     }, 20);
        //   }
        // };
        // setTimeout(function() {
        //   waitReady();
        // }, 50);
    },

    methods: {
        collect: function collect() {
            var that = this;
            if ($UMCore.uncompile('token') == null) {
                // localStorage.setItem("newsoperate", 1)
                this.$emit('unlogin', '');
                return false;
            }
            console.log(JSON.stringify({
                functionname: 'favorites_set',
                appid: that.appid,
                dappuuid: that.sid,
                title: that.title,
                type: that.favorites == 0 ? 0 : 2,
                umid: that.umid,
                sid: that.favoritessid
            }));
            $UMCore.post("/route.lua", {
                data: JSON.stringify({
                    functionname: 'favorites_set',
                    appid: that.appid,
                    dappuuid: that.sid,
                    title: that.title,
                    type: that.favorites == 0 ? 0 : 2,
                    umid: that.umid,
                    sid: that.favoritessid
                })
            }).then(function (response) {
                if (response.data.status === true) {
                    that.favoritessid = response.data.sid;
                    if (that.favorites == 0) {
                        that.favorites = 1;
                    } else {
                        that.favorites = 0;
                    }
                } else {
                    that.$message.error('网络错误！');
                    return false;
                }
            }).catch(function (error) {});
        }
    }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import QRCode from 'qrcode'
/* harmony default export */ __webpack_exports__["a"] = ({
    name: "UmShare",
    data: function data() {
        return {
            umid: '',
            showShareImg: false,
            mask: false,
            sharetitle: "联信应用",
            imgurl: "https://dapp.umnet.cn/img/um.png"
        };
    },

    props: ["title", "url", "sharetitle", "imgurl"],
    mounted: function mounted() {
        var that = this;
        that.umid = $UMCore.uncompile("umid");
        var that = this;
        window.goBack = that.goBack;
        console.log(JSON.stringify({
            functionname: "wxshare",
            umid: $UMCore.uncompile("umid")
        }));
        var ua = window.navigator.userAgent.toLowerCase(),
            status;
        // console.log("ua = " + ua.indexOf('micromessenger'));
        if (ua.indexOf('micromessenger') != -1) {
            $UMCore.post("route.lua", {
                data: JSON.stringify({
                    functionname: "wxshare",
                    // umid: $UMCore.uncompile("umid")
                    htmlpage: location.pathname
                })
            }).then(function (res) {
                if (res.data.status == 1) {
                    var noSharp = location.href.split('#')[0];
                    var url = noSharp.includes('?') ? noSharp + "&umid=" + $UMCore.uncompile("umid") : noSharp + "?umid=" + $UMCore.uncompile("umid");
                    console.log("@@@@@@ - " + url);
                    wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: res.data.appid, // 必填，公众号的唯一标识
                        timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                        nonceStr: res.data.noncestr, // 必填，生成签名的随机串
                        signature: res.data.signature, // 必填，签名
                        jsApiList: ["updateAppMessageShareData"]
                    });
                    wx.ready(function () {
                        wx.updateAppMessageShareData({
                            title: that.sharetitle, // 分享标题
                            desc: that.title, // 分享描述
                            link: that.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: that.imgurl, // 分享图标
                            success: function success() {
                                // 用户点击了分享后执行的回调函数
                            }
                        });
                    });
                }
            }).catch(function (err) {
                console.log(err);
            });
        }
    },

    methods: {
        share: function share() {
            var that = this;
            var isUmapp = navigator.userAgent.indexOf("umapp") > -1;
            if (isUmapp) {
                var u = navigator.userAgent,
                    app = navigator.appVersion;
                var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端
                var map = {};
                map.type = "cardShare";
                map.title = "联信应用";
                map.desc = that.title;
                map.url = that.url;
                map.sharelogo = "https://dapp.umnet.cn/img/um.png";
                if (isIOS) {
                    window.webkit.messageHandlers.event.postMessage(map);
                } else if (isAndroid) {
                    var newMap = JSON.stringify(map);
                    android.event(newMap);
                }
            } else {
                var ua = window.navigator.userAgent.toLowerCase(),
                    status;
                // console.log("ua = " + ua.indexOf('micromessenger'));
                if (ua.indexOf('micromessenger') == -1) {
                    that.mask = true;
                    that.sharecode = true;
                    $("#sharecanvas2").html("");
                    this.$nextTick(function () {
                        var qrcode1 = new QRCode("sharecanvas2", {
                            width: 200,
                            height: 200,
                            text: that.url, // 二维码地址
                            colorDark: "#000",
                            colorLight: "#fff"
                        });
                    });
                } else {
                    that.showShareImg = true;
                }
            }
        }
    },
    components: {
        // QRCode: QRCode
    }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import QRCode from 'qrcode'
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'UmDownloadApp',
    data: function data() {
        return {
            downloadUrl: "https://" + $UMCore.getHost() + "/dapp.html#/androiddownload"
        };
    },
    mounted: function mounted() {
        this.useqrcode();
    },
    updated: function updated() {
        this.useqrcode();
    },

    methods: {
        changeStatus: function changeStatus() {
            this.$emit("showTip", false);
        },
        useqrcode: function useqrcode() {
            // var canvas = this.$refs.downloadAppQR;
            // QRCode.toCanvas(canvas, "https://dapp.umnet.cn/apps/download/UMGrit.apk", function (error) {
            // if (error) console.error(error)
            // })
            // $(".downloadAppQR").width(250);
            // $(".downloadAppQR").height(250);
            var url = "https://dapp.umnet.cn/apps/download/UMGrit.apk";
            $("#downloadAppQR").html("");
            this.$nextTick(function () {
                var qrcode1 = new QRCode("downloadAppQR", {
                    width: 250,
                    height: 250,
                    text: url, // 二维码地址
                    colorDark: "#000",
                    colorLight: "#fff"
                });
            });
        }
    }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import QRCode from "qrcodejs2";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "umRecharge",
  data: function data() {
    return {
      activeNum: 1,
      showcode: false,
      activeumNum: 100,
      allAccount: 0,
      umallAccount: 0,
      paylist: [{
        jfNum: 100,
        moneyNum: 1
      }, {
        jfNum: 1000,
        moneyNum: 10
      }, {
        jfNum: 5000,
        moneyNum: 50
      }, {
        jfNum: 10000,
        moneyNum: 100
      }],
      umpaylist: [{
        umNum: 1,
        moneyNum: 100
      }, {
        umNum: 10,
        moneyNum: 1000
      }, {
        umNum: 50,
        moneyNum: 5000
      }, {
        umNum: 100,
        moneyNum: 10000
      }],
      otherNum: 5,
      otherumNum: 5,
      otherNumChoose: false,
      paytype: 2,
      otherUmNumChoose: false
    };
  },
  mounted: function mounted() {
    this.umaccount();
    this.account();
  },

  props: {
    payDialog: {
      type: Boolean,
      default: false
    },
    payMod: {
      type: String,
      default: "integral"
    }
  },
  watch: {
    payDialog: function payDialog(val) {
      if (val) {
        if (this.payMod == "integral") {
          this.qrcode();
        }
      }
    }
  },
  methods: {
    umaccount: function umaccount() {
      var that = this;
      $UMCore.post("route.lua", {
        data: JSON.stringify({
          functionname: "getchainaccount",
          umid: $UMCore.uncompile("umid")
        })
      }).then(function (res) {
        if (res.data.result) {
          var a = JSON.parse(res.data.data).result;
          // that.UMPayId = a.account_data.Account
          that.umallAccount = a.account_data.Balance / 1000000;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },

    /**
     * 获取总积分数
     */
    account: function account() {
      var _this = this;

      $UMCore.post("/route.lua", {
        data: JSON.stringify({
          functionname: "integral_getintegralforumid",
          umid: $UMCore.uncompile("umid")
        })
      }).then(function (res) {
        _this.allAccount = res.data.balance;
      }).catch(function (error) {
        _this.$message.error("查询积分总数失败");
      });
    },
    accMul: function accMul(arg1, arg2) {
      var m = 0,
          s1 = arg1.toString(),
          s2 = arg2.toString();
      try {
        m += s1.split(".")[1].length;
      } catch (e) {}
      try {
        m += s2.split(".")[1].length;
      } catch (e) {}
      return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
    },
    close: function close() {
      this.$emit("close", false);
      this.payDialog = false;
    },

    /**
     * 生成二维码
     */
    qrcode: function qrcode() {
      var _this2 = this;

      console.log(this.activeNum);
      if (this.showcode) {
        this.activeNum = this.otherNum;
      }
      var link = "";
      $UMCore.post("https://open.umnet.cn/pay/index.php", {
        user_id: $UMCore.uncompile("umid"),
        money_value: this.activeNum,
        order_no: new Date().getTime()
      }).then(function (res) {
        console.log("res=", res.data.url);
        $("#qrcode").html("");
        _this2.showcode = false;
        _this2.$nextTick(function () {
          var qrcode = new QRCode("qrcode", {
            width: 160,
            height: 160,
            text: res.data.url, // 二维码地址
            colorDark: "#000",
            colorLight: "#fff"
          });
        });
      }).catch(function (error) {
        console.log("error=", error);
      });
    },
    alipayUrl: function alipayUrl() {
      if (this.showcode) {
        this.activeNum = this.otherNum;
      }
      window.open("https://open.umnet.cn/pay/alipayzf.php?user_id=" + $UMCore.uncompile("umid") + "&money_value=" + this.activeNum + "&order_no=" + new Date().getTime());
    },
    chooseNum: function chooseNum(moneyNum, s) {
      this.otherNumChoose = s;
      if (!s) {
        this.activeNum = moneyNum;
        this.showcode = false;
        this.qrcode();
      } else {
        this.$refs.otherNum.focus();
        // $('.qrcodeBox').html('')
        this.showcode = true;
        // this.qrcode()
      }
    },
    chooseumNum: function chooseumNum(moneyNum, s) {
      this.otherUmNumChoose = s;
      this.paytype = 2;
      if (!s) {
        this.activeumNum = moneyNum;
      } else {
        this.$refs.otherNum.focus();
      }
    },
    oninput: function oninput(e) {
      // 通过正则过滤小数点后两位
      e.target.value = e.target.value.match(/^\d*(\.?\d{0,2})/g)[0] || null;
      this.otherNum = e.target.value;
    },
    onuminput: function onuminput(e) {
      // 通过正则过滤小数点后两位
      e.target.value = e.target.value.match(/^\d*(\.?\d{0,2})/g)[0] || null;
      this.otherumNum = e.target.value;
    },
    exchange: function exchange() {
      var _this3 = this;

      var integral = 0;
      if (this.otherUmNumChoose) {
        integral = this.otherumNum * 100;
      } else {
        integral = this.activeumNum;
      }
      var that = this;
      if (integral > that.umallAccount) {
        that.$message.error("兑换数量不能超过总数量！");
      } else {
        $UMCore.post("route.lua", {
          data: JSON.stringify({
            functionname: "integraltochainamount",
            umid: $UMCore.uncompile("umid"),
            integral: integral
          })
        }).then(function (res) {
          if (res.data.result) {
            _this3.$message({
              type: "success",
              message: "兑换成功！",
              onClose: function onClose() {
                _this3.payDialog = false;
                _this3.umaccount();
              }
            });
          } else {
            _this3.$message.error("兑换失败，请重试！");
            return;
          }
        }).catch(function (err) {
          console.log(err);
        });
      }
    }
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "umRange",
  data: function data() {
    return {};
  },

  props: ["formdapp", "tagsFriend", "tagsGroup", "tagsOrg", "tagshy", "tagsdq"],
  methods: {
    opencandidate: function opencandidate(type) {
      this.$emit("opencandidate", type);
    },

    /**tag表签删除 */
    handleClose: function handleClose(item, index, type) {
      if (type == "f") {
        this.tagsFriend.splice(index, 1);
      } else if (type == "g") {
        this.tagsGroup.splice(index, 1);
      } else if (type == "o") {
        this.tagsOrg.splice(index, 1);
      } else if (type == "h") {
        this.tagshy.splice(index, 1);
      } else if (type == "d") {
        this.tagsdq.splice(index, 1);
      }
    }
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "umIdentity",
  data: function data() {
    return {
      orglist: [],
      orgid: ""
    };
  },

  props: ["formdapp"],
  created: function created() {
    var that = this;
    that.formdapp.item = $UMCore.uncompile("umid");
    $UMCore.post("/route.lua", {
      data: JSON.stringify({
        functionname: "userlist_getusermangerrange",
        type: 3,
        umid: $UMCore.uncompile("umid")
      })
    }).then(function (response) {
      that.orglist = response.data.mangerlist.orglist;
    }).catch(function (error) {
      return false;
    });
  },

  methods: {
    setItem: function setItem(e) {
      if (e == "1") {
        this.formdapp.item = $UMCore.uncompile("umid");
      } else {
        this.formdapp.item = this.orgid;
      }
    },
    curOrgChanged: function curOrgChanged(e) {
      this.orgid = e;
      this.$emit("selectOrg", e, this.formdapp.identitytype);
    }
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "umMrange",
  data: function data() {
    return {
      reset_choose: false,
      scope: "仅个人可见（草稿）",
      scope_arr: ["仅个人可见（草稿）", "所有人可见", "范围可见"],
      muta_status: false,
      scope_status: false
    };
  },

  props: ["orgArr", "friendArr", "groupArr", "hyArr", "dqArr", "radio1"],
  watch: {
    radio1: function radio1(val) {
      if (val == "0") {
        this.scope = "仅个人可见（草稿）";
      } else if (val == "1") {
        this.scope = "所有人可见";
      } else if (val == "2") {
        this.scope = "范围可见";
        this.reset_choose = true;
      }
    }
  },
  mounted: function mounted() {
    if (this.radio1 == "0") {
      this.scope = "仅个人可见（草稿）";
    } else if (this.radio1 == "1") {
      this.scope = "所有人可见";
    } else if (this.radio1 == "2") {
      this.scope = "范围可见";
      this.reset_choose = true;
    }
  },

  methods: {
    choose: function choose() {
      this.$emit("chooseDialog", 2);
    },
    changeRa: function changeRa(val) {
      // 选择发布范围
      this.radio1 = val;
      this.reset_choose = false;
      this.scope = this.scope_arr[val];
      if (val == 2) {
        // ==2的时候弹出选人
        this.reset_choose = true;
      }
      this.$emit("chooseDialog", val);
    },

    /**tag表签删除 */
    handleClose: function handleClose(item, index, type) {
      if (type == "f") {
        this.friendArr.splice(index, 1);
      } else if (type == "g") {
        this.groupArr.splice(index, 1);
      } else if (type == "o") {
        this.orgArr.splice(index, 1);
      } else if (type == "h") {
        this.hyArr.splice(index, 1);
      } else if (type == "d") {
        this.dqArr.splice(index, 1);
      }
    },
    changeScope: function changeScope() {
      this.muta_status = true;
      this.scope_status = true;
      this.radio1 = parseInt(this.radio1);
      $("#selrangebox").css("height", "180px");
    },
    mask_status: function mask_status() {
      this.muta_status = false;
      this.scope_status = false;
    }
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "umMidentity",
  data: function data() {
    return {
      choose_org_status: false,
      orgArr: [],
      org_name: "",
      type: 1,
      radio2: 0,
      muta_status: false,
      change_status: true
    };
  },

  props: ["status", "orgId"],
  mounted: function mounted() {
    this.getList();
  },

  watch: {
    status: function status(val) {
      if (val == "1") {
        this.change_status = true;
      } else {
        this.change_status = false;
      }
    },
    orgId: function orgId(val) {
      this.getList();
    },
    releaseitem: function releaseitem(val) {
      var _this = this;

      if (!this.change_status) {
        this.orgArr.forEach(function (m) {
          if (m.orgid == _this.orgId) {
            _this.org_name = m.orgname;
            _this.orgId = m.orgid;
          }
        });
      }
    }
  },
  methods: {
    getList: function getList() {
      var that = this;
      $UMCore.post("/route.lua", {
        data: JSON.stringify({
          functionname: "userlist_getusermangerrange",
          type: 3,
          umid: $UMCore.uncompile("umid")
        })
      }).then(function (response) {
        that.orgArr = response.data.mangerlist.orglist;
        if (that.orgId) {
          that.orgArr.forEach(function (m, i) {
            if (that.orgId == m.orgid) {
              that.org_name = m.orgname;
            }
          });
        } else {
          that.org_name = that.orgArr[0].orgname;
        }
        that.radio2 = parseInt(that.orgArr[0].orgid);
        that.$forceUpdate();
      }).catch(function (error) {
        return false;
      });
    },
    changeP: function changeP() {
      this.type = 1;
      this.change_status = true;
      this.$emit("chooseorgid", "1");
    },
    changeO: function changeO() {
      this.type = 3;
      this.change_status = false;
      this.$emit("chooseorgid", "3");

      this.changeOrg();
    },
    change_org: function change_org(val) {
      var _this2 = this;

      $("#selidbox").css("height", "220px");
      this.orgArr.forEach(function (m, i) {
        if (m.orgid == val) {
          _this2.org_name = m.orgname;
          _this2.orgId = val;
        }
      });
      this.$emit("chooseorgid", "3", this.orgId, this.org_name);
    },
    changeOrg: function changeOrg() {
      this.muta_status = true;
      this.choose_org_status = true;
    },
    mask_status: function mask_status() {
      this.muta_status = false;
      this.choose_org_status = false;
    }
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "umEdituser",
  props: ["form", "editava", "usersub", "address", "address1", "industryinfo1", "defaultIcon", "area_code"],
  data: function data() {
    return {
      submitImgStatus: false,
      provinceList: [],
      cityList: [],
      districtList: [],
      provinceList1: [],
      cityList1: [],
      districtList1: [],
      industryinfo1List: [],
      industryinfo21List: [],
      industryinfo3List: [],
      schoolList: [],
      area_code: '',
      area_code1: '',
      industry_code: '',
      areainfo: {},
      industryinfo: {},
      value: {},
      loading: false
    };
  },

  watch: {
    usersub: function usersub(val) {
      if (val.areainfo.result != -1 && val.areainfo != "") {
        this.getAreaList(0, "province");
        this.getAreaList(val.areainfo.level1, "city");
        this.getAreaList(val.areainfo.level2, "district");
        this.address.level1 = val.areainfo.level1;
        this.address.level2 = val.areainfo.level2;
        this.address.level3 = val.areainfo.level3;
        this.area_code = val.area_code;
        this.$forceUpdate();
      } else {
        this.getAreaList(0, "province");
      }
      if (val.homeinfo.result != -1 && val.homeinfo != "") {
        this.getAreaList1(0, "province");
        this.getAreaList1(val.homeinfo.level1, "city");
        this.getAreaList1(val.homeinfo.level2, "district");
        this.address1.level1 = val.homeinfo.level1;
        this.address1.level2 = val.homeinfo.level2;
        this.address1.level3 = val.homeinfo.level3;
        this.area_code1 = val.home_code;
        this.$forceUpdate();
      } else {
        this.getAreaList1(0, "province");
      }
      if (val.industryinfo.result != -1 && val.industryinfo != "") {
        this.getIndustryinfoList(0, "level1");
        this.getIndustryinfoList(val.industryinfo.level1, "level2");
        this.getIndustryinfoList(val.industryinfo.level2, "level3");
        this.industryinfo1.level1 = val.industryinfo.level1;
        this.industryinfo1.level2 = val.industryinfo.level2;
        this.industryinfo1.level3 = val.industryinfo.level3;
        this.industry_code = val.industry_code;
        this.$forceUpdate();
      } else {
        this.getIndustryinfoList(0, "level1");
      }
    },
    editava: function editava(val) {
      var _this = this;

      if (this.usersub.school_code != "") {
        this.$set(this.value, 'code', this.usersub.school_code);
        this.$set(this.value, 'name', this.usersub.school_name);
      }
      if (val && this.value.name) {
        this.$nextTick(function () {
          $(".school .el-input__inner").val(_this.value.name);
        });
      }
    }
  },
  methods: {
    editavaClose: function editavaClose() {
      this.$emit("close");
    },
    submit: function submit() {
      this.submitImgStatus = true;
    },
    submitava: function submitava(e) {
      var that = this;
      var area_name;
      if (!$(".district option:selected").text()) {
        if (!$(".city option:selected").text()) {
          area_name = $(".province option:selected").text();
        } else {
          area_name = $(".province option:selected").text() + "-" + $(".city option:selected").text();
        }
      } else {
        area_name = $(".province option:selected").text() + "-" + $(".city option:selected").text() + "-" + $(".district option:selected").text();
      }
      var area_name1;
      if (!$(".district1 option:selected").text()) {
        if (!$(".city1 option:selected").text()) {
          area_name1 = $(".province1 option:selected").text();
        } else {
          area_name1 = $(".province1 option:selected").text() + "-" + $(".city1 option:selected").text();
        }
      } else {
        area_name1 = $(".province1 option:selected").text() + "-" + $(".city1 option:selected").text() + "-" + $(".district1 option:selected").text();
      }
      var industry_name;
      if (!$(".level1 option:selected").text()) {
        if (!$(".level2 option:selected").text()) {
          industry_name = $(".level1 option:selected").text();
        } else {
          industry_name = $(".level1 option:selected").text() + "-" + $(".level2 option:selected").text();
        }
      } else {
        industry_name = $(".level1 option:selected").text() + "-" + $(".level2 option:selected").text() + "-" + $(".level3 option:selected").text();
      }
      that.submitImgStatus = false;
      if (e != "") {
        that.form.avatar = e.fullpath;
      }
      $UMCore.post("/route.lua", {
        data: JSON.stringify({
          functionname: "sys_user_setsub",
          modulename: "admin",
          umid: $UMCore.uncompile("umid"),
          avatar: that.form.avatar,
          sumname: that.form.sumname,
          job: that.form.job,
          company: that.form.company,
          // location:that.actaddress,
          area_code: that.area_code,
          home_code: that.area_code1,
          industry_code: that.industry_code,
          areainfo: that.address,
          homeinfo: that.address1,
          industryinfo: that.industryinfo1,
          school_code: that.value.code,
          // area_name:
          signature: that.form.signature,
          stel: that.form.stel,
          email: that.form.email,
          area_name: area_name,
          industry_name: industry_name,
          home_name: area_name1,
          school_name: that.value.name,
          areaaddress: that.usersub.areaaddress,
          homeaddress: that.usersub.homeaddress,
          cardbackground: that.form.cardbackground
        })
      }).then(function (res) {
        if (res.data.data.status) {
          that.$message({
            message: "修改成功！",
            type: "success",
            onClose: function onClose() {
              that.editava = false;
              $UMCore.compile("avatar", that.form.avatar);
              $UMCore.compile("sumname", that.form.sumname);
              $UMCore.msg({
                cmd: "user",
                op: "editava",
                info: "修改头像",
                data: { avatar: that.form.avatar }
              });
            }
          });
        } else {
          that.$message.error("修改失败！");
        }
      }).catch(function (error) {
        that.$message.error("修改失败！");
      });
    },

    /**选择头像 */
    choosecolor: function choosecolor(item) {
      this.selectcolor = item.id;
      this.form.avatar = item.path;
    },
    editImg: function editImg(val) {
      if (this.editupload == "") {
        this.editupload = undefined;
      } else {
        this.editupload = "";
      }
      this.form.avatar = val;
      this.selectcolor = -1;
    },
    upload1: function upload1() {
      $(".editava .el-upload").click();
    },

    //获取地区
    getAreaList: function getAreaList(id, type, e) {
      var _this2 = this;

      $UMCore.post(window.zt_server + "/route.lua", {
        data: JSON.stringify({
          modulename: "area",
          functionname: "get",
          pid: id
        })
      }).then(function (res) {
        if (type == "province") {
          _this2.provinceList = res.data.data.slist;
          _this2.$forceUpdate();
        } else if (type == "city") {
          _this2.cityList = res.data.data.slist;
          if (e) {
            _this2.area_code = e.target.options[e.target.selectedIndex].getAttribute("data-code");
          }
          _this2.$forceUpdate();
        } else if (type == "district") {
          _this2.districtList = res.data.data.slist;
          if (e) {
            _this2.area_code = e.target.options[e.target.selectedIndex].getAttribute("data-code");
          }
          _this2.$forceUpdate();
        }
      });
    },

    /**获取籍贯 */
    getAreaList1: function getAreaList1(id, type, e) {
      var _this3 = this;

      $UMCore.post(window.zt_server + "/route.lua", {
        data: JSON.stringify({
          modulename: "area",
          functionname: "get",
          pid: id
        })
      }).then(function (res) {
        if (type == "province") {
          _this3.provinceList1 = res.data.data.slist;
          _this3.$forceUpdate();
        } else if (type == "city") {
          _this3.cityList1 = res.data.data.slist;
          if (e) {
            _this3.area_code1 = e.target.options[e.target.selectedIndex].getAttribute("data-code");
          }
          _this3.$forceUpdate();
        } else if (type == "district") {
          _this3.districtList1 = res.data.data.slist;
          if (e) {
            _this3.area_code1 = e.target.options[e.target.selectedIndex].getAttribute("data-code");
          }
          _this3.$forceUpdate();
        }
      });
    },

    //获取行业
    getIndustryinfoList: function getIndustryinfoList(id, type, e) {
      var _this4 = this;

      $UMCore.post(window.zt_server + "/route.lua", {
        data: JSON.stringify({
          modulename: "industry",
          functionname: "get",
          pid: id
        })
      }).then(function (res) {
        if (type == "level1") {
          _this4.industryinfo1List = res.data.data.slist;
          _this4.$forceUpdate();
        } else if (type == "level2") {
          _this4.industryinfo2List = res.data.data.slist;
          if (e) {
            _this4.industry_code = e.target.options[e.target.selectedIndex].getAttribute("data-code");
          }
          _this4.$forceUpdate();
        } else if (type == "level3") {
          _this4.industryinfo3List = res.data.data.slist;
          if (e) {
            _this4.industry_code = e.target.options[e.target.selectedIndex].getAttribute("data-code");
          }
          _this4.$forceUpdate();
        }
      });
    },
    getSchoolList: function getSchoolList(m) {
      var _this5 = this;

      this.loading = true;
      $UMCore.post(window.zt_server + "/route.lua", {
        data: JSON.stringify({
          modulename: "school",
          functionname: "getlist",
          name: m,
          pagesize: -1
        })
      }).then(function (res) {
        _this5.loading = false;
        _this5.schoolList = res.data.data.slist;
      });
    },
    getcode: function getcode(i) {
      this.area_code = i.target.options[i.target.selectedIndex].getAttribute("data-code");
    },
    getcode1: function getcode1(i) {
      this.industry_code = i.target.options[i.target.selectedIndex].getAttribute("data-code");
    },
    getcode2: function getcode2(i) {
      this.area_code1 = i.target.options[i.target.selectedIndex].getAttribute("data-code");
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__packages_comment_index_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__packages_img_index_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__packages_animate_index_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__packages_list_index_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__packages_attachment_index_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__packages_selectuser_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__packages_dialog_index_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__packages_addlist_index_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__packages_candidate_index_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__packages_simg_index_js__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__packages_mselector_index_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__packages_zan_index_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__packages_readcount_index_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__packages_mcomment_index_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__packages_collect_index_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__packages_share_index_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__packages_downloadAppTip_index_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__packages_recharge_index_js__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__packages_range_index_js__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__packages_identity_index_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__packages_mrange_index_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__packages_midentity_index_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__packages_edituser_index_js__ = __webpack_require__(148);
























var components = [__WEBPACK_IMPORTED_MODULE_0__packages_comment_index_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__packages_img_index_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__packages_animate_index_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__packages_list_index_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__packages_attachment_index_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__packages_selectuser_index_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__packages_dialog_index_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__packages_addlist_index_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__packages_candidate_index_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__packages_simg_index_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__packages_mselector_index_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__packages_zan_index_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__packages_readcount_index_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__packages_mcomment_index_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__packages_collect_index_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__packages_share_index_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__packages_downloadAppTip_index_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__packages_recharge_index_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__packages_range_index_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__packages_identity_index_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__packages_mrange_index_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__packages_midentity_index_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__packages_edituser_index_js__["a" /* default */]];

var install = function install(Vue) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  components.map(function (component) {
    Vue.component(component.name, component);
  });
};

/* 支持使用标签的方式引入 */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

/* harmony default export */ __webpack_exports__["default"] = ({
  install: install,
  umComment: __WEBPACK_IMPORTED_MODULE_0__packages_comment_index_js__["a" /* default */],
  umImg: __WEBPACK_IMPORTED_MODULE_1__packages_img_index_js__["a" /* default */],
  umAnimate: __WEBPACK_IMPORTED_MODULE_2__packages_animate_index_js__["a" /* default */],
  umList: __WEBPACK_IMPORTED_MODULE_3__packages_list_index_js__["a" /* default */],
  umAttachment: __WEBPACK_IMPORTED_MODULE_4__packages_attachment_index_js__["a" /* default */],
  umSelectuser: __WEBPACK_IMPORTED_MODULE_5__packages_selectuser_index_js__["a" /* default */],
  umDialog: __WEBPACK_IMPORTED_MODULE_6__packages_dialog_index_js__["a" /* default */],
  umAddlist: __WEBPACK_IMPORTED_MODULE_7__packages_addlist_index_js__["a" /* default */],
  umCandidate: __WEBPACK_IMPORTED_MODULE_8__packages_candidate_index_js__["a" /* default */],
  umSimg: __WEBPACK_IMPORTED_MODULE_9__packages_simg_index_js__["a" /* default */],
  umMselector: __WEBPACK_IMPORTED_MODULE_10__packages_mselector_index_js__["a" /* default */],
  umZan: __WEBPACK_IMPORTED_MODULE_11__packages_zan_index_js__["a" /* default */],
  umReadcount: __WEBPACK_IMPORTED_MODULE_12__packages_readcount_index_js__["a" /* default */],
  umMcomment: __WEBPACK_IMPORTED_MODULE_13__packages_mcomment_index_js__["a" /* default */],
  umCollect: __WEBPACK_IMPORTED_MODULE_14__packages_collect_index_js__["a" /* default */],
  umShare: __WEBPACK_IMPORTED_MODULE_15__packages_share_index_js__["a" /* default */],
  umDownloadApp: __WEBPACK_IMPORTED_MODULE_16__packages_downloadAppTip_index_js__["a" /* default */],
  umRecharge: __WEBPACK_IMPORTED_MODULE_17__packages_recharge_index_js__["a" /* default */],
  umRange: __WEBPACK_IMPORTED_MODULE_18__packages_range_index_js__["a" /* default */],
  umIdentity: __WEBPACK_IMPORTED_MODULE_19__packages_identity_index_js__["a" /* default */],
  umMrange: __WEBPACK_IMPORTED_MODULE_20__packages_mrange_index_js__["a" /* default */],
  umMidentity: __WEBPACK_IMPORTED_MODULE_21__packages_midentity_index_js__["a" /* default */],
  umEdituser: __WEBPACK_IMPORTED_MODULE_22__packages_edituser_index_js__["a" /* default */]
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__um_comment__ = __webpack_require__(28);

__WEBPACK_IMPORTED_MODULE_0__um_comment__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__um_comment__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__um_comment__["a" /* default */]);
}; //注册组件
// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) { 
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__um_comment__["a" /* default */]);

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_comment_vue__ = __webpack_require__(3);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e7e185a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_comment_vue__ = __webpack_require__(32);
function injectStyle (ssrContext) {
  __webpack_require__(29)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e7e185a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_comment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e7e185a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_comment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(30);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("dbbe7eb6", content, true, {});

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".usercomments .commenttitle[data-v-0e7e185a]{border-left:3px solid #0e8de6;justify-content:space-between;font-size:18px;color:#444}.usercomments .commenttitle .ctitle[data-v-0e7e185a]{padding:0 6px;font-size:16px;font-weight:800}.usercomments .commenttitle .totalNumber[data-v-0e7e185a]{font-size:14px;color:#0e8de6}.usercomments .minecomments[data-v-0e7e185a]{margin:20px 0;box-sizing:border-box;display:flex}.usercomments .minecomments .cuseravatar[data-v-0e7e185a]{float:left;display:block;width:50px;margin-right:15px}.usercomments .othercomments[data-v-0e7e185a]{margin-top:20px}.usercomments .othercomments ul[data-v-0e7e185a]{border-top:1px solid #dcdcdc;padding:10px 0}.usercomments .othercomments ul li[data-v-0e7e185a]{border-bottom:1px dashed #dcdcdc;padding:10px 0}.usercomments .othercomments .left img[data-v-0e7e185a]{width:50px;height:50px;border-radius:50%;margin-right:15px}.usercomments .othercomments .right[data-v-0e7e185a]{width:calc(100% - 65px)}.usercomments .othercomments .right .replyname[data-v-0e7e185a]{margin-right:10px;font-size:14px;color:#0e8de6;display:inline-block;margin-bottom:10px}.usercomments .othercomments .right .replytime[data-v-0e7e185a]{font-size:14px;color:#999;display:inline-block;margin-bottom:10px}.usercomments .othercomments .right .replycontent[data-v-0e7e185a]{font-size:14px;color:#333;width:100%;margin-bottom:10px}.usercomments .othercomments .right .replyoperation[data-v-0e7e185a]{justify-content:space-between;margin-bottom:10px}.usercomments .othercomments .right .replyoperation .replyBtn[data-v-0e7e185a]{color:#3064ea;font-size:14px;margin-right:10px;cursor:pointer}.usercomments .othercomments .right .replyoperation .replynum[data-v-0e7e185a]{color:#999;margin-right:10px}.usercomments .othercomments .right .replyoperation .evaluation img[data-v-0e7e185a]{width:14px;height:14px}.usercomments .othercomments .right .replyoperation .evaluation div[data-v-0e7e185a]{color:#999;margin-left:10px;cursor:pointer}.usercomments .othercomments .right .replyoperation .evaluation span[data-v-0e7e185a]{margin-left:6px}.defaultAvatar[data-v-0e7e185a]{width:50px;height:50px;color:#fff;text-align:center;line-height:50px;border-radius:50%;font-size:14px;margin-right:15px;background:#0e8de6;opacity:.85}.block[data-v-0e7e185a]{text-align:center}.sendcommentdiv[data-v-0e7e185a]{border:1px solid #dcdcdc;border-radius:5px;position:relative;font-size:16px;color:#bababa;background:#fff;box-sizing:content-box;flex:1;min-height:40px;height:100%;overflow:hidden}.sendcommentdiv .input-wrap textarea[data-v-0e7e185a]{transition:all .4s}.sendcommentdiv .input-wrap .tafocus[data-v-0e7e185a]{width:100%;height:110px;border:0;resize:none;outline:none;padding:10px;color:#666}.sendcommentdiv .input-wrap .tanotfocus[data-v-0e7e185a]{display:block;font-size:16px;width:100%;height:40px;resize:none;border:0;outline:0;padding:10px;border:0 solid #dcdcdc}.sendcommentdiv .cbtnsdiv[data-v-0e7e185a]{position:absolute;bottom:0;right:0;padding:0;border:none;height:40px}.sendcommentdiv .cbtnsdiv .send[data-v-0e7e185a]{float:right;width:80px;height:40px;line-height:40px;text-align:center;font-size:14px;color:#fff;background:#0e8de6;cursor:pointer;border-radius:0 0 5px 0}.cbtnsdiv.focus[data-v-0e7e185a]{position:relative;background-color:#f4f5f6;bottom:0;right:0;padding:0;border:none;height:40px}.input-wrap.focus textarea[data-v-0e7e185a]{height:110px}", ""]);

// exports


/***/ }),
/* 31 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usercomments"},[_c('div',{staticClass:"commenttitle vCenter"},[_c('div',{staticClass:"ctitle"},[_vm._v("留下您的评论")]),_vm._v(" "),_c('div',{staticClass:"totalNumber"},[_c('span',[_vm._v(_vm._s(_vm.total))]),_vm._v("条评论")])]),_vm._v(" "),_c('div',{staticClass:"minecomments"},[_c('div',{staticClass:"cuseravatar"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.avatar==''||_vm.avatar==undefined),expression:"avatar==''||avatar==undefined"}],staticClass:"defaultAvatar useravatar50"},[_vm._v(_vm._s(_vm.getShortName(_vm.sumname)))]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.avatar!=''&&_vm.avatar!=undefined),expression:"avatar!=''&&avatar!=undefined"}],staticClass:"useravatar50",attrs:{"src":_vm.avatar,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"sendcommentdiv"},[_c('div',{class:[_vm.textareafocus ? 'input-wrap focus' : 'input-wrap']},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.usercomments),expression:"usercomments"}],class:[_vm.textareafocus ? 'tafocus' : 'tanotfocus'],attrs:{"name":"","placeholder":"写下您的评论..."},domProps:{"value":(_vm.usercomments)},on:{"focus":function($event){_vm.setTextAreaFocus(true)},"input":function($event){if($event.target.composing){ return; }_vm.usercomments=$event.target.value}}})]),_vm._v(" "),_c('div',{class:[_vm.textareafocus?'clearfix cbtnsdiv focus': 'clearfix cbtnsdiv']},[_c('div',{staticClass:"send fr",on:{"click":function($event){_vm.send()}}},[_vm._v("发送")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.total>0),expression:"total>0"}],staticClass:"commenttitle vCenter"},[_c('div',{staticClass:"ctitle"},[_vm._v("最新评论")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.total>0),expression:"total>0"}],staticClass:"othercomments"},[_c('ul',_vm._l((_vm.review),function(item){return _c('li',{key:item.sid,staticClass:"clearfix",attrs:{"data-dappuuid":item.dappuuid}},[_c('div',{staticClass:"fl left"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.avatar==''||item.avatar==undefined),expression:"item.avatar==''||item.avatar==undefined"}],staticClass:"defaultAvatar"},[_vm._v(_vm._s(_vm.getShortName(item.sumname)))]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(item.avatar!=''&&item.avatar!=undefined),expression:"item.avatar!=''&&item.avatar!=undefined"}],attrs:{"src":item.avatar,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"fl right"},[_c('div',[_c('span',{staticClass:"replyname"},[_vm._v(_vm._s(item.sumname))]),_vm._v(" "),_c('span',{staticClass:"replytime"},[_vm._v(_vm._s(item.createdate))])]),_vm._v(" "),_c('div',{staticClass:"replycontent"},[_vm._v("\n                        "+_vm._s(item.stext)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"replyoperation clearfix"},[_c('div',{staticClass:"fr"},[_c('div',{staticClass:"clearfix evaluation"},[_c('div',{staticClass:"fl vCenter",on:{"click":function($event){_vm.ding(item.sid)}}},[_c('img',{attrs:{"src":item.mineding=='1'? '/img/icon/zaned.png' : '/img/icon/zan.png',"alt":""}}),_vm._v(" "),(parseInt(item.dingcount)==0)?_c('span',[_vm._v("\n                                      赞\n                                    ")]):_c('span',[_vm._v("\n                                      "+_vm._s(parseInt(item.dingcount))+"\n                                    ")])]),_vm._v(" "),_c('div',{staticClass:"fl vCenter",on:{"click":function($event){_vm.cai(item.sid)}}},[_c('img',{attrs:{"src":item.minecai=='1'? '/img/icon/caied.png' : '/img/icon/cai.png',"alt":""}}),_vm._v(" "),(parseInt(item.caicount)==0)?_c('span',[_vm._v("\n                                      踩\n                                    ")]):_c('span',[_vm._v("\n                                      "+_vm._s(parseInt(item.caicount))+"\n                                    ")])])])])])])])}))]),_vm._v(" "),(_vm.totalpage!=0)?_c('div',{staticClass:"block"},[_c('el-pagination',{attrs:{"layout":"prev, pager, next","background":"","page-size":_vm.pagesize,"page-count":_vm.totalpage},on:{"current-change":function($event){_vm.changepage($event)}}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__um_img__ = __webpack_require__(34);

__WEBPACK_IMPORTED_MODULE_0__um_img__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__um_img__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__um_img__["a" /* default */]);
}; //注册组件
// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) { 
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__um_img__["a" /* default */]);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_img_vue__ = __webpack_require__(4);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2702735d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_img_vue__ = __webpack_require__(37);
function injectStyle (ssrContext) {
  __webpack_require__(35)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_img_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2702735d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_img_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(36);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("708d8e3f", content, true, {});

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".avatar-uploader .el-upload{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload:hover{border-color:#409eff}.avatar-uploader-icon{font-size:28px;color:#8c939d;width:178px;height:178px;line-height:178px!important;text-align:center}.avatar{width:178px;height:178px;display:block}", ""]);

// exports


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-upload',{staticClass:"avatar-uploader upimg",attrs:{"auto-upload":false,"show-file-list":false,"on-change":_vm.onChange,"on-remove":_vm.remove,"before-upload":_vm.beforeAvatarUpload,"drag":"","action":"#","name":"filename0"}},[(_vm.imageUrl)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.imageUrl}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__um_animate__ = __webpack_require__(39);

__WEBPACK_IMPORTED_MODULE_0__um_animate__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__um_animate__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__um_animate__["a" /* default */]);
}; //注册组件
// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) { 
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__um_animate__["a" /* default */]);

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_animate_vue__ = __webpack_require__(5);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4419f203_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_animate_vue__ = __webpack_require__(42);
function injectStyle (ssrContext) {
  __webpack_require__(40)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_animate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4419f203_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_animate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(41);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("6a6c3056", content, true, {});

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".anbox{top:-10%;animation:myfirst3 2.5s;animation-delay:1s;animation-iteration-count:infinite}.anbox,.anbox1{position:fixed;left:50%;text-align:center;z-index:999;width:200px}.anbox1{top:60%;animation:myfirst1 2.5s;animation-delay:1s;animation-iteration-count:infinite}.anboxclass1{animation:myfirst2 2.5s;animation-delay:2.5s;animation-iteration-count:infinite}.anboxclass{animation-name:boxanname1;animation-duration:1.5s;animation-delay:1s;animation-timing-function:cubic-bezier(0,0,0,0);animation-fill-mode:forwards;animation-iteration-count:infinite}.gildclass{position:absolute;width:5px;animation:myfirst 1.5s;animation-delay:1s;animation-timing-function:cubic-bezier(.14,-.2,1,.18);animation-fill-mode:forwards;animation-iteration-count:infinite}#anbox1{animation-name:boxanname1}#anbox1,#gild1{animation-delay:.5s}@keyframes myfirst{10%{width:15px}20%{width:25px}to{margin-top:1000px;width:40px;transform:rotateX(1500deg);opacity:0}}@keyframes myfirst1{0%{top:60%}50%{top:-10%}to{top:-10%}}@keyframes myfirst3{0%{top:-10%}50%{top:60%}to{top:60%}}@keyframes myfirst2{0%{transform:rotateY(0)}50%{transform:rotateY(1turn)}to{transform:rotateY(0)}}@keyframes boxanname1{to{margin-left:60%}}#anbox2{animation-name:boxanname2}#anbox2,#gild2{animation-delay:.7s}@keyframes boxanname2{to{margin-left:20%}}#anbox3{animation-name:boxanname3}#anbox3,#gild3{animation-delay:.8s}@keyframes boxanname3{to{margin-left:0}}#anbox4{animation-name:boxanname4}#anbox4,#gild4{animation-delay:.3s}@keyframes boxanname4{to{margin-left:-20%}}#anbox5{animation-name:boxanname5}#anbox5,#gild5{animation-delay:.3s}@keyframes boxanname5{to{margin-left:-60%}}", ""]);

// exports


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type==1||_vm.type==3)?_c('div',{staticClass:"anbox"},[_c('img',{staticClass:"anboxclass1",attrs:{"src":"/img/icon.png","alt":""}}),_vm._v(" "),_c('div',[_vm._v("+"+_vm._s(_vm.type==1?_vm.amount/1000000+'UMB':_vm.amount+'积分'))])]):_vm._e(),_vm._v(" "),(_vm.type==2||_vm.type==4)?_c('div',{staticClass:"anbox1"},[_c('img',{staticClass:"anboxclass1",attrs:{"src":"/img/icon.png","alt":""}}),_vm._v(" "),_c('div',[_vm._v("-"+_vm._s(_vm.type==2?_vm.amount/1000000+'UMB':_vm.amount+'积分'))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__um_list__ = __webpack_require__(44);

__WEBPACK_IMPORTED_MODULE_0__um_list__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__um_list__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__um_list__["a" /* default */]);
}; //注册组件
// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) { 
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__um_list__["a" /* default */]);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_list_vue__ = __webpack_require__(6);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23e654a4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_list_vue__ = __webpack_require__(47);
function injectStyle (ssrContext) {
  __webpack_require__(45)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23e654a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23e654a4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(46);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("254ac8ac", content, true, {});

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "ul[data-v-23e654a4]{padding:0 30px}ul li[data-v-23e654a4]{border-bottom:1px solid #dcdcdc;padding:20px 0}ul li .left[data-v-23e654a4]{width:190px;height:124px;margin-right:30px}ul li .left img[data-v-23e654a4]{width:100%;height:100%}ul li .mid .newsTitle[data-v-23e654a4]{font-size:20px;font-weight:700;color:#333;margin-bottom:10px;cursor:pointer}ul li .mid .synopsis[data-v-23e654a4]{margin-bottom:10px;font-size:16px;width:40vw;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}ul li .mid>div[data-v-23e654a4]{color:#999}ul li .mid>div>div[data-v-23e654a4]{margin-right:10px}ul li .mid>div .author[data-v-23e654a4]:after,ul li .mid>div .comments[data-v-23e654a4]:after,ul li .mid>div .praise[data-v-23e654a4]:after{content:\"\";display:inline-block;width:2px;height:2px;background:#999;border-radius:50%;margin-left:10px}ul li .mid>div .newsType[data-v-23e654a4]{font-size:14px;border:1px solid;border-radius:8px;padding:1px 8px}", ""]);

// exports


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.newsInfo),function(item){return _c('li',{staticClass:"vCenter",attrs:{"data-url":item.newsid}},[_c('div',{staticClass:"left"},[(item.cover)?_c('img',{attrs:{"src":item.cover,"alt":""}}):(!item.cover)?_c('div',{staticClass:"defaultcover"},[_vm._v("\n              默 认\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"mid"},[_c('div',{staticClass:"newsTitle",on:{"click":function($event){_vm.showDeatil(item)}}},[_vm._v("\n                "+_vm._s(item.newscaption)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"synopsis"},[_vm._v("\n              "+_vm._s(item.synopsis)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"vCenter"},[_c('div',{staticClass:"newsType"},[_vm._v("\n                "+_vm._s(item.typename)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"author vCenter"},[_vm._v("\n                "+_vm._s(item.sumname)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"praise vCenter"},[_vm._v("\n                "+_vm._s(item.praisecount)+"赞\n              ")]),_vm._v(" "),_c('div',{staticClass:"comments vCenter"},[_vm._v("\n                "+_vm._s(item.reviewcount)+"评论\n              ")]),_vm._v(" "),_c('div',{staticClass:"time"},[_vm._v("  \n                "+_vm._s(item.createdate)+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"right"})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__um_attachment__ = __webpack_require__(49);

__WEBPACK_IMPORTED_MODULE_0__um_attachment__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__um_attachment__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__um_attachment__["a" /* default */]);
}; //注册组件
// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) { 
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__um_attachment__["a" /* default */]);

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_attachment_vue__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f5704e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_attachment_vue__ = __webpack_require__(52);
function injectStyle (ssrContext) {
  __webpack_require__(50)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39f5704e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_attachment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f5704e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_attachment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(51);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("b506d214", content, true, {});

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-upload',{staticClass:"upload-demo",attrs:{"auto-upload":false,"on-remove":_vm.remove,"on-change":_vm.onChange,"drag":"","limit":1,"on-exceed":_vm.handleExceed,"name":"filename0","file-list":_vm.fileList}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("\n      将文件拖到此处，或\n      "),_c('em',[_vm._v("点击上传")]),_vm._v("，大小不能超过 100MB\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__um_selectuser__ = __webpack_require__(54);

__WEBPACK_IMPORTED_MODULE_0__um_selectuser__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__um_selectuser__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__um_selectuser__["a" /* default */]);
}; //注册组件
// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) { 
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__um_selectuser__["a" /* default */]);

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_selectuser_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_629dab76_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_selectuser_vue__ = __webpack_require__(57);
function injectStyle (ssrContext) {
  __webpack_require__(55)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_selectuser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_629dab76_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_selectuser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(56);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("a7688324", content, true, {});

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".choosepeople{height:100%;width:100%;overflow:auto}.choosepeople::-webkit-scrollbar-track{background-color:#f5f5f5;-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.22)}.choosepeople::-webkit-scrollbar{display:block;width:7px;background-color:hsla(220,4%,58%,.3)}.choosepeople::-webkit-scrollbar-thumb{background-color:#8b8b8b;border-radius:7px}@media (max-width:750px){.choosepeople{width:100%;height:100%}}.choosepeople .el-tree>.el-tree-node>.el-tree-node__content>.el-checkbox{display:none}", ""]);

// exports


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"choosepeople"},[_vm._v("\n  总人数："+_vm._s(_vm.checkArray.length)+"\n  "),_c('el-input',{attrs:{"placeholder":"输入关键字进行过滤"},model:{value:(_vm.filterText),callback:function ($$v) {_vm.filterText=$$v},expression:"filterText"}}),_vm._v(" "),_c('el-tree',{ref:"tree",attrs:{"props":_vm.props1,"load":_vm.loadNode1,"filter-node-method":_vm.filterNode,"lazy":"","node-key":"id","show-checkbox":""},on:{"check":_vm.handleCheckChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__um_dialog__ = __webpack_require__(59);

__WEBPACK_IMPORTED_MODULE_0__um_dialog__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__um_dialog__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__um_dialog__["a" /* default */]);
}; //注册组件
// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) { 
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__um_dialog__["a" /* default */]);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_dialog_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17dd3e59_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_dialog_vue__ = __webpack_require__(62);
function injectStyle (ssrContext) {
  __webpack_require__(60)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_dialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17dd3e59_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_dialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(61);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("30dd4208", content, true, {});

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".mask1{width:100vw;height:100vh;background:#000;position:fixed;top:0;left:0;opacity:.4;z-index:1000}.dialog1{height:auto;background:#fff;position:fixed;z-index:1001;border-radius:3px;overflow:hidden}.dialog1_head{width:100%;height:30px;background:var(--theme-color);opacity:.85;padding:0 10px;line-height:30px;color:#fff;cursor:move;position:relative}.dialog1_head span{margin-left:10px}.dialog1_content{width:100%}.dialog1_content #ext1,.dialog1_content iframe{width:100%;height:100%;overflow:auto}#ext1::-webkit-scrollbar-thumb{border-radius:5px;-webkit-box-shadow:inset 0 0 5px rgba(0,0,0,.1);background:hsla(0,0%,60%,.5);width:8px}#ext1::-webkit-scrollbar{width:8px;height:1px;display:block}.dialog1_head .closebtn{position:absolute;right:10px;top:50%;transform:translateY(-50%);cursor:pointer;width:11px;height:11px;background-image:url(\"/img/icongroup.png\");background-position:0 22px;background-size:cover}#maximize{right:60px;background-position:0 -16px}#minimize{right:90px;background-position:0 16px}.home-contanier{position:relative}.popup-footer{height:45px;text-align:center;padding:0 20px}.popup-footer button{width:70px;height:30px;text-align:center;color:#fff;background:#2e9cf1;border:0;border-radius:2px}.popup-footer button.confirm{border:1px solid var(--theme-color);background:var(--theme-color)}.popup-footer button.cancel{border:1px solid #d9d9d9;color:#666;background:#fff;margin-left:20px}.popup-content{padding:20px;overflow:auto}.popup-content::-webkit-scrollbar-thumb{border-radius:5px;-webkit-box-shadow:inset 0 0 5px rgba(0,0,0,.1);background:hsla(0,0%,60%,.5)}.popup-content::-webkit-scrollbar{width:8px;height:1px;display:block}", ""]);

// exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[_c('div',{staticClass:"mask1",attrs:{"id":"mask1"}}),_vm._v(" "),_c('div',{ref:"dialog",staticClass:"dialog1",attrs:{"id":"dialog1"}},[_c('div',{staticClass:"dialog1_head move_part1",attrs:{"id":"move_part1"}},[_c('span'),_vm._v(" "),_c('i',{staticClass:"closebtn",attrs:{"id":"close closebtn","title":"关闭"},on:{"click":_vm.close}})]),_vm._v(" "),_c('div',{staticClass:"dialog1_content"},[_c('div',{staticClass:"ext1",attrs:{"id":"ext1"}},[_vm._t("default",[_vm._v("\n              使用slot占位\n              ")])],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__um_addlist__ = __webpack_require__(64);

__WEBPACK_IMPORTED_MODULE_0__um_addlist__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__um_addlist__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__um_addlist__["a" /* default */]);
}; //注册组件
// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) { 
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__um_addlist__["a" /* default */]);

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_addlist_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_481c2ad0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_addlist_vue__ = __webpack_require__(72);
function injectStyle (ssrContext) {
  __webpack_require__(65)
  __webpack_require__(67)
  __webpack_require__(69)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-481c2ad0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_addlist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_481c2ad0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_addlist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(66);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("613fa6ca", content, true, {});

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "#group[data-v-481c2ad0]{width:100%;height:100%}#group>div[data-v-481c2ad0]{width:100%;min-height:100%;padding:20px}#group .user[data-v-481c2ad0]{padding:0;background:#f7f7f7}#group .user .adduserTop[data-v-481c2ad0]{border-bottom:1px solid #ededed;padding:20px 0 30px;background:#fff;text-align:center}#group .user .adduserTop ul[data-v-481c2ad0]{display:inline-block}#group .user .adduserTop ul li[data-v-481c2ad0]{font-size:16px;color:#666;margin-right:60px;cursor:pointer}#group .user .adduserTop ul li[data-v-481c2ad0]:last-child{margin-right:0}#group .user .adduserTop ul .active[data-v-481c2ad0]{color:#2e9cf1}#group .user .adduserTop .addusersearch[data-v-481c2ad0]{margin-top:20px}#group .user .adduserTop .addusersearch input[data-v-481c2ad0]{height:36px;width:50%;border:1px solid #dcdcdc;margin-right:30px;border-radius:18px;padding:0 15px}#group .user .adduserTop .addusersearch button[data-v-481c2ad0]{width:70px;height:30px;background:#2e9cf1;border-radius:3px;color:#fff;border:0;cursor:pointer}#group .user .adduserBottom[data-v-481c2ad0]{padding:0 20px}#group .user .adduserBottom>div[data-v-481c2ad0]{color:#000;font-size:14px;margin:10px 0}#group .user .adduserBottom ul li[data-v-481c2ad0]{width:100%;float:left;position:relative;background:#fff;padding:10px;display:flex}#group .user .adduserBottom ul li>div[data-v-481c2ad0]:first-child{width:70px}#group .user .adduserBottom ul li>div[data-v-481c2ad0]:last-child{flex:1}#group .user .adduserBottom ul li .icon[data-v-481c2ad0]{position:absolute;top:0;right:0}#group .user .adduserBottom ul li .iconfont[data-v-481c2ad0]{display:none}#group .user .adduserBottom ul li #rightList[data-v-481c2ad0]{position:absolute;background:#fff;right:0;z-index:999;width:140px;border-radius:4px;box-shadow:0 0 10px 0 rgba(0,0,0,.2);padding:6px 0;top:30px}#group .user .adduserBottom ul li #rightList img[data-v-481c2ad0]{width:14px;height:15px;margin-top:7px;margin-right:10px}#group .user .adduserBottom ul li #rightList li[data-v-481c2ad0]{height:30px;line-height:30px;padding:0 13px;border-bottom:0}#group .user .adduserBottom ul li #rightList[data-v-481c2ad0] :hover{background:#edebea}#group .user .adduserBottom ul li .avatar[data-v-481c2ad0]{height:60px;width:60px;border-radius:50%;text-align:center;line-height:60px;color:#fff;font-size:16px;margin-right:10px}#group .user .adduserBottom ul li .info[data-v-481c2ad0]{height:70px}#group .user .adduserBottom ul li .info .sumname[data-v-481c2ad0]{font-size:14px;color:#000;margin-bottom:4px;max-width:80px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}#group .user .adduserBottom ul li .info .job[data-v-481c2ad0]{color:#999;font-size:12px;margin-left:10px;max-width:100px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}#group .user .adduserBottom ul li .info .company[data-v-481c2ad0],#group .user .adduserBottom ul li .info .sphone[data-v-481c2ad0]{font-size:12px;color:#000;margin-bottom:5px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;/*! autoprefixer: off */-webkit-box-orient:vertical;-webkit-line-clamp:2}#group .user .adduserBottom ul li .buttongroup button[data-v-481c2ad0]{width:70px;height:20px;background:#fff;border-radius:3px;font-size:12px;color:#2e9cf1;text-align:left;line-height:18px;border:0;cursor:pointer}#group .user .adduserBottom ul li .buttongroup button[data-v-481c2ad0]:last-child{margin-right:0}#group .user .adduserBottom ul li:hover .iconfont[data-v-481c2ad0]{display:inline-block}#group .groupleft[data-v-481c2ad0],#group .groupright[data-v-481c2ad0]{width:50%;height:100%;padding:10px 20px}#group .groupleft .rightBox[data-v-481c2ad0],#group .groupright .rightBox[data-v-481c2ad0]{height:50%;padding:10px 0}#group .groupleft .rightBox[data-v-481c2ad0]:last-child,#group .groupright .rightBox[data-v-481c2ad0]:last-child{border-top:1px solid #dcdcdc}#group .groupleft[data-v-481c2ad0]{border-right:1px solid #dcdcdc}.validation .desname[data-v-481c2ad0]{margin-top:20px}.sendMsg div[data-v-481c2ad0]{margin-bottom:10px;color:#666}.chooselist li[data-v-481c2ad0]{margin:0 10px 10px 0;position:relative}.chooselist li img[data-v-481c2ad0]{width:40px;height:40px;border-radius:50%;overflow:hidden}.chooselist li .selectcolor[data-v-481c2ad0]{position:absolute;width:16px;height:16px;bottom:0;right:0}.chooselist li[data-v-481c2ad0]:first-child{border-radius:0}.logopath[data-v-481c2ad0]{width:80px;height:80px;border-radius:50%;overflow:hidden;cursor:pointer}.listtitle[data-v-481c2ad0]{justify-content:space-between}.listtitle .refresh[data-v-481c2ad0]{color:#999;font-size:12px;display:inline-block;margin-left:20px;cursor:pointer}.adduser[data-v-481c2ad0]{font-size:16px;color:#999;width:80px;height:32px;border:1px solid #ccc;border-radius:4px;text-align:center;line-height:30px;cursor:pointer;display:inline-block}.center[data-v-481c2ad0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.searchuserlists[data-v-481c2ad0]{min-height:calc(54vh - 120px)}", ""]);

// exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(68);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("65a7e579", content, true, {});

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".addlist .el-dialog__body{padding:0}.validation .el-dialog__body{height:auto}.addlist .avatar-uploader.upimg{width:40px;height:40px}.addlist .upimg .el-upload-dragger{height:38px;width:38px}.addlist .upimg .el-upload-dragger img{height:40px}.addlist .avatar-uploader-icon{width:36px;height:36px;line-height:36px!important}.dapp .el-input,.newappname .el-input,.newauthor .el-input{width:100%;margin-right:20px}.adduserBottom .el-row .el-col{padding:10px!important}", ""]);

// exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(70);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("6d473d88", content, true, {});

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".newview[data-v-481c2ad0]{border:1px solid #ddf;margin:10px;padding:10px}.newsubmitdiv[data-v-481c2ad0]{width:120px;margin:10px auto}.hptitlelab[data-v-481c2ad0]{word-break:keep-all;width:80px}#city[data-v-481c2ad0],#district[data-v-481c2ad0],#province[data-v-481c2ad0]{padding:.5rem .75rem;height:40px;font-size:1rem;line-height:1.25;color:#464a4c;background-color:#fff;background-image:none;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem;-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;float:left;margin-right:10px}.newappname .el-input[data-v-481c2ad0],.newauthor .el-input[data-v-481c2ad0]{width:50%;margin-right:20px}", ""]);

// exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return search; });
/* unused harmony export setCenter */
/* unused harmony export setad */
var map,
    district,
    polygons = [],
    customClass = '',
    lng = "",
    lat = "",
    citycode;
// var document.getElementById("city") = document.getElementById("city");
// var document.getElementById("district") = document.getElementById("district");
function mm(c, setstatus, setad1) {
  customClass = c;
  map = new AMap.Map("container", {
    resizeEnable: true
  });
  AMap.plugin('AMap.Geolocation', function () {
    var geolocation = new AMap.Geolocation({
      enableHighAccuracy: true, //是否使用高精度定位，默认:true
      timeout: 30000, //超过10秒后停止定位，默认：5s
      buttonPosition: 'RB', //定位按钮的停靠位置
      buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
      zoomToAccuracy: true //定位成功后是否自动调整地图视野到定位点

    });
    map.addControl(geolocation);
    geolocation.getCurrentPosition(function (status, result) {
      if (status == 'complete') {
        lat = result.position.lat;
        lng = result.position.lng;
        //行政区划查询
        var opts = {
          subdistrict: 1, //返回下一级行政区
          showbiz: false //最后一级返回街道信息
        };
        district = new AMap.DistrictSearch(opts); //注意：需要使用插件同步下发功能才能这样直接使用
        if (setstatus) {
          setad(setad1);
        } else {
          $.ajax({
            url: "https://restapi.amap.com/v3/geocode/regeo?key=87afac9139f5f9b1e21d361fa9849b6a&location=" + lng + "," + lat + "&radius=1000&extensions=all&batch=false&roadlevel=0",
            async: false,
            success: function success(data) {
              district.search("中国", function (status, result) {
                if (status == "complete") {
                  getData(result.districtList[0], "province");
                  $("." + customClass + " #province").find("option:contains(" + data.regeocode.addressComponent.province + ")").attr("selected", true);
                  district.search(data.regeocode.addressComponent.province, function (status, result) {
                    if (status === "complete") {
                      console.log(result.districtList[0]);
                      getData(result.districtList[0], "city");
                      $("." + customClass + " #city").find("option:contains(" + data.regeocode.addressComponent.city + ")").attr("selected", true);
                      district.search(data.regeocode.addressComponent.city, function (status, result) {
                        if (status === "complete") {
                          getData(result.districtList[0], "district");
                          $("." + customClass + " #district").find("option:contains(" + data.regeocode.addressComponent.district + ")").attr("selected", true);
                        }
                      });
                    }
                  });
                }
              });
            }
          });
        }
      } else {}
    });
  });
}
function setad(data) {
  //行政区划查询
  var opts = {
    subdistrict: 1, //返回下一级行政区
    showbiz: false //最后一级返回街道信息
  };
  district = new AMap.DistrictSearch(opts); //注意：需要使用插件同步下发功能才能这样直接使用
  district.search("中国", function (status, result) {
    if (status == "complete") {
      getData(result.districtList[0], "province");
      $("." + customClass + " #province").find("option:contains(" + data.province + ")").attr("selected", true);
      district.search(data.province, function (status, result) {
        if (status === "complete") {
          getData(result.districtList[0], "city");
          $("." + customClass + " #city").find("option:contains(" + data.city + ")").attr("selected", true);
          district.search(data.city, function (status, result) {
            if (status === "complete") {
              getData(result.districtList[0], "district");
              $("." + customClass + " #district").find("option:contains(" + data.district + ")").attr("selected", true);
            }
          });
        }
      });
    }
  });
}
function getData(data, level) {
  var bounds = data.boundaries;
  if (bounds) {
    for (var i = 0, l = bounds.length; i < l; i++) {
      var polygon = new AMap.Polygon({
        map: map,
        strokeWeight: 1,
        strokeColor: "#0091ea",
        fillColor: "#80d8ff",
        fillOpacity: 0.2,
        path: bounds[i]
      });
      polygons.push(polygon);
    }
    map.setFitView(); //地图自适应
  }

  //清空下一级别的下拉列表
  if (level === "province") {
    document.getElementById("city").innerHTML = "";
    document.getElementById("district").innerHTML = "";
    // areaSelect.innerHTML = "";
  } else if (level === "city") {
    document.getElementById("district").innerHTML = "";
    // areaSelect.innerHTML = "";
  } else if (level === "district") {
    // areaSelect.innerHTML = "";
  }

  var subList = data.districtList;
  if (subList && subList[0].level != "street") {
    var contentSub;
    var curlevel = subList[0].level;
    console.log(99999, document.querySelector("." + customClass + " #" + curlevel));
    document.querySelector("." + customClass + " #" + curlevel).innerHTML = '';
    var curList = document.querySelector("." + customClass + " #" + curlevel);
    // curList.add(contentSub);
    for (var i = 0, l = subList.length; i < l; i++) {
      var name = subList[i].name;
      var levelSub = subList[i].level;
      var cityCode = subList[i].citycode;
      contentSub = new Option(name);
      contentSub.setAttribute("value", levelSub);
      contentSub.center = subList[i].center;
      contentSub.adcode = subList[i].adcode;
      curList.add(contentSub);
    }
  }
  // if(subList && subList[0].level == "city"){
  //   var data=document.querySelector("."+customClass+" #city")
  //   console.log(78787878,data)
  //   search(data)
  // }
}
function search(obj) {
  //清除地图上所有覆盖物
  for (var i = 0, l = polygons.length; i < l; i++) {
    polygons[i].setMap(null);
  }
  var option = obj[obj.options.selectedIndex];
  console.log(777777, option);

  var keyword = option.text; //关键字
  var adcode = option.adcode;
  district.setLevel(option.value); //行政区级别
  district.setExtensions("all");
  //行政区查询
  //按照adcode进行查询可以保证数据返回的唯一性
  district.search(adcode, function (status, result) {
    if (status === "complete") {
      getData(result.districtList[0], obj.id);
    }
  });
}
function setCenter(obj) {
  map.setCenter(obj[obj.options.selectedIndex].center);
}


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"container"}}),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.groupTitle,"visible":_vm.addDailog,"width":"61.8%","custom-class":("addlist " + _vm.customClass),"close-on-click-modal":false,"close-on-press-escape":true},on:{"update:visible":function($event){_vm.addDailog=$event},"closed":function($event){_vm.closenew()}}},[_c('div',{attrs:{"id":"group"}},[(_vm.createtype=='user')?_c('div',{staticClass:"user"},[_c('div',{staticClass:"adduserTop"},[(!_vm.unionStatus)?_c('ul',{staticClass:"clearfix"},_vm._l((_vm.squaretab),function(item){return _c('li',{class:['fl',{'active':item.id==_vm.tabactiveid}],on:{"click":function($event){_vm.changetab(item.id)}}},[_vm._v(_vm._s(item.name))])})):_vm._e(),_vm._v(" "),_c('div',{staticClass:"addusersearch"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],attrs:{"type":"text","placeholder":_vm.unionStatus?'请输入搜索内容':'请输入手机号/UMID/昵称'},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchfriends($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{on:{"click":_vm.searchfriends}},[_vm._v("搜索")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabactiveid==0&&!_vm.searchBoxshow&&!_vm.unionStatus),expression:"tabactiveid==0&&!searchBoxshow&&!unionStatus"}],staticClass:"searchuserlists",style:({'height':_vm.height2-60-_vm.squaresearch+'px'})},_vm._l((_vm.squarelist),function(item,index){return (_vm.squarelist[index].list.length>0)?_c('div',{staticClass:"adduserBottom"},[_c('div',{staticClass:"listtitle vCenter"},[_c('span',[_vm._v(_vm._s(item.name))]),_vm._v(" "),(_vm.squarelist[index].shownum<=8&&item.list.length>8)?_c('span',{staticClass:"refresh",on:{"click":function($event){_vm.squarelistmore(item.id)}}},[_vm._v("更多")]):_vm._e(),_vm._v(" "),(_vm.squarelist[index].shownum>8&&item.list.length>8)?_c('span',{staticClass:"refresh",on:{"click":function($event){_vm.squarelistmore(item.id)}}},[_vm._v("收起")]):_vm._e()]),_vm._v(" "),_c('ul',[_c('el-row',{attrs:{"gutter":10}},_vm._l((item.list.slice(0,item.shownum)),function(m,index){return _c('el-col',{key:index,attrs:{"xs":24,"sm":12,"md":12,"lg":8,"xl":8}},[_c('li',{staticClass:"clearfix"},[_c('div',{staticClass:"fl"},[(m.avatar)?_c('img',{staticClass:"fr avatar",attrs:{"src":m.avatar,"alt":""}}):_vm._e(),_vm._v(" "),(!m.avatar)?_c('div',{staticClass:"defaultAvatar fr avatar"},[_vm._v(_vm._s(_vm.avaname(m.sumname)))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fl"},[_c('div',{staticClass:"info"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"sumname fl"},[_vm._v(_vm._s(m.sumname))]),_vm._v(" "),_c('div',{staticClass:"job fl"},[_vm._v(_vm._s(m.job))])]),_vm._v(" "),(!m.isfriend)?_c('div',{staticClass:"sphone"},[_vm._v(_vm._s(_vm.hidenum(m.sphone)))]):_vm._e(),_vm._v(" "),(m.isfriend)?_c('div',{staticClass:"sphone"},[_vm._v(_vm._s(m.sphone))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"company"},[_vm._v(_vm._s(m.company))])]),_vm._v(" "),_c('div',{staticClass:"buttongroup"},[(!m.isfriend)?_c('button',{on:{"click":function($event){_vm.openchat(m,1,m)}}},[_vm._v("打招呼")]):_vm._e(),_vm._v(" "),(m.isfriend)?_c('button',{on:{"click":function($event){_vm.openchat(m,1,m)}}},[_vm._v("发消息")]):_vm._e(),_vm._v(" "),(!m.isfriend)?_c('button',{on:{"click":function($event){_vm.addfriend(m.umid,m,m)}}},[_vm._v("加好友")]):_vm._e(),_vm._v(" "),(m.isfriend)?_c('button',[_vm._v("好友")]):_vm._e()])])])])}))],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.shownum<=20&&item.shownum>8),expression:"item.shownum<=20&&item.shownum>8"}],staticStyle:{"text-align":"center"}},[_c('el-pagination',{directives:[{name:"show",rawName:"v-show",value:(item.total>1),expression:"item.total>1"}],attrs:{"layout":"prev, pager, next","page-count":item.total},on:{"current-change":function($event){_vm.sizeChange($event,item.id)},"click":_vm.aaaa}})],1)]):_vm._e()})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabactiveid==1&&!_vm.searchBoxshow&&!_vm.unionStatus),expression:"tabactiveid==1&&!searchBoxshow&&!unionStatus"}],staticClass:"searchuserlists",style:({'height':_vm.height2-60-_vm.squaresearch+'px'})},_vm._l((_vm.squarelist1),function(item,index){return (_vm.squarelist1[index].list.length>0)?_c('div',{staticClass:"adduserBottom"},[_c('div',{staticClass:"listtitle vCenter"},[_c('span',[_vm._v(_vm._s(item.name))]),_vm._v(" "),(_vm.squarelist1[index].shownum<=8&&item.list.length>8)?_c('span',{staticClass:"refresh",on:{"click":function($event){_vm.squarelistmore1(item.id)}}},[_vm._v("更多")]):_vm._e(),_vm._v(" "),(_vm.squarelist1[index].shownum>8&&item.list.length>8)?_c('span',{staticClass:"refresh",on:{"click":function($event){_vm.squarelistmore1(item.id)}}},[_vm._v("收起")]):_vm._e()]),_vm._v(" "),_c('ul',[_c('el-row',{attrs:{"gutter":10}},_vm._l((item.list.slice(0,item.shownum)),function(m,index){return _c('el-col',{key:index,attrs:{"xs":24,"sm":12,"md":12,"lg":8,"xl":8}},[_c('li',{staticClass:"clearfix"},[_c('div',{staticClass:"fl"},[(m.companylogo)?_c('img',{staticClass:"fr avatar",attrs:{"src":m.companylogo,"alt":""}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fl"},[_c('div',{staticClass:"info"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"sumname fl",staticStyle:{"max-width":"100%"}},[_vm._v(_vm._s(m.orgname))])]),_vm._v(" "),_c('div',{staticClass:"company"},[_vm._v(_vm._s(m.companydesc))])]),_vm._v(" "),_c('div',{staticClass:"buttongroup"},[(!m.inroom)?_c('button',{on:{"click":function($event){_vm.openchat(m,1,m.umidinfo)}}},[_vm._v("联系管理")]):_vm._e(),_vm._v(" "),(!m.inroom)?_c('button',{on:{"click":function($event){_vm.applyorg(m.orgid)}}},[_vm._v("申请加入")]):_vm._e(),_vm._v(" "),(m.inroom)?_c('button',[_vm._v("已加入")]):_vm._e()])])])])}))],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.shownum<=20&&item.shownum>8),expression:"item.shownum<=20&&item.shownum>8"}],staticStyle:{"text-align":"center"}},[_c('el-pagination',{directives:[{name:"show",rawName:"v-show",value:(item.total>1),expression:"item.total>1"}],attrs:{"layout":"prev, pager, next","page-count":item.total},on:{"current-change":function($event){_vm.sizeChange1($event,item.id)},"click":_vm.aaaa}})],1)]):_vm._e()})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabactiveid==2&&!_vm.searchBoxshow&&!_vm.unionStatus),expression:"tabactiveid==2&&!searchBoxshow&&!unionStatus"}],staticClass:"searchuserlists",style:({'height':_vm.height2-60-_vm.squaresearch+'px'})},_vm._l((_vm.squarelist2),function(item,index){return (_vm.squarelist2[index].list.length>0)?_c('div',{staticClass:"adduserBottom"},[_c('div',{staticClass:"listtitle vCenter"},[_c('span',[_vm._v(_vm._s(item.name))]),_vm._v(" "),(_vm.squarelist2[index].shownum<=8&&item.list.length>8)?_c('span',{staticClass:"refresh",on:{"click":function($event){_vm.squarelistmore2(item.id)}}},[_vm._v("更多")]):_vm._e(),_vm._v(" "),(_vm.squarelist2[index].shownum>8&&item.list.length>8)?_c('span',{staticClass:"refresh",on:{"click":function($event){_vm.squarelistmore2(item.id)}}},[_vm._v("收起")]):_vm._e()]),_vm._v(" "),_c('ul',[_c('el-row',{attrs:{"gutter":10}},_vm._l((item.list.slice(0,item.shownum)),function(m,index){return _c('el-col',{key:index,attrs:{"xs":24,"sm":12,"md":12,"lg":8,"xl":8}},[_c('li',{staticClass:"clearfix"},[_c('div',{staticClass:"fl"},[(m.logopath)?_c('img',{staticClass:"fr avatar",attrs:{"src":m.logopath,"alt":""}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fl"},[_c('div',{staticClass:"info"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"sumname fl",staticStyle:{"max-width":"100%"}},[_vm._v(_vm._s(m.roomname))])]),_vm._v(" "),_c('div',{staticClass:"company"},[_vm._v(_vm._s(m.roomremark))])]),_vm._v(" "),_c('div',{staticClass:"buttongroup"},[(!m.inroom)?_c('button',{on:{"click":function($event){_vm.openchat(m,1,m.umidinfo)}}},[_vm._v("联系群主")]):_vm._e(),_vm._v(" "),(m.inroom)?_c('button',{on:{"click":function($event){_vm.openchatroom(m)}}},[_vm._v("发消息")]):_vm._e(),_vm._v(" "),(!m.inroom)?_c('button',{on:{"click":function($event){_vm.applygroup(m.roomid)}}},[_vm._v("申请加入")]):_vm._e(),_vm._v(" "),(m.inroom)?_c('button',[_vm._v("已加入")]):_vm._e()])])])])}))],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.shownum<=20&&item.shownum>8),expression:"item.shownum<=20&&item.shownum>8"}],staticStyle:{"text-align":"center"}},[_c('el-pagination',{directives:[{name:"show",rawName:"v-show",value:(item.total>1),expression:"item.total>1"}],attrs:{"layout":"prev, pager, next","page-count":item.total},on:{"current-change":function($event){_vm.sizeChange2($event,item.id)},"click":_vm.aaaa}})],1)]):_vm._e()})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.unionStatus&&!_vm.searchBoxshow),expression:"unionStatus&&!searchBoxshow"}],staticClass:"searchuserlists defaultPart center vCenter"},[_c('div',[_c('img',{attrs:{"src":"/img/setting/default.png","alt":""}}),_vm._v(" "),_c('div',[_vm._v("请输入组织名称进行搜索 ...")])])]),_vm._v(" "),(_vm.searchBoxshow)?_c('div',{staticClass:"searchuserlists",style:({'height':_vm.height2-60-_vm.squaresearch+'px'})},[(_vm.tabactiveid==0&&!_vm.unionStatus)?_c('div',{staticClass:"adduserBottom"},[_c('div',{staticClass:"listtitle"},[_vm._v("找到"+_vm._s(_vm.searchuserlist.length)+"人")]),_vm._v(" "),_c('ul',[_c('el-row',{attrs:{"gutter":10}},_vm._l((_vm.searchuserlist),function(m,index){return _c('el-col',{key:index,attrs:{"xs":24,"sm":12,"md":12,"lg":8,"xl":8}},[_c('li',{staticClass:"clearfix"},[_c('div',{staticClass:"fl"},[(m.avatar)?_c('img',{staticClass:"fr avatar",attrs:{"src":m.avatar,"alt":""}}):_vm._e(),_vm._v(" "),(!m.avatar)?_c('div',{staticClass:"defaultAvatar fr avatar"},[_vm._v(_vm._s(_vm.avaname(m.sumname)))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fl"},[_c('div',{staticClass:"info"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"sumname fl"},[_vm._v(_vm._s(m.sumname))]),_vm._v(" "),_c('div',{staticClass:"job fl"},[_vm._v(_vm._s(m.job))])]),_vm._v(" "),(!m.isfriend)?_c('div',{staticClass:"sphone"},[_vm._v(_vm._s(_vm.hidenum(m.sphone)))]):_vm._e(),_vm._v(" "),(m.isfriend)?_c('div',{staticClass:"sphone"},[_vm._v(_vm._s(m.sphone))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"company"},[_vm._v(_vm._s(m.company))])]),_vm._v(" "),_c('div',{staticClass:"buttongroup"},[(!m.isfriend)?_c('button',{on:{"click":function($event){_vm.openchat(m,1,m)}}},[_vm._v("打招呼")]):_vm._e(),_vm._v(" "),(m.isfriend)?_c('button',{on:{"click":function($event){_vm.openchat(m,1,m)}}},[_vm._v("发消息")]):_vm._e(),_vm._v(" "),(!m.isfriend)?_c('button',{on:{"click":function($event){_vm.addfriend(m.umid,m,m)}}},[_vm._v("加好友")]):_vm._e(),_vm._v(" "),(m.isfriend)?_c('button',[_vm._v("好友")]):_vm._e()])])])])}))],1)]):_vm._e(),_vm._v(" "),(_vm.tabactiveid==1&&!_vm.unionStatus)?_c('div',{staticClass:"adduserBottom"},[_c('div',{staticClass:"listtitle"},[_vm._v("找到"+_vm._s(_vm.searchuserlist.length)+"个组织")]),_vm._v(" "),_c('ul',[_c('el-row',{attrs:{"gutter":10}},_vm._l((_vm.searchuserlist),function(m,index){return _c('el-col',{key:index,attrs:{"xs":24,"sm":12,"md":12,"lg":8,"xl":8}},[_c('li',{staticClass:"clearfix"},[_c('div',{staticClass:"fl"},[(m.companylogo)?_c('img',{staticClass:"fr avatar",attrs:{"src":m.companylogo,"alt":""}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fl"},[_c('div',{staticClass:"info"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"sumname fl",staticStyle:{"max-width":"100%"}},[_vm._v(_vm._s(m.orgname))])]),_vm._v(" "),_c('div',{staticClass:"company"},[_vm._v(_vm._s(m.companydesc))])]),_vm._v(" "),_c('div',{staticClass:"buttongroup"},[(!m.inorg)?_c('button',{on:{"click":function($event){_vm.openchat(m,1,m.umidinfo)}}},[_vm._v("联系管理")]):_vm._e(),_vm._v(" "),(!m.inorg)?_c('button',{on:{"click":function($event){_vm.applyorg(m.orgid)}}},[_vm._v("申请加入")]):_vm._e(),_vm._v(" "),(m.inorg)?_c('button',[_vm._v("已加入")]):_vm._e()])])])])}))],1)]):_vm._e(),_vm._v(" "),(_vm.tabactiveid==2&&!_vm.unionStatus)?_c('div',{staticClass:"adduserBottom"},[_c('div',{staticClass:"listtitle"},[_vm._v("找到"+_vm._s(_vm.searchuserlist.length)+"个群")]),_vm._v(" "),_c('ul',[_c('el-row',{attrs:{"gutter":10}},_vm._l((_vm.searchuserlist),function(m,index){return _c('el-col',{key:index,attrs:{"xs":24,"sm":12,"md":12,"lg":8,"xl":8}},[_c('li',{staticClass:"clearfix"},[_c('div',{staticClass:"fl"},[(m.logopath)?_c('img',{staticClass:"fr avatar",attrs:{"src":m.logopath,"alt":""}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fl"},[_c('div',{staticClass:"info"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"sumname fl",staticStyle:{"max-width":"100%"}},[_vm._v(_vm._s(m.roomname))])]),_vm._v(" "),_c('div',{staticClass:"company"},[_vm._v(_vm._s(m.roomremark))])]),_vm._v(" "),_c('div',{staticClass:"buttongroup"},[(!m.inroom)?_c('button',{on:{"click":function($event){_vm.openchat(m,1,m.umidinfo)}}},[_vm._v("联系群主")]):_vm._e(),_vm._v(" "),(m.inroom)?_c('button',{on:{"click":function($event){_vm.openchatroom(m)}}},[_vm._v("发消息")]):_vm._e(),_vm._v(" "),(!m.inroom)?_c('button',{on:{"click":function($event){_vm.applygroup(m.roomid)}}},[_vm._v("申请加入")]):_vm._e(),_vm._v(" "),(m.inroom)?_c('button',[_vm._v("已加入")]):_vm._e()])])])])}))],1)]):_vm._e(),_vm._v(" "),(_vm.unionStatus)?_c('div',{staticClass:"adduserBottom"},[_c('div',{staticClass:"listtitle"},[_vm._v("找到"+_vm._s(_vm.searchuserlist.length)+"个组织（当前身份为组织身份，申请加入为申请成为该组织下级，邀请加入为邀请成为该组织上级）")]),_vm._v(" "),_c('ul',[_c('el-row',{attrs:{"gutter":10}},_vm._l((_vm.searchuserlist),function(m,index){return _c('el-col',{key:index,attrs:{"xs":24,"sm":12,"md":12,"lg":8,"xl":8}},[_c('li',{staticClass:"clearfix",on:{"mouseleave":_vm.rightListhide}},[(m.tag==1)?_c('img',{staticClass:"icon",attrs:{"src":"/img/superior.png","alt":""}}):_vm._e(),_vm._v(" "),(m.tag==2)?_c('img',{staticClass:"icon",attrs:{"src":"/img/subordinate.png","alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"fl"},[(m.companylogo)?_c('img',{staticClass:"fr avatar",attrs:{"src":m.companylogo,"alt":""}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fl",staticStyle:{"flex":"1","width":"0","margin-right":"10px"}},[_c('div',{staticClass:"info"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"sumname fl",staticStyle:{"max-width":"100%"}},[_vm._v(_vm._s(m.orgname))])]),_vm._v(" "),_c('div',{staticClass:"company"},[_vm._v(_vm._s(m.companydesc))])])]),_vm._v(" "),(m.tag==0)?_c('i',{staticClass:"iconfont fr",staticStyle:{"width":"20px","cursor":"pointer"},on:{"mouseenter":function($event){_vm.rightList(index,$event)}}},[_vm._v("")]):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRightList==index),expression:"showRightList==index"}],attrs:{"id":"rightList"}},[(m.tag==0)?_c('li',{on:{"click":function($event){_vm.openchat(m,1,m.umidinfo)}}},[_vm._v("联系管理员")]):_vm._e(),_vm._v(" "),(m.tag==0)?_c('li',{on:{"click":function($event){_vm.applyorg(m.orgid,1)}}},[_vm._v("申请加入")]):_vm._e(),_vm._v(" "),(m.tag==0)?_c('li',{on:{"click":function($event){_vm.applyorg(m.orgid,2)}}},[_vm._v("邀请加入")]):_vm._e(),_vm._v(" "),(m.tag==1||m.tag==2)?_c('li',[_vm._v("已加入")]):_vm._e()])])])}))],1)]):_vm._e()]):_vm._e(),_vm._v(" "),_c('um-dialog',{attrs:{"show":_vm.showid},on:{"update:show":function($event){_vm.showid=$event},"showchange":_vm.showchangeFun},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"popup-content"},[(!_vm.isfriend&&_vm.dialogInfo.umid!=_vm.mine&&!_vm.apply_group&&!_vm.apply_org)?_c('div',{staticClass:"sendMsg"},[_c('div',[_vm._v("请输入验证消息")]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","placeholder":"我是...","resize":"none"},on:{"focus":_vm.setvalue},model:{value:(_vm.validationMsg),callback:function ($$v) {_vm.validationMsg=$$v},expression:"validationMsg"}}),_vm._v(" "),_c('div',[_vm._v("为朋友设置备注")]),_vm._v(" "),_c('el-input',{staticClass:"desname",attrs:{"placeholder":"为朋友设置备注"},model:{value:(_vm.desname),callback:function ($$v) {_vm.desname=$$v},expression:"desname"}})],1):(_vm.isfriend&&_vm.dialogInfo.umid!=_vm.mine)?_c('div',[_vm._v("你们已经是好友了，快去聊天吧！")]):(_vm.dialogInfo.umid==_vm.mine)?_c('div',[_vm._v("不能添加自己为好友，换个帐号试试吧！")]):(!_vm.isfriend&&_vm.apply_group&&!_vm.apply_org)?_c('div',[_c('div',[_vm._v("请输入验证消息")]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","placeholder":"我是...","resize":"none"},on:{"focus":_vm.setvalue},model:{value:(_vm.validationGroupMsg),callback:function ($$v) {_vm.validationGroupMsg=$$v},expression:"validationGroupMsg"}})],1):(!_vm.isfriend&&!_vm.apply_group&&_vm.apply_org)?_c('div',[_c('div',[_vm._v("请输入验证消息")]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","placeholder":"我是...","resize":"none"},on:{"focus":_vm.setvalue},model:{value:(_vm.validationOrgMsg),callback:function ($$v) {_vm.validationOrgMsg=$$v},expression:"validationOrgMsg"}})],1):_vm._e()]),_vm._v(" "),(!_vm.isfriend&&_vm.dialogInfo.umid!=_vm.mine&&!_vm.apply_group&&!_vm.apply_org)?_c('div',{staticClass:"popup-footer"},[_c('button',{staticClass:"confirm",on:{"click":function($event){_vm.sendApply(_vm.dialogInfo.umid)}}},[_vm._v("发送")]),_vm._v(" "),_c('button',{staticClass:"cancel",on:{"click":function($event){_vm.showchangeFun()}}},[_vm._v("取消")])]):_vm._e(),_vm._v(" "),(!_vm.isfriend&&_vm.apply_group&&!_vm.apply_org)?_c('div',{staticClass:"popup-footer"},[_c('button',{staticClass:"confirm",on:{"click":function($event){_vm.sendApply(_vm.applyroomid)}}},[_vm._v("发送")]),_vm._v(" "),_c('button',{staticClass:"cancel",on:{"click":function($event){_vm.showchangeFun()}}},[_vm._v("取消")])]):_vm._e(),_vm._v(" "),(!_vm.isfriend&&!_vm.apply_group&&_vm.apply_org)?_c('div',{staticClass:"popup-footer"},[(!_vm.unionStaus)?_c('button',{staticClass:"confirm",on:{"click":function($event){_vm.sendApply(_vm.applyorgid)}}},[_vm._v("发送")]):_vm._e(),_vm._v(" "),(_vm.unionStaus)?_c('button',{staticClass:"confirm",on:{"click":function($event){_vm.sendApply(_vm.applyorgid)}}},[_vm._v("发送")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"cancel",on:{"click":function($event){_vm.showchangeFun()}}},[_vm._v("取消")])]):(_vm.isfriend&&_vm.dialogInfo.umid!=_vm.mine)?_c('div',{staticClass:"popup-footer"},[_c('button',{staticClass:"confirm",on:{"click":function($event){_vm.openchat(_vm.dialogInfo.item,1,_vm.dialogInfo.item)}}},[_vm._v("发起聊天")]),_vm._v(" "),_c('button',{staticClass:"cancel",on:{"click":function($event){_vm.showchangeFun()}}},[_vm._v("取消")])]):(_vm.dialogInfo.umid==_vm.mine)?_c('div',{staticClass:"popup-footer"},[_c('button',{on:{"click":function($event){_vm.showchangeFun()}}},[_vm._v("确定")])]):_vm._e()]}}])})],1):_vm._e(),_vm._v(" "),(_vm.createtype=='org')?_c('div',[_c('el-form',{ref:"form",attrs:{"rules":_vm.rules,"model":_vm.form,"label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"组织LOGO上传","prop":"logopath","required":""}},[_c('div',{staticClass:"vCenter"},[_c('img',{staticClass:"logopath",attrs:{"src":_vm.form.logopath,"alt":""},on:{"click":_vm.upload1}}),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"20px","flex":"1"}},[_c('p',[_vm._v("点击头像进行选择，点击上传按钮可上传本地图片。")]),_vm._v(" "),_c('ul',{staticClass:"clearfix chooselist"},[_c('li',{staticClass:"fl"},[_c('um-img',{attrs:{"submitStatus":_vm.submitImgStatus,"uploadlogo":_vm.orgupload},on:{"submit-file":function($event){_vm.confirmgroup1($event,'org')},"getImgSrc":_vm.orgImg}})],1),_vm._v(" "),_vm._l((_vm.defaultIcon),function(item){return _c('li',{staticClass:"fl"},[_c('img',{attrs:{"src":item.path,"alt":""},on:{"click":function($event){_vm.choosecolor(item,'o')}}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(item.id==_vm.selectcolor),expression:"item.id==selectcolor"}],staticClass:"selectcolor",attrs:{"src":"/img/select.png","alt":""}})])})],2)])])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"组织名称","prop":"orgname"}},[_c('el-input',{model:{value:(_vm.form.orgname),callback:function ($$v) {_vm.$set(_vm.form, "orgname", $$v)},expression:"form.orgname"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"组织简称","prop":"orgshortname"}},[_c('el-input',{model:{value:(_vm.form.orgshortname),callback:function ($$v) {_vm.$set(_vm.form, "orgshortname", $$v)},expression:"form.orgshortname"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"组织类型","prop":"type"}},[_c('el-select',{attrs:{"popper-append-to-body":false,"placeholder":"请选择组织类型"},model:{value:(_vm.form.value),callback:function ($$v) {_vm.$set(_vm.form, "value", $$v)},expression:"form.value"}},_vm._l((_vm.form.options),function(item){return _c('el-option',{key:item.orgtypeid,attrs:{"label":item.orgtypename,"value":item.orgtypeid}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"固定电话","prop":"orgtel"}},[_c('el-input',{model:{value:(_vm.form.orgtel),callback:function ($$v) {_vm.$set(_vm.form, "orgtel", $$v)},expression:"form.orgtel"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"官网地址","prop":"orghomepage"}},[_c('el-input',{model:{value:(_vm.form.homepage),callback:function ($$v) {_vm.$set(_vm.form, "homepage", $$v)},expression:"form.homepage"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"组织邮箱","prop":"orgemail"}},[_c('el-input',{model:{value:(_vm.form.orgemail),callback:function ($$v) {_vm.$set(_vm.form, "orgemail", $$v)},expression:"form.orgemail"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"组织简介","prop":"orgdesc"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.form.orgdesc),callback:function ($$v) {_vm.$set(_vm.form, "orgdesc", $$v)},expression:"form.orgdesc"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所在地区"}},[_c('div',{staticClass:"input-item"},[_c('select',{attrs:{"id":"province"},on:{"change":function($event){_vm.search1($event.target)}}})]),_vm._v(" "),_c('div',{staticClass:"input-item"},[_c('select',{attrs:{"id":"city"},on:{"change":function($event){_vm.search1($event.target)}}})]),_vm._v(" "),_c('div',{staticClass:"input-item"},[_c('select',{attrs:{"id":"district"},on:{"change":function($event){_vm.search1($event.target)}}})])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"开启组织权限"}},[_c('el-switch',{attrs:{"active-color":"#409EFF","inactive-color":"#6c6c6c"},model:{value:(_vm.form.jurisdiction),callback:function ($$v) {_vm.$set(_vm.form, "jurisdiction", $$v)},expression:"form.jurisdiction"}}),_vm._v(" "),_c('div',[_vm._v("启用权限后成员只能看到当前部门与下级部门数据")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.createtype=='homepage')?_c('div',{staticClass:"homepageedit"},[_c('el-form',{ref:"hpform",attrs:{"model":_vm.hpform,"label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"已选项目"}},_vm._l((_vm.hpform.navlist),function(item,index){return _c('div',{key:index},[_c('div',{staticClass:"vCenter"},[_c('input',{attrs:{"type":"checkbox","value":""},domProps:{"checked":item.checked},on:{"click":function($event){_vm.curHpItemCheckedChange(index)}}}),_vm._v(" "),_c('div',{staticStyle:{"width":"140px"}},[_vm._v(_vm._s(item.sname))]),_vm._v(" "),_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){_vm.editHpItem(item, index)}}},[_vm._v("编辑")]),_vm._v(" "),_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){_vm.delHpItem(index)}}},[_vm._v("删除")])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hpform.curindex == index),expression:"hpform.curindex == index"}],staticClass:"newview"},[_c('div',{staticClass:"vCenter"},[_c('div',{staticClass:"hptitlelab"},[_vm._v("项目名称：")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"请输入项目名称"},model:{value:(_vm.hpform.edititem.caption),callback:function ($$v) {_vm.$set(_vm.hpform.edititem, "caption", $$v)},expression:"hpform.edititem.caption"}})],1),_vm._v(" "),_c('div',{staticClass:"vCenter"},[_c('div',{staticClass:"hptitlelab"},[_vm._v("项目类型：")]),_vm._v(" "),_c('el-radio-group',{model:{value:(_vm.hpform.edititem.itype),callback:function ($$v) {_vm.$set(_vm.hpform.edititem, "itype", $$v)},expression:"hpform.edititem.itype"}},[_c('el-radio',{attrs:{"label":"0"}},[_vm._v("网页url")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"1"}},[_vm._v("自定义页面")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2"}},[_vm._v("独立网页")])],1)],1),_vm._v(" "),_c('div',{staticClass:"vCenter"},[_c('div',{staticClass:"hptitlelab"},[_vm._v("项目地址：")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"请输入项目地址"},model:{value:(_vm.hpform.edititem.url),callback:function ($$v) {_vm.$set(_vm.hpform.edititem, "url", $$v)},expression:"hpform.edititem.url"}})],1),_vm._v(" "),_c('div',{staticClass:"vCenter"},[_c('div',{staticClass:"hptitlelab"},[_vm._v("dappid：")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"请输入dappid(没有可不填)"},model:{value:(_vm.hpform.edititem.dappid),callback:function ($$v) {_vm.$set(_vm.hpform.edititem, "dappid", $$v)},expression:"hpform.edititem.dappid"}})],1),_vm._v(" "),_c('div',{staticClass:"vCenter"},[_c('div',{staticClass:"hptitlelab"},[_vm._v("appid：")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"请输入appid(没有可不填)"},model:{value:(_vm.hpform.edititem.appid),callback:function ($$v) {_vm.$set(_vm.hpform.edititem, "appid", $$v)},expression:"hpform.edititem.appid"}})],1),_vm._v(" "),_c('div',{staticClass:"newsubmitdiv vCenter"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.hpform.curindex = -1}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":function($event){_vm.commitEditHpItem(index)}}},[_vm._v("确定")])],1)])])}))],1),_vm._v(" "),_c('el-form',{ref:"hpform",attrs:{"model":_vm.hpform,"label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"可选项目"}},[_c('div',_vm._l((_vm.hpform.dapplist),function(item){return _c('label',{key:item.indexname},[_c('input',{attrs:{"name":"Fruit","type":"checkbox","value":"","disabled":item.checked},domProps:{"checked":item.checked},on:{"click":function($event){_vm.selectHpItem(item)}}}),_vm._v("\n                "+_vm._s(item.indexname)+"\n              ")])})),_vm._v(" "),_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){_vm.hpform.showNewView=true}}},[_vm._v("添加自定义项")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hpform.showNewView),expression:"hpform.showNewView"}],staticClass:"newview"},[_c('div',{staticClass:"vCenter"},[_c('div',{staticClass:"hptitlelab"},[_vm._v("项目名称：")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"请输入项目名称"},model:{value:(_vm.hpform.newitem.caption),callback:function ($$v) {_vm.$set(_vm.hpform.newitem, "caption", $$v)},expression:"hpform.newitem.caption"}})],1),_vm._v(" "),_c('div',{staticClass:"vCenter"},[_c('div',[_vm._v("项目类型：")]),_vm._v(" "),_c('el-radio-group',{model:{value:(_vm.hpform.newitem.itype),callback:function ($$v) {_vm.$set(_vm.hpform.newitem, "itype", $$v)},expression:"hpform.newitem.itype"}},[_c('el-radio',{attrs:{"label":"0"}},[_vm._v("网页url")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"1"}},[_vm._v("自定义页面")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2"}},[_vm._v("独立网页")])],1)],1),_vm._v(" "),_c('div',{staticClass:"vCenter"},[_c('div',{staticClass:"hptitlelab"},[_vm._v("项目地址：")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"请输入项目地址"},model:{value:(_vm.hpform.newitem.url),callback:function ($$v) {_vm.$set(_vm.hpform.newitem, "url", $$v)},expression:"hpform.newitem.url"}})],1),_vm._v(" "),_c('div',{staticClass:"vCenter"},[_c('div',{staticClass:"hptitlelab"},[_vm._v("dappid：")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"请输入dappid(没有可不填)"},model:{value:(_vm.hpform.newitem.dappid),callback:function ($$v) {_vm.$set(_vm.hpform.newitem, "dappid", $$v)},expression:"hpform.newitem.dappid"}})],1),_vm._v(" "),_c('div',{staticClass:"vCenter"},[_c('div',{staticClass:"hptitlelab"},[_vm._v("appid：")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"请输入appid(没有可不填)"},model:{value:(_vm.hpform.newitem.appid),callback:function ($$v) {_vm.$set(_vm.hpform.newitem, "appid", $$v)},expression:"hpform.newitem.appid"}})],1),_vm._v(" "),_c('div',{staticClass:"newsubmitdiv vCenter"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.hpform.showNewView=false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":function($event){_vm.addNewHpItem()}}},[_vm._v("确定")])],1)])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.createtype=='copyhomepage')?_c('div',{staticClass:"clearfix"},[_c('el-form',{ref:"hpform",attrs:{"model":_vm.hpform,"label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"请选择组织"}},[_c('el-select',{attrs:{"popper-append-to-body":false,"placeholder":"请选择已创建的组织"},model:{value:(_vm.hpform.curorgid),callback:function ($$v) {_vm.$set(_vm.hpform, "curorgid", $$v)},expression:"hpform.curorgid"}},_vm._l((_vm.hpform.mineorg),function(item){return _c('el-option',{key:item.orgid,attrs:{"label":item.name,"value":item.orgid}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"已选项目"}},_vm._l((_vm.hpform.navlist),function(item,index){return _c('div',{key:index},[_c('div',[_c('el-checkbox',{staticStyle:{"width":"140px"},attrs:{"checked":item.checked},on:{"change":function($event){_vm.curHpItemCheckedChange(index)}}},[_vm._v(_vm._s(item.sname))]),_vm._v(" "),_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){_vm.editHpItem(item, index)}}},[_vm._v("编辑")]),_vm._v(" "),_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){_vm.delHpItem(index)}}},[_vm._v("删除")])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hpform.curindex == index),expression:"hpform.curindex == index"}],staticClass:"newview"},[_c('div',{staticClass:"vCenter"},[_c('div',{staticClass:"hptitlelab"},[_vm._v("项目名称：")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"请输入项目名称"},model:{value:(_vm.hpform.edititem.caption),callback:function ($$v) {_vm.$set(_vm.hpform.edititem, "caption", $$v)},expression:"hpform.edititem.caption"}})],1),_vm._v(" "),_c('div',{staticClass:"vCenter"},[_c('div',{staticClass:"hptitlelab"},[_vm._v("项目类型：")]),_vm._v(" "),_c('el-radio-group',{model:{value:(_vm.hpform.edititem.itype),callback:function ($$v) {_vm.$set(_vm.hpform.edititem, "itype", $$v)},expression:"hpform.edititem.itype"}},[_c('el-radio',{attrs:{"label":"0"}},[_vm._v("网页url")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"1"}},[_vm._v("自定义页面")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2"}},[_vm._v("独立网页")])],1)],1),_vm._v(" "),_c('div',{staticClass:"vCenter"},[_c('div',{staticClass:"hptitlelab"},[_vm._v("项目地址：")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"请输入项目地址"},model:{value:(_vm.hpform.edititem.url),callback:function ($$v) {_vm.$set(_vm.hpform.edititem, "url", $$v)},expression:"hpform.edititem.url"}})],1),_vm._v(" "),_c('div',{staticClass:"vCenter"},[_c('div',{staticClass:"hptitlelab"},[_vm._v("dappid：")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"请输入dappid(没有可不填)"},model:{value:(_vm.hpform.edititem.dappid),callback:function ($$v) {_vm.$set(_vm.hpform.edititem, "dappid", $$v)},expression:"hpform.edititem.dappid"}})],1),_vm._v(" "),_c('div',{staticClass:"vCenter"},[_c('div',{staticClass:"hptitlelab"},[_vm._v("appid：")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"请输入appid(没有可不填)"},model:{value:(_vm.hpform.edititem.appid),callback:function ($$v) {_vm.$set(_vm.hpform.edititem, "appid", $$v)},expression:"hpform.edititem.appid"}})],1),_vm._v(" "),_c('div',{staticClass:"newsubmitdiv vCenter"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.hpform.curindex = -1}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":function($event){_vm.commitEditHpItem(index)}}},[_vm._v("确定")])],1)])])}))],1)],1):_vm._e(),_vm._v(" "),(_vm.createtype=='group')?_c('div',{staticClass:"clearfix"},[_c('el-form',{ref:"groupForm",attrs:{"model":_vm.groupForm,"label-width":"80px"}},[_c('el-form-item',{attrs:{"label":"群头像：","prop":"logopath"}},[_c('div',{staticClass:"vCenter"},[_c('img',{staticClass:"logopath",attrs:{"src":_vm.groupForm.logopath,"alt":""},on:{"click":_vm.upload1}}),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"20px","flex":"1"}},[_c('p',[_vm._v("点击头像进行选择，点击上传按钮可上传本地图片。")]),_vm._v(" "),_c('ul',{staticClass:"clearfix chooselist"},[_c('li',{staticClass:"fl"},[_c('um-img',{attrs:{"submitStatus":_vm.submitImgStatus,"uploadlogo":_vm.groupupload},on:{"submit-file":function($event){_vm.confirmgroup($event,'group')},"getImgSrc":_vm.groupImg}})],1),_vm._v(" "),_vm._l((_vm.defaultIcon1),function(item){return _c('li',{staticClass:"fl"},[_c('img',{attrs:{"src":item.path,"alt":""},on:{"click":function($event){_vm.choosecolor(item,'g')}}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(item.id==_vm.selectcolor),expression:"item.id==selectcolor"}],staticClass:"selectcolor",attrs:{"src":"/img/select.png","alt":""}})])})],2)])])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"群名称：","prop":"groupname"}},[_c('el-input',{model:{value:(_vm.groupForm.groupname),callback:function ($$v) {_vm.$set(_vm.groupForm, "groupname", $$v)},expression:"groupForm.groupname"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"群类型：","prop":"grouptype"}},[_c('el-select',{attrs:{"popper-append-to-body":false},model:{value:(_vm.groupForm.grouptype),callback:function ($$v) {_vm.$set(_vm.groupForm, "grouptype", $$v)},expression:"groupForm.grouptype"}},[_c('el-option',{attrs:{"label":"普通群","value":"0"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"内部群","value":"1"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"群介绍：","prop":"groupinfo"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.groupForm.groupinfo),callback:function ($$v) {_vm.$set(_vm.groupForm, "groupinfo", $$v)},expression:"groupForm.groupinfo"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"群成员："}},[_vm._l((_vm.tagsFriend),function(item,index){return _c('el-tag',{key:index,attrs:{"closable":""},on:{"close":function($event){_vm.handleClose(item,index)}}},[_vm._v(_vm._s(item.name))])}),_vm._v(" "),_c('div',{staticClass:"adduser",on:{"click":function($event){_vm.opencandidate('13')}}},[_vm._v("+添加")])],2)],1)],1):_vm._e(),_vm._v(" "),(_vm.createtype=='dapp')?_c('div',{staticClass:"clearfix dapp"},[_c('el-form',{ref:"formdapp",attrs:{"model":_vm.formdapp,"label-width":"80px"}},[_c('el-form-item',{attrs:{"label":"LOGO","prop":"imageUrl"}},[_c('div',{staticClass:"vCenter"},[_c('img',{staticClass:"logopath",attrs:{"src":_vm.formdapp.imageUrl,"alt":""},on:{"click":_vm.upload1}}),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"20px","flex":"1"}},[_c('p',[_vm._v("点击头像进行选择，点击上传按钮可上传本地图片。")]),_vm._v(" "),_c('ul',{staticClass:"clearfix chooselist"},[_c('li',{staticClass:"fl"},[_c('um-img',{attrs:{"submitStatus":_vm.submitImgStatus,"uploadlogo":_vm.dappupload},on:{"submit-file":function($event){_vm.confirmgroup($event,'dapp')},"getImgSrc":_vm.dappImg}})],1),_vm._v(" "),_vm._l((_vm.defaultIcon2),function(item){return _c('li',{staticClass:"fl"},[_c('img',{attrs:{"src":item.path,"alt":""},on:{"click":function($event){_vm.choosecolor(item,'d')}}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(item.id==_vm.selectcolor),expression:"item.id==selectcolor"}],staticClass:"selectcolor",attrs:{"src":"/img/select.png","alt":""}})])})],2)])])]),_vm._v(" "),_c('el-form-item',{staticClass:"newappname",attrs:{"label":"小程序名","required":"","prop":"newtitle"}},[_c('el-input',{model:{value:(_vm.formdapp.newtitle),callback:function ($$v) {_vm.$set(_vm.formdapp, "newtitle", $$v)},expression:"formdapp.newtitle"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"功能描述","prop":"appinfo"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.formdapp.appinfo),callback:function ($$v) {_vm.$set(_vm.formdapp, "appinfo", $$v)},expression:"formdapp.appinfo"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"模板","prop":"type"}},[_c('el-select',{attrs:{"popper-append-to-body":false,"placeholder":"请选择模板"},on:{"change":function($event){_vm.getdappstyle(_vm.formdapp.dappmodule)}},model:{value:(_vm.formdapp.dappmodule),callback:function ($$v) {_vm.$set(_vm.formdapp, "dappmodule", $$v)},expression:"formdapp.dappmodule"}},_vm._l((_vm.dappmodulelist),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.stype,"value":item.sid}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"模板样式","prop":"type"}},[_c('el-select',{attrs:{"popper-append-to-body":false,"placeholder":"请选择类型","disabled":_vm.formdapp.dappmodule=='58c66a66240c07432a41691e2b6f1a7b'&&_vm.formdapp.istyle=='c9a4ae48acfd67565bc1ea5706bf5c4d'},model:{value:(_vm.formdapp.istyle),callback:function ($$v) {_vm.$set(_vm.formdapp, "istyle", $$v)},expression:"formdapp.istyle"}},_vm._l((_vm.dappstylelist),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.sname,"value":item.sid}})}))],1),_vm._v(" "),(_vm.formdapp.dappmodule=='58c66a66240c07432a41691e2b6f1a7b')?_c('el-form-item',{staticClass:"newauthor",attrs:{"label":"URL","prop":"url"}},[_c('el-input',{attrs:{"placeholder":"https://"},model:{value:(_vm.formdapp.dappsrc),callback:function ($$v) {_vm.$set(_vm.formdapp, "dappsrc", $$v)},expression:"formdapp.dappsrc"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"分类","prop":"type"}},[_c('el-select',{attrs:{"popper-append-to-body":false,"placeholder":"请选择分类"},model:{value:(_vm.formdapp.type),callback:function ($$v) {_vm.$set(_vm.formdapp, "type", $$v)},expression:"formdapp.type"}},_vm._l((_vm.dapptypelist1),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.sname,"value":item.itype}})}))],1),_vm._v(" "),_c('el-form-item',{staticClass:"newauthor",attrs:{"label":"新建人","prop":"newauthor"}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.formdapp.newauthor),callback:function ($$v) {_vm.$set(_vm.formdapp, "newauthor", $$v)},expression:"formdapp.newauthor"}})],1),_vm._v(" "),_c('um-identity',{attrs:{"formdapp":_vm.formdapp},on:{"selectOrg":_vm.selectOrgFun}}),_vm._v(" "),_c('um-range',{attrs:{"formdapp":_vm.formdapp,"tagsFriend":_vm.tagsFriend,"tagsGroup":_vm.tagsGroup,"tagsOrg":_vm.tagsOrg,"tagshy":_vm.tagshy,"tagsdq":_vm.tagsdq},on:{"opencandidate":_vm.opencandidateFun}})],1)],1):_vm._e(),_vm._v(" "),(_vm.createtype=='copydapp')?_c('div',[_c('el-form',{ref:"formdapp",attrs:{"model":_vm.formdapp,"label-width":"80px"}},[_c('el-form-item',{attrs:{"label":"LOGO","prop":"imageUrl"}},[_c('div',{staticClass:"vCenter"},[_c('img',{staticClass:"logopath",attrs:{"src":_vm.formdapp.imageUrl,"alt":""},on:{"click":_vm.upload1}}),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"20px","flex":"1"}},[_c('p',[_vm._v("点击头像进行选择，点击上传按钮可上传本地图片。")]),_vm._v(" "),_c('ul',{staticClass:"clearfix chooselist"},[_c('li',{staticClass:"fl"},[_c('um-img',{attrs:{"submitStatus":_vm.submitImgStatus,"uploadlogo":_vm.dappupload},on:{"submit-file":function($event){_vm.confirmgroup($event,'copydapp')},"getImgSrc":_vm.dappImg}})],1),_vm._v(" "),_vm._l((_vm.defaultIcon2),function(item){return _c('li',{staticClass:"fl"},[_c('img',{attrs:{"src":item.path,"alt":""},on:{"click":function($event){_vm.choosecolor(item,'d')}}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(item.id==_vm.selectcolor),expression:"item.id==selectcolor"}],staticClass:"selectcolor",attrs:{"src":"/img/select.png","alt":""}})])})],2)])])]),_vm._v(" "),_c('el-form-item',{staticClass:"newappname",attrs:{"label":"小程序名","required":"","prop":"newtitle"}},[_c('el-input',{model:{value:(_vm.formdapp.newtitle),callback:function ($$v) {_vm.$set(_vm.formdapp, "newtitle", $$v)},expression:"formdapp.newtitle"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"功能描述","prop":"appinfo"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.formdapp.appinfo),callback:function ($$v) {_vm.$set(_vm.formdapp, "appinfo", $$v)},expression:"formdapp.appinfo"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"分类","prop":"type"}},[_c('el-select',{attrs:{"popper-append-to-body":false,"placeholder":"请选择分类"},model:{value:(_vm.formdapp.type),callback:function ($$v) {_vm.$set(_vm.formdapp, "type", $$v)},expression:"formdapp.type"}},_vm._l((_vm.dapptypelist1),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.sname,"value":item.itype}})}))],1),_vm._v(" "),_c('el-form-item',{staticClass:"newauthor",attrs:{"label":"新建人","prop":"newauthor"}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.formdapp.newauthor),callback:function ($$v) {_vm.$set(_vm.formdapp, "newauthor", $$v)},expression:"formdapp.newauthor"}})],1),_vm._v(" "),_c('um-identity',{attrs:{"formdapp":_vm.formdapp},on:{"selectOrg":_vm.selectOrgFun}}),_vm._v(" "),_c('um-range',{attrs:{"formdapp":_vm.formdapp,"tagsFriend":_vm.tagsFriend,"tagsGroup":_vm.tagsGroup,"tagsOrg":_vm.tagsOrg,"tagshy":_vm.tagshy,"tagsdq":_vm.tagsdq},on:{"opencandidate":_vm.opencandidateFun}})],1)],1):_vm._e(),_vm._v(" "),(_vm.createtype=='editdapp')?_c('div',[_c('el-form',{ref:"formdapp",attrs:{"model":_vm.formdapp,"label-width":"80px"}},[_c('el-form-item',{attrs:{"label":"LOGO","prop":"imageUrl"}},[_c('div',{staticClass:"vCenter"},[_c('img',{staticClass:"logopath",attrs:{"src":_vm.formdapp.imageUrl,"alt":""},on:{"click":_vm.upload1}}),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"20px","flex":"1"}},[_c('p',[_vm._v("点击头像进行选择，点击上传按钮可上传本地图片。")]),_vm._v(" "),_c('ul',{staticClass:"clearfix chooselist"},[_c('li',{staticClass:"fl"},[_c('um-img',{attrs:{"submitStatus":_vm.submitImgStatus,"uploadlogo":_vm.dappupload},on:{"submit-file":function($event){_vm.confirmgroup($event,'editdapp')},"getImgSrc":_vm.dappImg}})],1),_vm._v(" "),_vm._l((_vm.defaultIcon2),function(item){return _c('li',{staticClass:"fl"},[_c('img',{attrs:{"src":item.path,"alt":""},on:{"click":function($event){_vm.choosecolor(item,'d')}}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(item.id==_vm.selectcolor),expression:"item.id==selectcolor"}],staticClass:"selectcolor",attrs:{"src":"/img/select.png","alt":""}})])})],2)])])]),_vm._v(" "),_c('el-form-item',{staticClass:"newappname",attrs:{"label":"小程序名","required":"","prop":"newtitle"}},[_c('el-input',{model:{value:(_vm.formdapp.newtitle),callback:function ($$v) {_vm.$set(_vm.formdapp, "newtitle", $$v)},expression:"formdapp.newtitle"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"功能描述","prop":"appinfo"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.formdapp.appinfo),callback:function ($$v) {_vm.$set(_vm.formdapp, "appinfo", $$v)},expression:"formdapp.appinfo"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"模板","prop":"type"}},[_c('el-select',{attrs:{"popper-append-to-body":false,"placeholder":"请选择模板"},on:{"change":function($event){_vm.getdappstyle(_vm.formdapp.dappmodule)}},model:{value:(_vm.formdapp.dappmodule),callback:function ($$v) {_vm.$set(_vm.formdapp, "dappmodule", $$v)},expression:"formdapp.dappmodule"}},_vm._l((_vm.dappmodulelist),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.stype,"value":item.sid}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"模板样式","prop":"type"}},[_c('el-select',{attrs:{"placeholder":"请选择类型","disabled":_vm.formdapp.dappmodule=='58c66a66240c07432a41691e2b6f1a7b'&&_vm.formdapp.istyle=='c9a4ae48acfd67565bc1ea5706bf5c4d'},model:{value:(_vm.formdapp.istyle),callback:function ($$v) {_vm.$set(_vm.formdapp, "istyle", $$v)},expression:"formdapp.istyle"}},_vm._l((_vm.dappstylelist),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.sname,"value":item.sid}})}))],1),_vm._v(" "),(_vm.formdapp.dappmodule=='58c66a66240c07432a41691e2b6f1a7b')?_c('el-form-item',{staticClass:"newauthor",attrs:{"label":"URL","prop":"url"}},[_c('el-input',{attrs:{"placeholder":"https://"},model:{value:(_vm.formdapp.dappsrc),callback:function ($$v) {_vm.$set(_vm.formdapp, "dappsrc", $$v)},expression:"formdapp.dappsrc"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"分类","prop":"type"}},[_c('el-select',{attrs:{"popper-append-to-body":false,"placeholder":"请选择分类"},model:{value:(_vm.formdapp.type),callback:function ($$v) {_vm.$set(_vm.formdapp, "type", $$v)},expression:"formdapp.type"}},_vm._l((_vm.dapptypelist1),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.sname,"value":item.itype}})}))],1),_vm._v(" "),_c('el-form-item',{staticClass:"newauthor",attrs:{"label":"新建人","prop":"newauthor"}},[_c('el-input',{attrs:{"disabled":true},model:{value:(_vm.formdapp.author),callback:function ($$v) {_vm.$set(_vm.formdapp, "author", $$v)},expression:"formdapp.author"}})],1),_vm._v(" "),_c('um-identity',{attrs:{"formdapp":_vm.formdapp},on:{"selectOrg":_vm.selectOrgFun}}),_vm._v(" "),_c('um-range',{attrs:{"formdapp":_vm.formdapp,"tagsFriend":_vm.tagsFriend,"tagsGroup":_vm.tagsGroup,"tagsOrg":_vm.tagsOrg,"tagshy":_vm.tagshy,"tagsdq":_vm.tagsdq},on:{"opencandidate":_vm.opencandidateFun}})],1)],1):_vm._e()]),_vm._v(" "),(_vm.createtype!='user')?_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.closenew()}}},[_vm._v("取 消")]),_vm._v(" "),(_vm.createtype=='homepage')?_c('el-button',{attrs:{"type":"primary","disabled":!_vm.submitStatus},on:{"click":function($event){_vm.confirmhomepage(_vm.createtype)}}},[_vm._v(_vm._s(_vm.submitBtn))]):_c('el-button',{attrs:{"type":"primary","disabled":!_vm.submitStatus},on:{"click":function($event){_vm.confirm(_vm.createtype)}}},[_vm._v(_vm._s(_vm.submitBtn))])],1):_vm._e()]),_vm._v(" "),(_vm.candidate)?_c('um-candidate',{attrs:{"chooseorg":_vm.chooseorg,"hy":_vm.tagshy,"dq":_vm.tagsdq,"createtype":_vm.createtype,"friend":_vm.tagsFriend,"org":_vm.tagsOrg,"group":_vm.tagsGroup,"usertype":_vm.usertype,"candidate":_vm.candidate},on:{"closecandidate":_vm.closecandidateFun,"submitcandidate":_vm.submitcandidateFun}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__um_candidate__ = __webpack_require__(74);

__WEBPACK_IMPORTED_MODULE_0__um_candidate__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__um_candidate__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__um_candidate__["a" /* default */]);
}; //注册组件
// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) { 
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__um_candidate__["a" /* default */]);

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_candidate_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27afad3d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_candidate_vue__ = __webpack_require__(79);
function injectStyle (ssrContext) {
  __webpack_require__(75)
  __webpack_require__(77)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_candidate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27afad3d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_candidate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(76);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("41f955c4", content, true, {});

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".candidate-left{width:50%;border-right:1px solid #dcdcdc;padding-right:20px;height:100%}.candidate-left .tab{display:flex}.candidate-left .tab .tablist{width:90px;margin-right:20px;cursor:pointer}.candidate-left .tab .tablist li{width:90px;height:30px;text-align:center;line-height:30px;margin-bottom:10px;background:#e7e7e7}.candidate-left .tab .tablist li.active{background:#2e9cf1;color:#fff}.candidate-left .tab .tabbox{flex:1;height:300px;overflow:auto}.candidate-left .tab .tabbox>div{margin-right:10px}.candidate-left .tab .tabbox .breadcrumb{margin-bottom:10px}.candidate-left .tab .tabbox .breadcrumb li{color:#2e9cf1;cursor:pointer}.candidate-left .tab .tabbox .breadcrumb li .last{color:#333}.candidate-left .tab .tabbox li{display:block;margin-bottom:6px}.candidate-left .tab .tabbox li .userHeadImg{width:28px;height:28px;color:#fff;font-size:12px;text-align:center;line-height:28px;border:0;margin-right:6px}.candidate-left .tab .tabbox li .nextdept{font-size:14px;display:inline-block;cursor:pointer;color:#2e9cf1}.candidate-left .tab .tabbox li .disabled{color:#b1b1b1;line-height:28px}.candidate-left .tab .tabbox .bwn{justify-content:space-between}.candidate-left .candidate-left-search{height:40px;margin:0 auto 20px;width:100%;padding:0 10px;border:1px solid #ccc;border-radius:4px}.candidate-left .candidate-left-search input{height:40px;border:0;width:180px;margin-right:10px;background:transparent}.candidate-left .candidate-left-search i{color:#9e9e9e}.candidate-right{width:50%;padding-left:20px}.candidate-right .occupy{height:10px}.candidate-right .vCenter{margin-bottom:10px}.candidate-right .line{width:2px;height:16px;background:#2e9cf1;display:inline-block;margin-right:5px}", ""]);

// exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(78);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("79a62b0a", content, true, {});

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".candidate-right .el-tag{margin:0 5px 5px 0}.tabbox .el-checkbox{color:#333}.tabbox .el-checkbox__inner{width:20px;height:20px;border-radius:50%}.tabbox .el-checkbox__inner:after{left:7px;top:4px}.el-checkbox__input.is-checked+.el-checkbox__label{color:#333}", ""]);

// exports


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-dialog',{attrs:{"title":_vm.title==''?'选人':_vm.title,"visible":_vm.candidate,"width":"61.8%","before-close":_vm.closecandidate,"append-to-body":true},on:{"update:visible":function($event){_vm.candidate=$event}}},[_c('div',{staticClass:"clearfix",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"candidate-left fl"},[_c('div',{staticClass:"candidate-left-search"},[_c('i',{staticClass:"iconfont searchBtn"},[_vm._v("")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],attrs:{"type":"text","placeholder":"回车搜索人员"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.candidateSearch($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"tab"},[_c('ul',{staticClass:"tablist"},_vm._l((_vm.usertype),function(item,index){return _c('li',{key:index,class:{'active':_vm.usertypeActive==item},on:{"click":function($event){_vm.changetype(item)}}},[(item==0)?_c('span',[_vm._v("最近联系")]):_vm._e(),_vm._v(" "),(item==1)?_c('span',[_vm._v("好友")]):_vm._e(),_vm._v(" "),(item==2)?_c('span',[_vm._v("群")]):_vm._e(),_vm._v(" "),(item==3)?_c('span',[_vm._v("组织")]):_vm._e(),_vm._v(" "),(item==4)?_c('span',[_vm._v("角色")]):_vm._e(),_vm._v(" "),(item==5)?_c('span',[_vm._v("标签")]):_vm._e(),_vm._v(" "),(item==6)?_c('span',[_vm._v("群成员")]):_vm._e(),_vm._v(" "),(item==7)?_c('span',[_vm._v("行业")]):_vm._e(),_vm._v(" "),(item==8)?_c('span',[_vm._v("区域")]):_vm._e()])})),_vm._v(" "),_c('ul',{staticClass:"tabbox"},[(_vm.usertypeActive==3)?_c('ul',{staticClass:"clearfix breadcrumb"},_vm._l((_vm.breadcrumb),function(item,index){return _c('li',{staticClass:"fl"},[_c('span',{class:{'last':index==_vm.breadcrumb.length-1},on:{"click":function($event){_vm.nextdept(item.name,item.orgid,item.deptno,item.type)}}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(index<_vm.breadcrumb.length-1),expression:"index<breadcrumb.length-1"}],staticClass:"last el-icon-arrow-right"})])})):_vm._e(),_vm._v(" "),(_vm.usertypeActive==7||_vm.usertypeActive==8)?_c('ul',{staticClass:"clearfix breadcrumb"},_vm._l((_vm.breadcrumb),function(item,index){return _c('li',{staticClass:"fl"},[_c('span',{class:{'last':index==_vm.breadcrumb.length-1},on:{"click":function($event){_vm.next(_vm.usertypeActive,item.id)}}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(index<_vm.breadcrumb.length-1),expression:"index<breadcrumb.length-1"}],staticClass:"last el-icon-arrow-right"})])})):_vm._e(),_vm._v(" "),_c('li',[_c('el-checkbox',{attrs:{"disabled":_vm.createtype=='addFriend'||_vm.createtype=='administrators'||_vm.createtype=='assignment'||_vm.createtype=='soldierinfo'},on:{"change":function($event){_vm.checkall($event,_vm.userlist)}},model:{value:(_vm.radioStatus),callback:function ($$v) {_vm.radioStatus=$$v},expression:"radioStatus"}},[_vm._v("全选")])],1),_vm._v(" "),_c('el-checkbox-group',{attrs:{"max":_vm.limit==-1?99999999:_vm.limit},model:{value:(_vm.checklist),callback:function ($$v) {_vm.checklist=$$v},expression:"checklist"}},_vm._l((_vm.userlist),function(m,i){return _c('li',{staticClass:"clearfix"},[(_vm.chooseorg&&_vm.usertypeActive!='7'&&_vm.usertypeActive!='8')?_c('el-checkbox',{staticClass:"vCenter fl",attrs:{"label":m.id,"disabled":m.type!='1'||m.disabled},on:{"change":function($event){_vm.checkChange($event,m)}}},[_c('div',{staticClass:"vCenter"},[(m.avatar!=undefined&&m.type!='2')?_c('img',{staticClass:"userHeadImg",attrs:{"src":m.avatar,"alt":""}}):_vm._e(),_vm._v(" "),((m.avatar==null||m.avatar==undefined)&&m.type!='2')?_c('div',{staticClass:"userHeadImg defaultAvatar"},[_vm._v(_vm._s(_vm.avaname(m.name)))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(m.name))])])]):_vm._e(),_vm._v(" "),(!_vm.chooseorg&&_vm.usertypeActive!='7'&&_vm.usertypeActive!='8')?_c('el-checkbox',{staticClass:"vCenter fl",attrs:{"label":m.id,"disabled":m.disabled||(_vm.createtype=='soldierinfo'&&m.type!='2')},on:{"change":function($event){_vm.checkChange($event,m)}}},[_c('div',{staticClass:"vCenter"},[(m.avatar!=undefined&&m.type!='2')?_c('img',{staticClass:"userHeadImg",attrs:{"src":m.avatar,"alt":""}}):_vm._e(),_vm._v(" "),((m.avatar==null||m.avatar==undefined)&&m.type!='2')?_c('div',{staticClass:"userHeadImg defaultAvatar"},[_vm._v(_vm._s(_vm.avaname(m.name)))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(m.name))])])]):_vm._e(),_vm._v(" "),(_vm.usertypeActive=='7'||_vm.usertypeActive=='8')?_c('el-checkbox',{staticClass:"vCenter fl",attrs:{"label":m.id},on:{"change":function($event){_vm.checkChange($event,m)}}},[_c('div',{staticClass:"vCenter"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(m.name))])])]):_vm._e(),_vm._v(" "),(_vm.usertypeActive==3&&m.type!='1')?_c('div',{class:['fr nextdept'],on:{"click":function($event){$event.stopPropagation();_vm.nextdept(m.name,m.orgid,m.deptno,m.type)}}},[_vm._v("下级")]):_vm._e(),_vm._v(" "),((_vm.usertypeActive==7||_vm.usertypeActive==8)&&m.level<4)?_c('div',{class:['fr nextdept'],on:{"click":function($event){$event.stopPropagation();_vm.next(_vm.usertypeActive,m.id,m.name)}}},[_vm._v("下级")]):_vm._e()],1)}))],1)]),_vm._v(" "),(_vm.usertypeActive==='3')?_c('el-pagination',{attrs:{"layout":"prev, pager, next","total":_vm.total,"hide-on-single-page":1},on:{"current-change":_vm.currentChange}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"candidate-right fl"},[_c('ul',[_c('li',[(_vm.usertype.indexOf('1')!=-1||_vm.usertype.indexOf('3')!=-1)?_c('div',[_c('div',{staticClass:"vCenter"},[_c('span',{staticClass:"line"}),_vm._v(" "),_c('span',[_vm._v("已选好友：")])]),_vm._v(" "),_vm._l((_vm.tagsFriend),function(tag,index){return _c('el-tag',{key:tag.name,attrs:{"closable":!tag.disabled,"type":tag.type},on:{"close":function($event){_vm.closeTag(1,index,tag)}}},[_vm._v(_vm._s(tag.name))])}),_vm._v(" "),(_vm.tagsFriend.length==0)?_c('div',{staticClass:"occupy"}):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.usertype.indexOf('6')!=-1)?_c('div',[_c('div',{staticClass:"vCenter"},[_c('span',{staticClass:"line"}),_vm._v(" "),_c('span',[_vm._v("\n                  已选群成员：\n                  "),(_vm.limit!=-1)?_c('span',[_vm._v("（"+_vm._s(_vm.tagsFriend.length)+"/"+_vm._s(_vm.limit)+"）")]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.tagsFriend),function(tag,index){return _c('el-tag',{key:tag.name,attrs:{"closable":!tag.disabled,"type":tag.type},on:{"close":function($event){_vm.closeTag(1,index,tag)}}},[_vm._v(_vm._s(tag.name))])}),_vm._v(" "),(_vm.tagsFriend.length==0)?_c('div',{staticClass:"occupy"}):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.usertype.indexOf('2')!=-1)?_c('div',[_c('div',{staticClass:"vCenter"},[_c('span',{staticClass:"line"}),_vm._v(" "),_c('span',[_vm._v("已选群：")])]),_vm._v(" "),_vm._l((_vm.tagsGroup),function(tag,index){return _c('el-tag',{key:tag.name,attrs:{"closable":"","type":tag.type},on:{"close":function($event){_vm.closeTag(2,index,tag)}}},[_vm._v(_vm._s(tag.name))])}),_vm._v(" "),(_vm.tagsGroup.length==0)?_c('div',{staticClass:"occupy"}):_vm._e()],2):_vm._e(),_vm._v(" "),(!_vm.chooseorg)?_c('div',[_c('div',{staticClass:"vCenter"},[_c('span',{staticClass:"line"}),_vm._v(" "),_c('span',[_vm._v("已选组织：")])]),_vm._v(" "),_vm._l((_vm.tagsOrg),function(tag,index){return _c('el-tag',{key:tag.name,attrs:{"closable":"","type":tag.type},on:{"close":function($event){_vm.closeTag(3,index,tag)}}},[_vm._v(_vm._s(tag.name))])}),_vm._v(" "),(_vm.tagsOrg.length==0)?_c('div',{staticClass:"occupy"}):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.usertype.indexOf('7')!=-1)?_c('div',[_c('div',{staticClass:"vCenter"},[_c('span',{staticClass:"line"}),_vm._v(" "),_c('span',[_vm._v("已选行业：")])]),_vm._v(" "),_vm._l((_vm.tagshy),function(tag,index){return _c('el-tag',{key:tag.name,attrs:{"closable":!tag.disabled,"type":tag.type},on:{"close":function($event){_vm.closeTag(7,index,tag)}}},[_vm._v(_vm._s(tag.name))])}),_vm._v(" "),(_vm.tagsFriend.length==0)?_c('div',{staticClass:"occupy"}):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.usertype.indexOf('8')!=-1)?_c('div',[_c('div',{staticClass:"vCenter"},[_c('span',{staticClass:"line"}),_vm._v(" "),_c('span',[_vm._v("已选地区：")])]),_vm._v(" "),_vm._l((_vm.tagsdq),function(tag,index){return _c('el-tag',{key:tag.name,attrs:{"closable":!tag.disabled,"type":tag.type},on:{"close":function($event){_vm.closeTag(8,index,tag)}}},[_vm._v(_vm._s(tag.name))])}),_vm._v(" "),(_vm.tagsFriend.length==0)?_c('div',{staticClass:"occupy"}):_vm._e()],2):_vm._e()])])])]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.closecandidate}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.submitcandidate}},[_vm._v("确 定")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__um_simg__ = __webpack_require__(81);

__WEBPACK_IMPORTED_MODULE_0__um_simg__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__um_simg__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__um_simg__["a" /* default */]);
}; //注册组件
// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) { 
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__um_simg__["a" /* default */]);

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_simg_vue__ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f517570a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_simg_vue__ = __webpack_require__(84);
function injectStyle (ssrContext) {
  __webpack_require__(82)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_simg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f517570a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_simg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(83);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1b598348", content, true, {});

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".avatar-uploader .el-upload{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload:hover{border-color:#409eff}.avatar-uploader-icon{font-size:28px;color:#8c939d;width:178px;height:178px;line-height:178px!important;text-align:center}.avatar{width:178px;height:178px;display:block}", ""]);

// exports


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-upload',{staticClass:"avatar-uploader upsimg",attrs:{"auto-upload":false,"show-file-list":false,"on-change":_vm.onChange,"on-remove":_vm.remove,"before-upload":_vm.beforeAvatarUpload,"drag":"","action":"#","name":"filename0"}},[(_vm.imageUrl)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.imageUrl}}):_c('div',[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("\n        将图片拖到此处，或\n        "),_c('em',[_vm._v("点击上传")]),_vm._v("，大小不能超过 50MB\n      ")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__um_mselector__ = __webpack_require__(86);

__WEBPACK_IMPORTED_MODULE_0__um_mselector__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__um_mselector__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__um_mselector__["a" /* default */]);
}; //注册组件
// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) { 
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__um_mselector__["a" /* default */]);

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_mselector_vue__ = __webpack_require__(13);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91ef3aea_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_mselector_vue__ = __webpack_require__(92);
function injectStyle (ssrContext) {
  __webpack_require__(87)
  __webpack_require__(89)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-91ef3aea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_mselector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91ef3aea_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_mselector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(88);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("edd6e8b6", content, true, {});

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".choosepeople[data-v-91ef3aea]{height:100%;width:100%;overflow:auto;background:#fff;position:fixed;z-index:9}.big_box[data-v-91ef3aea]{width:100%;height:100%;overflow:auto;padding-top:100px;background:#f7f7f7}.bread[data-v-91ef3aea]{width:100%;border-bottom:1px solid #eee;margin-top:100px;padding:10px 15px;height:42px;overflow:hidden;color:#dadada;position:fixed;top:0;background:#fff;z-index:2}.bread .bread_ul[data-v-91ef3aea]{white-space:nowrap;overflow-x:auto}.bread .bread_ul li[data-v-91ef3aea]{display:inline-block;font-size:16px;color:#2e9cf1}.bread .bread_ul li[data-v-91ef3aea]:last-child{color:#666}.searchBox[data-v-91ef3aea]{width:100%;background:#fff;padding-top:65px;position:fixed;padding-bottom:10px;z-index:2}.searchBox .search[data-v-91ef3aea]{background-color:#f3f3f3;text-align:center;width:93%;border-radius:3px;color:#bfbfbf;line-height:20px;padding:7px 0;margin:0 auto}.list[data-v-91ef3aea]{margin-top:10px;background:#fff;width:100%}.search i[data-v-91ef3aea]{width:18px;height:18px;display:inline-block;background:url(\"/img/fangdajing_sel.png\") no-repeat;background-size:16px;vertical-align:middle}.myList .myUl[data-v-91ef3aea],.myList[data-v-91ef3aea]{width:100%;overflow:hidden}.myLi[data-v-91ef3aea],.recentList[data-v-91ef3aea]{width:100%;background-color:#fff;padding:10px 15px;float:left}.myLi .avatar[data-v-91ef3aea],.myLi .no_avatar[data-v-91ef3aea],.recentList .avatar[data-v-91ef3aea],.recentList .no_avatar[data-v-91ef3aea]{float:left;width:40px;height:40px;border-radius:50%;text-align:center;line-height:40px;color:#fff}.myLi .avatar img[data-v-91ef3aea],.myLi .no_avatar img[data-v-91ef3aea],.recentList .avatar img[data-v-91ef3aea],.recentList .no_avatar img[data-v-91ef3aea]{width:40px;height:40px;border-radius:50%;object-fit:cover}.myLi .no_avatar[data-v-91ef3aea],.recentList .no_avatar[data-v-91ef3aea]{background:#34b2fd}.myLi .name[data-v-91ef3aea],.recentList .name[data-v-91ef3aea]{line-height:40px;margin-left:10px;font-size:15px;max-width:70%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;float:left}.myLi .name img[data-v-91ef3aea],.recentList .name img[data-v-91ef3aea]{width:20px;height:20px;float:left;margin-top:10px;margin-left:10px}.recent[data-v-91ef3aea]{color:#999;font-size:12px;padding:10px 15px}.recentList[data-v-91ef3aea]{background:#fff;width:100%;margin-bottom:53px}.recentList .el-checkbox[data-v-91ef3aea]{line-height:60px;height:60px;width:100%}.recentList .el-checkbox .el-checkbox__label[data-v-91ef3aea]{font-size:15px;color:#333;width:100%}.group_list[data-v-91ef3aea],.org_list[data-v-91ef3aea],.people_list[data-v-91ef3aea]{padding-top:5px;margin-bottom:53px;margin-top:140px;width:100%;overflow:hidden}.member_list .list_ul[data-v-91ef3aea],.member_list[data-v-91ef3aea]{width:100%}.member_list .list_ul .section[data-v-91ef3aea]{width:100%;margin:5px 0;background-color:#f6f6f6;overflow:hidden}.member_list .list_ul .section .letter[data-v-91ef3aea]{padding:0 15px;color:#9a9a9c;line-height:25px;font-size:15px}.member_list .list_ul .section .el-checkbox-group[data-v-91ef3aea]{overflow:hidden;background:#fff}.member_list .list_ul .section .el-checkbox-group .el-checkbox[data-v-91ef3aea]{width:100%;float:left;font-size:12px;line-height:20px;padding:10px 15px;border-bottom:1px solid #ededed}.member_list .list_ul .section .el-checkbox-group .el-checkbox[data-v-91ef3aea] .el-checkbox__label{width:calc(100% - 30px)}.member_list .list_ul .section .el-checkbox-group .el-checkbox[data-v-91ef3aea] .el-checkbox__label .avatar{width:40px;height:40px;float:left}.member_list .list_ul .section .el-checkbox-group .el-checkbox[data-v-91ef3aea] .el-checkbox__label .avatar img{width:40px;height:40px;border-radius:50%;object-fit:cover}.member_list .list_ul .section .el-checkbox-group .el-checkbox[data-v-91ef3aea] .el-checkbox__label .avatar .noAvatar{width:40px;height:40px;border-radius:50%;background-color:#34b2fd;text-align:center;line-height:40px;color:#fff}.member_list .list_ul .section .el-checkbox-group .el-checkbox[data-v-91ef3aea] .el-checkbox__label .name_phone{float:left;margin-left:10px;height:40px;display:flex;align-items:left;justify-content:space-around;flex-direction:column;padding-top:2px;max-width:55%}.member_list .list_ul .section .el-checkbox-group .el-checkbox[data-v-91ef3aea] .el-checkbox__label .name_phone p{width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.member_list .list_ul .section .el-checkbox-group .el-checkbox[data-v-91ef3aea] .el-checkbox__label .name_phone .name{float:left;color:#000;font-size:14px}.member_list .list_ul .section .el-checkbox-group .el-checkbox[data-v-91ef3aea] .el-checkbox__label .name_phone .phone{clear:both;color:#666}.member_list .list_ul .section .el-checkbox-group .el-checkbox[data-v-91ef3aea] .el-checkbox__label .company{float:right;text-align:right;max-width:30%}.member_list .list_ul .section .el-checkbox-group .el-checkbox[data-v-91ef3aea] .el-checkbox__label .company p{width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.member_list .list_ul .section .el-checkbox-group .van-checkbox[data-v-91ef3aea]:last-child{border:none}.groupUl[data-v-91ef3aea]{float:left;width:100%;background:#fff}.groupUl .el-checkbox[data-v-91ef3aea]{padding:10px 15px;width:100%;border-bottom:1px solid #ededed}.groupUl .el-checkbox .avatar[data-v-91ef3aea]{width:40px;height:40px;border-radius:50%;float:left}.groupUl .el-checkbox .avatar img[data-v-91ef3aea]{width:40px;height:40px;border-radius:50%;object-fit:cover}.groupUl .el-checkbox .right[data-v-91ef3aea]{max-width:calc(100% - 50px);margin-left:10px;height:40px;line-height:40px;float:left}.groupUl .el-checkbox .right span[data-v-91ef3aea]{width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:inline-block}.groupUl .el-checkbox[data-v-91ef3aea]:last-child{border:none}.orglist[data-v-91ef3aea]{width:100%;overflow:hidden;background:#f7f7f7}.orglist .org_ul[data-v-91ef3aea]{width:100%;float:left;line-height:25px;padding:0 15px;padding-top:10px;background:#fff}.orglist .org_ul .el-checkbox[data-v-91ef3aea]{overflow:hidden;width:calc(100% - 69px)}.orglist .org_ul .el-checkbox[data-v-91ef3aea] .el-checkbox__label{width:100%}.orglist .org_ul .el-checkbox[data-v-91ef3aea] .el-checkbox__label .avatar{width:40px;height:40px;border-radius:50%;float:left}.orglist .org_ul .el-checkbox[data-v-91ef3aea] .el-checkbox__label .avatar img{width:40px;height:40px;border-radius:50%;object-fit:cover}.orglist .org_ul .el-checkbox[data-v-91ef3aea] .el-checkbox__label .noAvatar{width:40px;height:40px;border-radius:50%;background-color:#34b2fd;float:left;text-align:center;line-height:40px;color:#fff}.orglist .org_ul .el-checkbox[data-v-91ef3aea] .el-checkbox__label .name{margin-left:10px;float:left;max-width:80%;line-height:40px}.orglist .org_ul .el-checkbox[data-v-91ef3aea] .el-checkbox__label .name span{display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;float:left;font-size:16px;font-weight:500;max-width:100%}.orglist .org_ul .el-checkbox[data-v-91ef3aea] .el-checkbox__label .name img{width:20px;height:20px;float:left;margin-top:10px;margin-left:10px}.orglist .org_ul li .next[data-v-91ef3aea]{float:right;color:#2e9cf1;line-height:40px;font-size:14px}.orglist .org_ul li .next img[data-v-91ef3aea]{width:12px;height:16px}.orglist .manList[data-v-91ef3aea]{margin-top:10px}.orglist .rightBox[data-v-91ef3aea]{float:left;margin-left:10px;width:calc(100% - 10px)}.orglist .rightBox .name[data-v-91ef3aea]{float:left;line-height:40px;font-size:16px}.orglist .rightBox .job[data-v-91ef3aea]{float:right;line-height:40px}.sure[data-v-91ef3aea]{width:100%;float:left;background:#fff;position:fixed;bottom:0;left:0;right:0;z-index:2;padding:10px 15px;line-height:32px;border-top:1px solid #ededed}.sure .left[data-v-91ef3aea]{float:left}.sure .choosedPeople[data-v-91ef3aea]{float:left;height:100%;overflow:hidden}.sure .right[data-v-91ef3aea]{float:right}.choosepeople[data-v-91ef3aea]::-webkit-scrollbar-track{background-color:#f5f5f5;-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.22)}@media (max-width:750px){.choosepeople[data-v-91ef3aea]{width:100%;height:100%}}.special .big_box[data-v-91ef3aea],.special[data-v-91ef3aea]{width:100%;height:100%;overflow:auto}.special .big_box[data-v-91ef3aea]{padding-top:70px;background:#fff}.special .big_box .listUl[data-v-91ef3aea]{width:100%;overflow:hidden}.special .big_box .listUl .listLi[data-v-91ef3aea]{width:100%;line-height:40px;font-size:15px;padding:10px 15px;float:left;border-bottom:1px solid #ededed}.special .big_box .listUl .listLi .avatar[data-v-91ef3aea],.special .big_box .listUl .listLi .no_avatar[data-v-91ef3aea]{width:40px;height:40px;border-radius:50%;float:left}.special .big_box .listUl .listLi .avatar img[data-v-91ef3aea],.special .big_box .listUl .listLi .no_avatar img[data-v-91ef3aea]{width:40px;height:40px;border-radius:50%;object-fit:cover}.special .big_box .listUl .listLi .no_avatar[data-v-91ef3aea]{background:#3696fa;text-align:center;color:#fff;line-height:40px}.special .big_box .listUl .listLi .name[data-v-91ef3aea]{float:left;margin-left:15px}.special .big_box .listUl .listLi .remove[data-v-91ef3aea]{float:right;color:#fb6155}.special .big_box .listUl .listLi[data-v-91ef3aea]:last-child{border:none}.special .big_box .listUl .classify[data-v-91ef3aea]{background:#f6f6f6;color:#9a9a9c;clear:both;padding:5px 15px}.spectial[data-v-91ef3aea]{position:fixed;left:0;right:0;z-index:2}", ""]);

// exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(90);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("52781978", content, true, {});

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".choosepeople .el-checkbox-group>.el-checkbox+.el-checkbox{color:#333;margin:0}.choosepeople .el-checkbox__input>.el-checkbox__inner{width:20px;height:20px;border-radius:50%}.choosepeople .el-checkbox__input>.el-checkbox__inner:after{left:7px;top:4px}.choosepeople .el-checkbox>.el-checkbox__input.is-checked+.el-checkbox__label{color:#333}.choosepeople .el-checkbox>.el-checkbox__input{margin-top:-30px}", ""]);

// exports


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* harmony default export */ __webpack_exports__["a"] = ({
    strChineseFirstPY: function strChineseFirstPY() {
        var a = "YDYQSXMWZSSXJBYMGCCZQPSSQBYCDSCDQLDYLYBSSJGYZZJJFKCCLZDHWDWZJLJPFYYNWJJTMYHZWZHFLZPPQHGSCYYYNJQYXXGJHHSDSJNKKTMOMLCRXYPSNQSECCQZGGLLYJLMYZZSECYKYYHQWJSSGGYXYZYJWWKDJHYCHMYXJTLXJYQBYXZLDWRDJRWYSRLDZJPCBZJJBRCFTLECZSTZFXXZHTRQHYBDLYCZSSYMMRFMYQZPWWJJYFCRWFDFZQPYDDWYXKYJAWJFFXYPSFTZYHHYZYSWCJYXSCLCXXWZZXNBGNNXBXLZSZSBSGPYSYZDHMDZBQBZCWDZZYYTZHBTSYYBZGNTNXQYWQSKBPHHLXGYBFMJEBJHHGQTJCYSXSTKZHLYCKGLYSMZXYALMELDCCXGZYRJXSDLTYZCQKCNNJWHJTZZCQLJSTSTBNXBTYXCEQXGKWJYFLZQLYHYXSPSFXLMPBYSXXXYDJCZYLLLSJXFHJXPJBTFFYABYXBHZZBJYZLWLCZGGBTSSMDTJZXPTHYQTGLJSCQFZKJZJQNLZWLSLHDZBWJNCJZYZSQQYCQYRZCJJWYBRTWPYFTWEXCSKDZCTBZHYZZYYJXZCFFZZMJYXXSDZZOTTBZLQWFCKSZSXFYRLNYJMBDTHJXSQQCCSBXYYTSYFBXDZTGBCNSLCYZZPSAZYZZSCJCSHZQYDXLBPJLLMQXTYDZXSQJTZPXLCGLQTZWJBHCTSYJSFXYEJJTLBGXSXJMYJQQPFZASYJNTYDJXKJCDJSZCBARTDCLYJQMWNQNCLLLKBYBZZSYHQQLTWLCCXTXLLZNTYLNEWYZYXCZXXGRKRMTCNDNJTSYYSSDQDGHSDBJGHRWRQLYBGLXHLGTGXBQJDZPYJSJYJCTMRNYMGRZJCZGJMZMGXMPRYXKJNYMSGMZJYMKMFXMLDTGFBHCJHKYLPFMDXLQJJSMTQGZSJLQDLDGJYCALCMZCSDJLLNXDJFFFFJCZFMZFFPFKHKGDPSXKTACJDHHZDDCRRCFQYJKQCCWJDXHWJLYLLZGCFCQDSMLZPBJJPLSBCJGGDCKKDEZSQCCKJGCGKDJTJDLZYCXKLQSCGJCLTFPCQCZGWPJDQYZJJBYJHSJDZWGFSJGZKQCCZLLPSPKJGQJHZZLJPLGJGJJTHJJYJZCZMLZLYQBGJWMLJKXZDZNJQSYZMLJLLJKYWXMKJLHSKJGBMCLYYMKXJQLBMLLKMDXXKWYXYSLMLPSJQQJQXYXFJTJDXMXXLLCXQBSYJBGWYMBGGBCYXPJYGPEPFGDJGBHBNSQJYZJKJKHXQFGQZKFHYGKHDKLLSDJQXPQYKYBNQSXQNSZSWHBSXWHXWBZZXDMNSJBSBKBBZKLYLXGWXDRWYQZMYWSJQLCJXXJXKJEQXSCYETLZHLYYYSDZPAQYZCMTLSHTZCFYZYXYLJSDCJQAGYSLCQLYYYSHMRQQKLDXZSCSSSYDYCJYSFSJBFRSSZQSBXXPXJYSDRCKGJLGDKZJZBDKTCSYQPYHSTCLDJDHMXMCGXYZHJDDTMHLTXZXYLYMOHYJCLTYFBQQXPFBDFHHTKSQHZYYWCNXXCRWHOWGYJLEGWDQCWGFJYCSNTMYTOLBYGWQWESJPWNMLRYDZSZTXYQPZGCWXHNGPYXSHMYQJXZTDPPBFYHZHTJYFDZWKGKZBLDNTSXHQEEGZZYLZMMZYJZGXZXKHKSTXNXXWYLYAPSTHXDWHZYMPXAGKYDXBHNHXKDPJNMYHYLPMGOCSLNZHKXXLPZZLBMLSFBHHGYGYYGGBHSCYAQTYWLXTZQCEZYDQDQMMHTKLLSZHLSJZWFYHQSWSCWLQAZYNYTLSXTHAZNKZZSZZLAXXZWWCTGQQTDDYZTCCHYQZFLXPSLZYGPZSZNGLNDQTBDLXGTCTAJDKYWNSYZLJHHZZCWNYYZYWMHYCHHYXHJKZWSXHZYXLYSKQYSPSLYZWMYPPKBYGLKZHTYXAXQSYSHXASMCHKDSCRSWJPWXSGZJLWWSCHSJHSQNHCSEGNDAQTBAALZZMSSTDQJCJKTSCJAXPLGGXHHGXXZCXPDMMHLDGTYBYSJMXHMRCPXXJZCKZXSHMLQXXTTHXWZFKHCCZDYTCJYXQHLXDHYPJQXYLSYYDZOZJNYXQEZYSQYAYXWYPDGXDDXSPPYZNDLTWRHXYDXZZJHTCXMCZLHPYYYYMHZLLHNXMYLLLMDCPPXHMXDKYCYRDLTXJCHHZZXZLCCLYLNZSHZJZZLNNRLWHYQSNJHXYNTTTKYJPYCHHYEGKCTTWLGQRLGGTGTYGYHPYHYLQYQGCWYQKPYYYTTTTLHYHLLTYTTSPLKYZXGZWGPYDSSZZDQXSKCQNMJJZZBXYQMJRTFFBTKHZKBXLJJKDXJTLBWFZPPTKQTZTGPDGNTPJYFALQMKGXBDCLZFHZCLLLLADPMXDJHLCCLGYHDZFGYDDGCYYFGYDXKSSEBDHYKDKDKHNAXXYBPBYYHXZQGAFFQYJXDMLJCSQZLLPCHBSXGJYNDYBYQSPZWJLZKSDDTACTBXZDYZYPJZQSJNKKTKNJDJGYYPGTLFYQKASDNTCYHBLWDZHBBYDWJRYGKZYHEYYFJMSDTYFZJJHGCXPLXHLDWXXJKYTCYKSSSMTWCTTQZLPBSZDZWZXGZAGYKTYWXLHLSPBCLLOQMMZSSLCMBJCSZZKYDCZJGQQDSMCYTZQQLWZQZXSSFPTTFQMDDZDSHDTDWFHTDYZJYQJQKYPBDJYYXTLJHDRQXXXHAYDHRJLKLYTWHLLRLLRCXYLBWSRSZZSYMKZZHHKYHXKSMDSYDYCJPBZBSQLFCXXXNXKXWYWSDZYQOGGQMMYHCDZTTFJYYBGSTTTYBYKJDHKYXBELHTYPJQNFXFDYKZHQKZBYJTZBXHFDXKDASWTAWAJLDYJSFHBLDNNTNQJTJNCHXFJSRFWHZFMDRYJYJWZPDJKZYJYMPCYZNYNXFBYTFYFWYGDBNZZZDNYTXZEMMQBSQEHXFZMBMFLZZSRXYMJGSXWZJSPRYDJSJGXHJJGLJJYNZZJXHGXKYMLPYYYCXYTWQZSWHWLYRJLPXSLSXMFSWWKLCTNXNYNPSJSZHDZEPTXMYYWXYYSYWLXJQZQXZDCLEEELMCPJPCLWBXSQHFWWTFFJTNQJHJQDXHWLBYZNFJLALKYYJLDXHHYCSTYYWNRJYXYWTRMDRQHWQCMFJDYZMHMYYXJWMYZQZXTLMRSPWWCHAQBXYGZYPXYYRRCLMPYMGKSJSZYSRMYJSNXTPLNBAPPYPYLXYYZKYNLDZYJZCZNNLMZHHARQMPGWQTZMXXMLLHGDZXYHXKYXYCJMFFYYHJFSBSSQLXXNDYCANNMTCJCYPRRNYTYQNYYMBMSXNDLYLYSLJRLXYSXQMLLYZLZJJJKYZZCSFBZXXMSTBJGNXYZHLXNMCWSCYZYFZLXBRNNNYLBNRTGZQYSATSWRYHYJZMZDHZGZDWYBSSCSKXSYHYTXXGCQGXZZSHYXJSCRHMKKBXCZJYJYMKQHZJFNBHMQHYSNJNZYBKNQMCLGQHWLZNZSWXKHLJHYYBQLBFCDSXDLDSPFZPSKJYZWZXZDDXJSMMEGJSCSSMGCLXXKYYYLNYPWWWGYDKZJGGGZGGSYCKNJWNJPCXBJJTQTJWDSSPJXZXNZXUMELPXFSXTLLXCLJXJJLJZXCTPSWXLYDHLYQRWHSYCSQYYBYAYWJJJQFWQCQQCJQGXALDBZZYJGKGXPLTZYFXJLTPADKYQHPMATLCPDCKBMTXYBHKLENXDLEEGQDYMSAWHZMLJTWYGXLYQZLJEEYYBQQFFNLYXRDSCTGJGXYYNKLLYQKCCTLHJLQMKKZGCYYGLLLJDZGYDHZWXPYSJBZKDZGYZZHYWYFQYTYZSZYEZZLYMHJJHTSMQWYZLKYYWZCSRKQYTLTDXWCTYJKLWSQZWBDCQYNCJSRSZJLKCDCDTLZZZACQQZZDDXYPLXZBQJYLZLLLQDDZQJYJYJZYXNYYYNYJXKXDAZWYRDLJYYYRJLXLLDYXJCYWYWNQCCLDDNYYYNYCKCZHXXCCLGZQJGKWPPCQQJYSBZZXYJSQPXJPZBSBDSFNSFPZXHDWZTDWPPTFLZZBZDMYYPQJRSDZSQZSQXBDGCPZSWDWCSQZGMDHZXMWWFYBPDGPHTMJTHZSMMBGZMBZJCFZWFZBBZMQCFMBDMCJXLGPNJBBXGYHYYJGPTZGZMQBQTCGYXJXLWZKYDPDYMGCFTPFXYZTZXDZXTGKMTYBBCLBJASKYTSSQYYMSZXFJEWLXLLSZBQJJJAKLYLXLYCCTSXMCWFKKKBSXLLLLJYXTYLTJYYTDPJHNHNNKBYQNFQYYZBYYESSESSGDYHFHWTCJBSDZZTFDMXHCNJZYMQWSRYJDZJQPDQBBSTJGGFBKJBXTGQHNGWJXJGDLLTHZHHYYYYYYSXWTYYYCCBDBPYPZYCCZYJPZYWCBDLFWZCWJDXXHYHLHWZZXJTCZLCDPXUJCZZZLYXJJTXPHFXWPYWXZPTDZZBDZCYHJHMLXBQXSBYLRDTGJRRCTTTHYTCZWMXFYTWWZCWJWXJYWCSKYBZSCCTZQNHXNWXXKHKFHTSWOCCJYBCMPZZYKBNNZPBZHHZDLSYDDYTYFJPXYNGFXBYQXCBHXCPSXTYZDMKYSNXSXLHKMZXLYHDHKWHXXSSKQYHHCJYXGLHZXCSNHEKDTGZXQYPKDHEXTYKCNYMYYYPKQYYYKXZLTHJQTBYQHXBMYHSQCKWWYLLHCYYLNNEQXQWMCFBDCCMLJGGXDQKTLXKGNQCDGZJWYJJLYHHQTTTNWCHMXCXWHWSZJYDJCCDBQCDGDNYXZTHCQRXCBHZTQCBXWGQWYYBXHMBYMYQTYEXMQKYAQYRGYZSLFYKKQHYSSQYSHJGJCNXKZYCXSBXYXHYYLSTYCXQTHYSMGSCPMMGCCCCCMTZTASMGQZJHKLOSQYLSWTMXSYQKDZLJQQYPLSYCZTCQQPBBQJZCLPKHQZYYXXDTDDTSJCXFFLLCHQXMJLWCJCXTSPYCXNDTJSHJWXDQQJSKXYAMYLSJHMLALYKXCYYDMNMDQMXMCZNNCYBZKKYFLMCHCMLHXRCJJHSYLNMTJZGZGYWJXSRXCWJGJQHQZDQJDCJJZKJKGDZQGJJYJYLXZXXCDQHHHEYTMHLFSBDJSYYSHFYSTCZQLPBDRFRZTZYKYWHSZYQKWDQZRKMSYNBCRXQBJYFAZPZZEDZCJYWBCJWHYJBQSZYWRYSZPTDKZPFPBNZTKLQYHBBZPNPPTYZZYBQNYDCPJMMCYCQMCYFZZDCMNLFPBPLNGQJTBTTNJZPZBBZNJKLJQYLNBZQHKSJZNGGQSZZKYXSHPZSNBCGZKDDZQANZHJKDRTLZLSWJLJZLYWTJNDJZJHXYAYNCBGTZCSSQMNJPJYTYSWXZFKWJQTKHTZPLBHSNJZSYZBWZZZZLSYLSBJHDWWQPSLMMFBJDWAQYZTCJTBNNWZXQXCDSLQGDSDPDZHJTQQPSWLYYJZLGYXYZLCTCBJTKTYCZJTQKBSJLGMGZDMCSGPYNJZYQYYKNXRPWSZXMTNCSZZYXYBYHYZAXYWQCJTLLCKJJTJHGDXDXYQYZZBYWDLWQCGLZGJGQRQZCZSSBCRPCSKYDZNXJSQGXSSJMYDNSTZTPBDLTKZWXQWQTZEXNQCZGWEZKSSBYBRTSSSLCCGBPSZQSZLCCGLLLZXHZQTHCZMQGYZQZNMCOCSZJMMZSQPJYGQLJYJPPLDXRGZYXCCSXHSHGTZNLZWZKJCXTCFCJXLBMQBCZZWPQDNHXLJCTHYZLGYLNLSZZPCXDSCQQHJQKSXZPBAJYEMSMJTZDXLCJYRYYNWJBNGZZTMJXLTBSLYRZPYLSSCNXPHLLHYLLQQZQLXYMRSYCXZLMMCZLTZSDWTJJLLNZGGQXPFSKYGYGHBFZPDKMWGHCXMSGDXJMCJZDYCABXJDLNBCDQYGSKYDQTXDJJYXMSZQAZDZFSLQXYJSJZYLBTXXWXQQZBJZUFBBLYLWDSLJHXJYZJWTDJCZFQZQZZDZSXZZQLZCDZFJHYSPYMPQZMLPPLFFXJJNZZYLSJEYQZFPFZKSYWJJJHRDJZZXTXXGLGHYDXCSKYSWMMZCWYBAZBJKSHFHJCXMHFQHYXXYZFTSJYZFXYXPZLCHMZMBXHZZSXYFYMNCWDABAZLXKTCSHHXKXJJZJSTHYGXSXYYHHHJWXKZXSSBZZWHHHCWTZZZPJXSNXQQJGZYZYWLLCWXZFXXYXYHXMKYYSWSQMNLNAYCYSPMJKHWCQHYLAJJMZXHMMCNZHBHXCLXTJPLTXYJHDYYLTTXFSZHYXXSJBJYAYRSMXYPLCKDUYHLXRLNLLSTYZYYQYGYHHSCCSMZCTZQXKYQFPYYRPFFLKQUNTSZLLZMWWTCQQYZWTLLMLMPWMBZSSTZRBPDDTLQJJBXZCSRZQQYGWCSXFWZLXCCRSZDZMCYGGDZQSGTJSWLJMYMMZYHFBJDGYXCCPSHXNZCSBSJYJGJMPPWAFFYFNXHYZXZYLREMZGZCYZSSZDLLJCSQFNXZKPTXZGXJJGFMYYYSNBTYLBNLHPFZDCYFBMGQRRSSSZXYSGTZRNYDZZCDGPJAFJFZKNZBLCZSZPSGCYCJSZLMLRSZBZZLDLSLLYSXSQZQLYXZLSKKBRXBRBZCYCXZZZEEYFGKLZLYYHGZSGZLFJHGTGWKRAAJYZKZQTSSHJJXDCYZUYJLZYRZDQQHGJZXSSZBYKJPBFRTJXLLFQWJHYLQTYMBLPZDXTZYGBDHZZRBGXHWNJTJXLKSCFSMWLSDQYSJTXKZSCFWJLBXFTZLLJZLLQBLSQMQQCGCZFPBPHZCZJLPYYGGDTGWDCFCZQYYYQYSSCLXZSKLZZZGFFCQNWGLHQYZJJCZLQZZYJPJZZBPDCCMHJGXDQDGDLZQMFGPSYTSDYFWWDJZJYSXYYCZCYHZWPBYKXRYLYBHKJKSFXTZJMMCKHLLTNYYMSYXYZPYJQYCSYCWMTJJKQYRHLLQXPSGTLYYCLJSCPXJYZFNMLRGJJTYZBXYZMSJYJHHFZQMSYXRSZCWTLRTQZSSTKXGQKGSPTGCZNJSJCQCXHMXGGZTQYDJKZDLBZSXJLHYQGGGTHQSZPYHJHHGYYGKGGCWJZZYLCZLXQSFTGZSLLLMLJSKCTBLLZZSZMMNYTPZSXQHJCJYQXYZXZQZCPSHKZZYSXCDFGMWQRLLQXRFZTLYSTCTMJCXJJXHJNXTNRZTZFQYHQGLLGCXSZSJDJLJCYDSJTLNYXHSZXCGJZYQPYLFHDJSBPCCZHJJJQZJQDYBSSLLCMYTTMQTBHJQNNYGKYRQYQMZGCJKPDCGMYZHQLLSLLCLMHOLZGDYYFZSLJCQZLYLZQJESHNYLLJXGJXLYSYYYXNBZLJSSZCQQCJYLLZLTJYLLZLLBNYLGQCHXYYXOXCXQKYJXXXYKLXSXXYQXCYKQXQCSGYXXYQXYGYTQOHXHXPYXXXULCYEYCHZZCBWQBBWJQZSCSZSSLZYLKDESJZWMYMCYTSDSXXSCJPQQSQYLYYZYCMDJDZYWCBTJSYDJKCYDDJLBDJJSODZYSYXQQYXDHHGQQYQHDYXWGMMMAJDYBBBPPBCMUUPLJZSMTXERXJMHQNUTPJDCBSSMSSSTKJTSSMMTRCPLZSZMLQDSDMJMQPNQDXCFYNBFSDQXYXHYAYKQYDDLQYYYSSZBYDSLNTFQTZQPZMCHDHCZCWFDXTMYQSPHQYYXSRGJCWTJTZZQMGWJJTJHTQJBBHWZPXXHYQFXXQYWYYHYSCDYDHHQMNMTMWCPBSZPPZZGLMZFOLLCFWHMMSJZTTDHZZYFFYTZZGZYSKYJXQYJZQBHMBZZLYGHGFMSHPZFZSNCLPBQSNJXZSLXXFPMTYJYGBXLLDLXPZJYZJYHHZCYWHJYLSJEXFSZZYWXKZJLUYDTMLYMQJPWXYHXSKTQJEZRPXXZHHMHWQPWQLYJJQJJZSZCPHJLCHHNXJLQWZJHBMZYXBDHHYPZLHLHLGFWLCHYYTLHJXCJMSCPXSTKPNHQXSRTYXXTESYJCTLSSLSTDLLLWWYHDHRJZSFGXTSYCZYNYHTDHWJSLHTZDQDJZXXQHGYLTZPHCSQFCLNJTCLZPFSTPDYNYLGMJLLYCQHYSSHCHYLHQYQTMZYPBYWRFQYKQSYSLZDQJMPXYYSSRHZJNYWTQDFZBWWTWWRXCWHGYHXMKMYYYQMSMZHNGCEPMLQQMTCWCTMMPXJPJJHFXYYZSXZHTYBMSTSYJTTQQQYYLHYNPYQZLCYZHZWSMYLKFJXLWGXYPJYTYSYXYMZCKTTWLKSMZSYLMPWLZWXWQZSSAQSYXYRHSSNTSRAPXCPWCMGDXHXZDZYFJHGZTTSBJHGYZSZYSMYCLLLXBTYXHBBZJKSSDMALXHYCFYGMQYPJYCQXJLLLJGSLZGQLYCJCCZOTYXMTMTTLLWTGPXYMZMKLPSZZZXHKQYSXCTYJZYHXSHYXZKXLZWPSQPYHJWPJPWXQQYLXSDHMRSLZZYZWTTCYXYSZZSHBSCCSTPLWSSCJCHNLCGCHSSPHYLHFHHXJSXYLLNYLSZDHZXYLSXLWZYKCLDYAXZCMDDYSPJTQJZLNWQPSSSWCTSTSZLBLNXSMNYYMJQBQHRZWTYYDCHQLXKPZWBGQYBKFCMZWPZLLYYLSZYDWHXPSBCMLJBSCGBHXLQHYRLJXYSWXWXZSLDFHLSLYNJLZYFLYJYCDRJLFSYZFSLLCQYQFGJYHYXZLYLMSTDJCYHBZLLNWLXXYGYYHSMGDHXXHHLZZJZXCZZZCYQZFNGWPYLCPKPYYPMCLQKDGXZGGWQBDXZZKZFBXXLZXJTPJPTTBYTSZZDWSLCHZHSLTYXHQLHYXXXYYZYSWTXZKHLXZXZPYHGCHKCFSYHUTJRLXFJXPTZTWHPLYXFCRHXSHXKYXXYHZQDXQWULHYHMJTBFLKHTXCWHJFWJCFPQRYQXCYYYQYGRPYWSGSUNGWCHKZDXYFLXXHJJBYZWTSXXNCYJJYMSWZJQRMHXZWFQSYLZJZGBHYNSLBGTTCSYBYXXWXYHXYYXNSQYXMQYWRGYQLXBBZLJSYLPSYTJZYHYZAWLRORJMKSCZJXXXYXCHDYXRYXXJDTSQFXLYLTSFFYXLMTYJMJUYYYXLTZCSXQZQHZXLYYXZHDNBRXXXJCTYHLBRLMBRLLAXKYLLLJLYXXLYCRYLCJTGJCMTLZLLCYZZPZPCYAWHJJFYBDYYZSMPCKZDQYQPBPCJPDCYZMDPBCYYDYCNNPLMTMLRMFMMGWYZBSJGYGSMZQQQZTXMKQWGXLLPJGZBQCDJJJFPKJKCXBLJMSWMDTQJXLDLPPBXCWRCQFBFQJCZAHZGMYKPHYYHZYKNDKZMBPJYXPXYHLFPNYYGXJDBKXNXHJMZJXSTRSTLDXSKZYSYBZXJLXYSLBZYSLHXJPFXPQNBYLLJQKYGZMCYZZYMCCSLCLHZFWFWYXZMWSXTYNXJHPYYMCYSPMHYSMYDYSHQYZCHMJJMZCAAGCFJBBHPLYZYLXXSDJGXDHKXXTXXNBHRMLYJSLTXMRHNLXQJXYZLLYSWQGDLBJHDCGJYQYCMHWFMJYBMBYJYJWYMDPWHXQLDYGPDFXXBCGJSPCKRSSYZJMSLBZZJFLJJJLGXZGYXYXLSZQYXBEXYXHGCXBPLDYHWETTWWCJMBTXCHXYQXLLXFLYXLLJLSSFWDPZSMYJCLMWYTCZPCHQEKCQBWLCQYDPLQPPQZQFJQDJHYMMCXTXDRMJWRHXCJZYLQXDYYNHYYHRSLSRSYWWZJYMTLTLLGTQCJZYABTCKZCJYCCQLJZQXALMZYHYWLWDXZXQDLLQSHGPJFJLJHJABCQZDJGTKHSSTCYJLPSWZLXZXRWGLDLZRLZXTGSLLLLZLYXXWGDZYGBDPHZPBRLWSXQBPFDWOFMWHLYPCBJCCLDMBZPBZZLCYQXLDOMZBLZWPDWYYGDSTTHCSQSCCRSSSYSLFYBFNTYJSZDFNDPDHDZZMBBLSLCMYFFGTJJQWFTMTPJWFNLBZCMMJTGBDZLQLPYFHYYMJYLSDCHDZJWJCCTLJCLDTLJJCPDDSQDSSZYBNDBJLGGJZXSXNLYCYBJXQYCBYLZCFZPPGKCXZDZFZTJJFJSJXZBNZYJQTTYJYHTYCZHYMDJXTTMPXSPLZCDWSLSHXYPZGTFMLCJTYCBPMGDKWYCYZCDSZZYHFLYCTYGWHKJYYLSJCXGYWJCBLLCSNDDBTZBSCLYZCZZSSQDLLMQYYHFSLQLLXFTYHABXGWNYWYYPLLSDLDLLBJCYXJZMLHLJDXYYQYTDLLLBUGBFDFBBQJZZMDPJHGCLGMJJPGAEHHBWCQXAXHHHZCHXYPHJAXHLPHJPGPZJQCQZGJJZZUZDMQYYBZZPHYHYBWHAZYJHYKFGDPFQSDLZMLJXKXGALXZDAGLMDGXMWZQYXXDXXPFDMMSSYMPFMDMMKXKSYZYSHDZKXSYSMMZZZMSYDNZZCZXFPLSTMZDNMXCKJMZTYYMZMZZMSXHHDCZJEMXXKLJSTLWLSQLYJZLLZJSSDPPMHNLZJCZYHMXXHGZCJMDHXTKGRMXFWMCGMWKDTKSXQMMMFZZYDKMSCLCMPCGMHSPXQPZDSSLCXKYXTWLWJYAHZJGZQMCSNXYYMMPMLKJXMHLMLQMXCTKZMJQYSZJSYSZHSYJZJCDAJZYBSDQJZGWZQQXFKDMSDJLFWEHKZQKJPEYPZYSZCDWYJFFMZZYLTTDZZEFMZLBNPPLPLPEPSZALLTYLKCKQZKGENQLWAGYXYDPXLHSXQQWQCQXQCLHYXXMLYCCWLYMQYSKGCHLCJNSZKPYZKCQZQLJPDMDZHLASXLBYDWQLWDNBQCRYDDZTJYBKBWSZDXDTNPJDTCTQDFXQQMGNXECLTTBKPWSLCTYQLPWYZZKLPYGZCQQPLLKCCYLPQMZCZQCLJSLQZDJXLDDHPZQDLJJXZQDXYZQKZLJCYQDYJPPYPQYKJYRMPCBYMCXKLLZLLFQPYLLLMBSGLCYSSLRSYSQTMXYXZQZFDZUYSYZTFFMZZSMZQHZSSCCMLYXWTPZGXZJGZGSJSGKDDHTQGGZLLBJDZLCBCHYXYZHZFYWXYZYMSDBZZYJGTSMTFXQYXQSTDGSLNXDLRYZZLRYYLXQHTXSRTZNGZXBNQQZFMYKMZJBZYMKBPNLYZPBLMCNQYZZZSJZHJCTZKHYZZJRDYZHNPXGLFZTLKGJTCTSSYLLGZRZBBQZZKLPKLCZYSSUYXBJFPNJZZXCDWXZYJXZZDJJKGGRSRJKMSMZJLSJYWQSKYHQJSXPJZZZLSNSHRNYPZTWCHKLPSRZLZXYJQXQKYSJYCZTLQZYBBYBWZPQDWWYZCYTJCJXCKCWDKKZXSGKDZXWWYYJQYYTCYTDLLXWKCZKKLCCLZCQQDZLQLCSFQCHQHSFSMQZZLNBJJZBSJHTSZDYSJQJPDLZCDCWJKJZZLPYCGMZWDJJBSJQZSYZYHHXJPBJYDSSXDZNCGLQMBTSFSBPDZDLZNFGFJGFSMPXJQLMBLGQCYYXBQKDJJQYRFKZTJDHCZKLBSDZCFJTPLLJGXHYXZCSSZZXSTJYGKGCKGYOQXJPLZPBPGTGYJZGHZQZZLBJLSQFZGKQQJZGYCZBZQTLDXRJXBSXXPZXHYZYCLWDXJJHXMFDZPFZHQHQMQGKSLYHTYCGFRZGNQXCLPDLBZCSCZQLLJBLHBZCYPZZPPDYMZZSGYHCKCPZJGSLJLNSCDSLDLXBMSTLDDFJMKDJDHZLZXLSZQPQPGJLLYBDSZGQLBZLSLKYYHZTTNTJYQTZZPSZQZTLLJTYYLLQLLQYZQLBDZLSLYYZYMDFSZSNHLXZNCZQZPBWSKRFBSYZMTHBLGJPMCZZLSTLXSHTCSYZLZBLFEQHLXFLCJLYLJQCBZLZJHHSSTBRMHXZHJZCLXFNBGXGTQJCZTMSFZKJMSSNXLJKBHSJXNTNLZDNTLMSJXGZJYJCZXYJYJWRWWQNZTNFJSZPZSHZJFYRDJSFSZJZBJFZQZZHZLXFYSBZQLZSGYFTZDCSZXZJBQMSZKJRHYJZCKMJKHCHGTXKXQGLXPXFXTRTYLXJXHDTSJXHJZJXZWZLCQSBTXWXGXTXXHXFTSDKFJHZYJFJXRZSDLLLTQSQQZQWZXSYQTWGWBZCGZLLYZBCLMQQTZHZXZXLJFRMYZFLXYSQXXJKXRMQDZDMMYYBSQBHGZMWFWXGMXLZPYYTGZYCCDXYZXYWGSYJYZNBHPZJSQSYXSXRTFYZGRHZTXSZZTHCBFCLSYXZLZQMZLMPLMXZJXSFLBYZMYQHXJSXRXSQZZZSSLYFRCZJRCRXHHZXQYDYHXSJJHZCXZBTYNSYSXJBQLPXZQPYMLXZKYXLXCJLCYSXXZZLXDLLLJJYHZXGYJWKJRWYHCPSGNRZLFZWFZZNSXGXFLZSXZZZBFCSYJDBRJKRDHHGXJLJJTGXJXXSTJTJXLYXQFCSGSWMSBCTLQZZWLZZKXJMLTMJYHSDDBXGZHDLBMYJFRZFSGCLYJBPMLYSMSXLSZJQQHJZFXGFQFQBPXZGYYQXGZTCQWYLTLGWSGWHRLFSFGZJMGMGBGTJFSYZZGZYZAFLSSPMLPFLCWBJZCLJJMZLPJJLYMQDMYYYFBGYGYZMLYZDXQYXRQQQHSYYYQXYLJTYXFSFSLLGNQCYHYCWFHCCCFXPYLYPLLZYXXXXXKQHHXSHJZCFZSCZJXCPZWHHHHHAPYLQALPQAFYHXDYLUKMZQGGGDDESRNNZLTZGCHYPPYSQJJHCLLJTOLNJPZLJLHYMHEYDYDSQYCDDHGZUNDZCLZYZLLZNTNYZGSLHSLPJJBDGWXPCDUTJCKLKCLWKLLCASSTKZZDNQNTTLYYZSSYSSZZRYLJQKCQDHHCRXRZYDGRGCWCGZQFFFPPJFZYNAKRGYWYQPQXXFKJTSZZXSWZDDFBBXTBGTZKZNPZZPZXZPJSZBMQHKCYXYLDKLJNYPKYGHGDZJXXEAHPNZKZTZCMXCXMMJXNKSZQNMNLWBWWXJKYHCPSTMCSQTZJYXTPCTPDTNNPGLLLZSJLSPBLPLQHDTNJNLYYRSZFFJFQWDPHZDWMRZCCLODAXNSSNYZRESTYJWJYJDBCFXNMWTTBYLWSTSZGYBLJPXGLBOCLHPCBJLTMXZLJYLZXCLTPNCLCKXTPZJSWCYXSFYSZDKNTLBYJCYJLLSTGQCBXRYZXBXKLYLHZLQZLNZCXWJZLJZJNCJHXMNZZGJZZXTZJXYCYYCXXJYYXJJXSSSJSTSSTTPPGQTCSXWZDCSYFPTFBFHFBBLZJCLZZDBXGCXLQPXKFZFLSYLTUWBMQJHSZBMDDBCYSCCLDXYCDDQLYJJWMQLLCSGLJJSYFPYYCCYLTJANTJJPWYCMMGQYYSXDXQMZHSZXPFTWWZQSWQRFKJLZJQQYFBRXJHHFWJJZYQAZMYFRHCYYBYQWLPEXCCZSTYRLTTDMQLYKMBBGMYYJPRKZNPBSXYXBHYZDJDNGHPMFSGMWFZMFQMMBCMZZCJJLCNUXYQLMLRYGQZCYXZLWJGCJCGGMCJNFYZZJHYCPRRCMTZQZXHFQGTJXCCJEAQCRJYHPLQLSZDJRBCQHQDYRHYLYXJSYMHZYDWLDFRYHBPYDTSSCNWBXGLPZMLZZTQSSCPJMXXYCSJYTYCGHYCJWYRXXLFEMWJNMKLLSWTXHYYYNCMMCWJDQDJZGLLJWJRKHPZGGFLCCSCZMCBLTBHBQJXQDSPDJZZGKGLFQYWBZYZJLTSTDHQHCTCBCHFLQMPWDSHYYTQWCNZZJTLBYMBPDYYYXSQKXWYYFLXXNCWCXYPMAELYKKJMZZZBRXYYQJFLJPFHHHYTZZXSGQQMHSPGDZQWBWPJHZJDYSCQWZKTXXSQLZYYMYSDZGRXCKKUJLWPYSYSCSYZLRMLQSYLJXBCXTLWDQZPCYCYKPPPNSXFYZJJRCEMHSZMSXLXGLRWGCSTLRSXBZGBZGZTCPLUJLSLYLYMTXMTZPALZXPXJTJWTCYYZLBLXBZLQMYLXPGHDSLSSDMXMBDZZSXWHAMLCZCPJMCNHJYSNSYGCHSKQMZZQDLLKABLWJXSFMOCDXJRRLYQZKJMYBYQLYHETFJZFRFKSRYXFJTWDSXXSYSQJYSLYXWJHSNLXYYXHBHAWHHJZXWMYLJCSSLKYDZTXBZSYFDXGXZJKHSXXYBSSXDPYNZWRPTQZCZENYGCXQFJYKJBZMLJCMQQXUOXSLYXXLYLLJDZBTYMHPFSTTQQWLHOKYBLZZALZXQLHZWRRQHLSTMYPYXJJXMQSJFNBXYXYJXXYQYLTHYLQYFMLKLJTMLLHSZWKZHLJMLHLJKLJSTLQXYLMBHHLNLZXQJHXCFXXLHYHJJGBYZZKBXSCQDJQDSUJZYYHZHHMGSXCSYMXFEBCQWWRBPYYJQTYZCYQYQQZYHMWFFHGZFRJFCDPXNTQYZPDYKHJLFRZXPPXZDBBGZQSTLGDGYLCQMLCHHMFYWLZYXKJLYPQHSYWMQQGQZMLZJNSQXJQSYJYCBEHSXFSZPXZWFLLBCYYJDYTDTHWZSFJMQQYJLMQXXLLDTTKHHYBFPWTYYSQQWNQWLGWDEBZWCMYGCULKJXTMXMYJSXHYBRWFYMWFRXYQMXYSZTZZTFYKMLDHQDXWYYNLCRYJBLPSXCXYWLSPRRJWXHQYPHTYDNXHHMMYWYTZCSQMTSSCCDALWZTCPQPYJLLQZYJSWXMZZMMYLMXCLMXCZMXMZSQTZPPQQBLPGXQZHFLJJHYTJSRXWZXSCCDLXTYJDCQJXSLQYCLZXLZZXMXQRJMHRHZJBHMFLJLMLCLQNLDXZLLLPYPSYJYSXCQQDCMQJZZXHNPNXZMEKMXHYKYQLXSXTXJYYHWDCWDZHQYYBGYBCYSCFGPSJNZDYZZJZXRZRQJJYMCANYRJTLDPPYZBSTJKXXZYPFDWFGZZRPYMTNGXZQBYXNBUFNQKRJQZMJEGRZGYCLKXZDSKKNSXKCLJSPJYYZLQQJYBZSSQLLLKJXTBKTYLCCDDBLSPPFYLGYDTZJYQGGKQTTFZXBDKTYYHYBBFYTYYBCLPDYTGDHRYRNJSPTCSNYJQHKLLLZSLYDXXWBCJQSPXBPJZJCJDZFFXXBRMLAZHCSNDLBJDSZBLPRZTSWSBXBCLLXXLZDJZSJPYLYXXYFTFFFBHJJXGBYXJPMMMPSSJZJMTLYZJXSWXTYLEDQPJMYGQZJGDJLQJWJQLLSJGJGYGMSCLJJXDTYGJQJQJCJZCJGDZZSXQGSJGGCXHQXSNQLZZBXHSGZXCXYLJXYXYYDFQQJHJFXDHCTXJYRXYSQTJXYEFYYSSYYJXNCYZXFXMSYSZXYYSCHSHXZZZGZZZGFJDLTYLNPZGYJYZYYQZPBXQBDZTZCZYXXYHHSQXSHDHGQHJHGYWSZTMZMLHYXGEBTYLZKQWYTJZRCLEKYSTDBCYKQQSAYXCJXWWGSBHJYZYDHCSJKQCXSWXFLTYNYZPZCCZJQTZWJQDZZZQZLJJXLSBHPYXXPSXSHHEZTXFPTLQYZZXHYTXNCFZYYHXGNXMYWXTZSJPTHHGYMXMXQZXTSBCZYJYXXTYYZYPCQLMMSZMJZZLLZXGXZAAJZYXJMZXWDXZSXZDZXLEYJJZQBHZWZZZQTZPSXZTDSXJJJZNYAZPHXYYSRNQDTHZHYYKYJHDZXZLSWCLYBZYECWCYCRYLCXNHZYDZYDYJDFRJJHTRSQTXYXJRJHOJYNXELXSFSFJZGHPZSXZSZDZCQZBYYKLSGSJHCZSHDGQGXYZGXCHXZJWYQWGYHKSSEQZZNDZFKWYSSTCLZSTSYMCDHJXXYWEYXCZAYDMPXMDSXYBSQMJMZJMTZQLPJYQZCGQHXJHHLXXHLHDLDJQCLDWBSXFZZYYSCHTYTYYBHECXHYKGJPXHHYZJFXHWHBDZFYZBCAPNPGNYDMSXHMMMMAMYNBYJTMPXYYMCTHJBZYFCGTYHWPHFTWZZEZSBZEGPFMTSKFTYCMHFLLHGPZJXZJGZJYXZSBBQSCZZLZCCSTPGXMJSFTCCZJZDJXCYBZLFCJSYZFGSZLYBCWZZBYZDZYPSWYJZXZBDSYUXLZZBZFYGCZXBZHZFTPBGZGEJBSTGKDMFHYZZJHZLLZZGJQZLSFDJSSCBZGPDLFZFZSZYZYZSYGCXSNXXCHCZXTZZLJFZGQSQYXZJQDCCZTQCDXZJYQJQCHXZTDLGSCXZSYQJQTZWLQDQZTQCHQQJZYEZZZPBWKDJFCJPZTYPQYQTTYNLMBDKTJZPQZQZZFPZSBNJLGYJDXJDZZKZGQKXDLPZJTCJDQBXDJQJSTCKNXBXZMSLYJCQMTJQWWCJQNJNLLLHJCWQTBZQYDZCZPZZDZYDDCYZZZCCJTTJFZDPRRTZTJDCQTQZDTJNPLZBCLLCTZSXKJZQZPZLBZRBTJDCXFCZDBCCJJLTQQPLDCGZDBBZJCQDCJWYNLLZYZCCDWLLXWZLXRXNTQQCZXKQLSGDFQTDDGLRLAJJTKUYMKQLLTZYTDYYCZGJWYXDXFRSKSTQTENQMRKQZHHQKDLDAZFKYPBGGPZREBZZYKZZSPEGJXGYKQZZZSLYSYYYZWFQZYLZZLZHWCHKYPQGNPGBLPLRRJYXCCSYYHSFZFYBZYYTGZXYLXCZWXXZJZBLFFLGSKHYJZEYJHLPLLLLCZGXDRZELRHGKLZZYHZLYQSZZJZQLJZFLNBHGWLCZCFJYSPYXZLZLXGCCPZBLLCYBBBBUBBCBPCRNNZCZYRBFSRLDCGQYYQXYGMQZWTZYTYJXYFWTEHZZJYWLCCNTZYJJZDEDPZDZTSYQJHDYMBJNYJZLXTSSTPHNDJXXBYXQTZQDDTJTDYYTGWSCSZQFLSHLGLBCZPHDLYZJYCKWTYTYLBNYTSDSYCCTYSZYYEBHEXHQDTWNYGYCLXTSZYSTQMYGZAZCCSZZDSLZCLZRQXYYELJSBYMXSXZTEMBBLLYYLLYTDQYSHYMRQWKFKBFXNXSBYCHXBWJYHTQBPBSBWDZYLKGZSKYHXQZJXHXJXGNLJKZLYYCDXLFYFGHLJGJYBXQLYBXQPQGZTZPLNCYPXDJYQYDYMRBESJYYHKXXSTMXRCZZYWXYQYBMCLLYZHQYZWQXDBXBZWZMSLPDMYSKFMZKLZCYQYCZLQXFZZYDQZPZYGYJYZMZXDZFYFYTTQTZHGSPCZMLCCYTZXJCYTJMKSLPZHYSNZLLYTPZCTZZCKTXDHXXTQCYFKSMQCCYYAZHTJPCYLZLYJBJXTPNYLJYYNRXSYLMMNXJSMYBCSYSYLZYLXJJQYLDZLPQBFZZBLFNDXQKCZFYWHGQMRDSXYCYTXNQQJZYYPFZXDYZFPRXEJDGYQBXRCNFYYQPGHYJDYZXGRHTKYLNWDZNTSMPKLBTHBPYSZBZTJZSZZJTYYXZPHSSZZBZCZPTQFZMYFLYPYBBJQXZMXXDJMTSYSKKBJZXHJCKLPSMKYJZCXTMLJYXRZZQSLXXQPYZXMKYXXXJCLJPRMYYGADYSKQLSNDHYZKQXZYZTCGHZTLMLWZYBWSYCTBHJHJFCWZTXWYTKZLXQSHLYJZJXTMPLPYCGLTBZZTLZJCYJGDTCLKLPLLQPJMZPAPXYZLKKTKDZCZZBNZDYDYQZJYJGMCTXLTGXSZLMLHBGLKFWNWZHDXUHLFMKYSLGXDTWWFRJEJZTZHYDXYKSHWFZCQSHKTMQQHTZHYMJDJSKHXZJZBZZXYMPAGQMSTPXLSKLZYNWRTSQLSZBPSPSGZWYHTLKSSSWHZZLYYTNXJGMJSZSUFWNLSOZTXGXLSAMMLBWLDSZYLAKQCQCTMYCFJBSLXCLZZCLXXKSBZQCLHJPSQPLSXXCKSLNHPSFQQYTXYJZLQLDXZQJZDYYDJNZPTUZDSKJFSLJHYLZSQZLBTXYDGTQFDBYAZXDZHZJNHHQBYKNXJJQCZMLLJZKSPLDYCLBBLXKLELXJLBQYCXJXGCNLCQPLZLZYJTZLJGYZDZPLTQCSXFDMNYCXGBTJDCZNBGBQYQJWGKFHTNPYQZQGBKPBBYZMTJDYTBLSQMPSXTBNPDXKLEMYYCJYNZCTLDYKZZXDDXHQSHDGMZSJYCCTAYRZLPYLTLKXSLZCGGEXCLFXLKJRTLQJAQZNCMBYDKKCXGLCZJZXJHPTDJJMZQYKQSECQZDSHHADMLZFMMZBGNTJNNLGBYJBRBTMLBYJDZXLCJLPLDLPCQDHLXZLYCBLCXZZJADJLNZMMSSSMYBHBSQKBHRSXXJMXSDZNZPXLGBRHWGGFCXGMSKLLTSJYYCQLTSKYWYYHYWXBXQYWPYWYKQLSQPTNTKHQCWDQKTWPXXHCPTHTWUMSSYHBWCRWXHJMKMZNGWTMLKFGHKJYLSYYCXWHYECLQHKQHTTQKHFZLDXQWYZYYDESBPKYRZPJFYYZJCEQDZZDLATZBBFJLLCXDLMJSSXEGYGSJQXCWBXSSZPDYZCXDNYXPPZYDLYJCZPLTXLSXYZYRXCYYYDYLWWNZSAHJSYQYHGYWWAXTJZDAXYSRLTDPSSYYFNEJDXYZHLXLLLZQZSJNYQYQQXYJGHZGZCYJCHZLYCDSHWSHJZYJXCLLNXZJJYYXNFXMWFPYLCYLLABWDDHWDXJMCXZTZPMLQZHSFHZYNZTLLDYWLSLXHYMMYLMBWWKYXYADTXYLLDJPYBPWUXJMWMLLSAFDLLYFLBHHHBQQLTZJCQJLDJTFFKMMMBYTHYGDCQRDDWRQJXNBYSNWZDBYYTBJHPYBYTTJXAAHGQDQTMYSTQXKBTZPKJLZRBEQQSSMJJBDJOTGTBXPGBKTLHQXJJJCTHXQDWJLWRFWQGWSHCKRYSWGFTGYGBXSDWDWRFHWYTJJXXXJYZYSLPYYYPAYXHYDQKXSHXYXGSKQHYWFDDDPPLCJLQQEEWXKSYYKDYPLTJTHKJLTCYYHHJTTPLTZZCDLTHQKZXQYSTEEYWYYZYXXYYSTTJKLLPZMCYHQGXYHSRMBXPLLNQYDQHXSXXWGDQBSHYLLPJJJTHYJKYPPTHYYKTYEZYENMDSHLCRPQFDGFXZPSFTLJXXJBSWYYSKSFLXLPPLBBBLBSFXFYZBSJSSYLPBBFFFFSSCJDSTZSXZRYYSYFFSYZYZBJTBCTSBSDHRTJJBYTCXYJEYLXCBNEBJDSYXYKGSJZBXBYTFZWGENYHHTHZHHXFWGCSTBGXKLSXYWMTMBYXJSTZSCDYQRCYTWXZFHMYMCXLZNSDJTTTXRYCFYJSBSDYERXJLJXBBDEYNJGHXGCKGSCYMBLXJMSZNSKGXFBNBPTHFJAAFXYXFPXMYPQDTZCXZZPXRSYWZDLYBBKTYQPQJPZYPZJZNJPZJLZZFYSBTTSLMPTZRTDXQSJEHBZYLZDHLJSQMLHTXTJECXSLZZSPKTLZKQQYFSYGYWPCPQFHQHYTQXZKRSGTTSQCZLPTXCDYYZXSQZSLXLZMYCPCQBZYXHBSXLZDLTCDXTYLZJYYZPZYZLTXJSJXHLPMYTXCQRBLZSSFJZZTNJYTXMYJHLHPPLCYXQJQQKZZSCPZKSWALQSBLCCZJSXGWWWYGYKTJBBZTDKHXHKGTGPBKQYSLPXPJCKBMLLXDZSTBKLGGQKQLSBKKTFXRMDKBFTPZFRTBBRFERQGXYJPZSSTLBZTPSZQZSJDHLJQLZBPMSMMSXLQQNHKNBLRDDNXXDHDDJCYYGYLXGZLXSYGMQQGKHBPMXYXLYTQWLWGCPBMQXCYZYDRJBHTDJYHQSHTMJSBYPLWHLZFFNYPMHXXHPLTBQPFBJWQDBYGPNZTPFZJGSDDTQSHZEAWZZYLLTYYBWJKXXGHLFKXDJTMSZSQYNZGGSWQSPHTLSSKMCLZXYSZQZXNCJDQGZDLFNYKLJCJLLZLMZZNHYDSSHTHZZLZZBBHQZWWYCRZHLYQQJBEYFXXXWHSRXWQHWPSLMSSKZTTYGYQQWRSLALHMJTQJSMXQBJJZJXZYZKXBYQXBJXSHZTSFJLXMXZXFGHKZSZGGYLCLSARJYHSLLLMZXELGLXYDJYTLFBHBPNLYZFBBHPTGJKWETZHKJJXZXXGLLJLSTGSHJJYQLQZFKCGNNDJSSZFDBCTWWSEQFHQJBSAQTGYPQLBXBMMYWXGSLZHGLZGQYFLZBYFZJFRYSFMBYZHQGFWZSYFYJJPHZBYYZFFWODGRLMFTWLBZGYCQXCDJYGZYYYYTYTYDWEGAZYHXJLZYYHLRMGRXXZCLHNELJJTJTPWJYBJJBXJJTJTEEKHWSLJPLPSFYZPQQBDLQJJTYYQLYZKDKSQJYYQZLDQTGJQYZJSUCMRYQTHTEJMFCTYHYPKMHYZWJDQFHYYXWSHCTXRLJHQXHCCYYYJLTKTTYTMXGTCJTZAYYOCZLYLBSZYWJYTSJYHBYSHFJLYGJXXTMZYYLTXXYPZLXYJZYZYYPNHMYMDYYLBLHLSYYQQLLNJJYMSOYQBZGDLYXYLCQYXTSZEGXHZGLHWBLJHEYXTWQMAKBPQCGYSHHEGQCMWYYWLJYJHYYZLLJJYLHZYHMGSLJLJXCJJYCLYCJPCPZJZJMMYLCQLNQLJQJSXYJMLSZLJQLYCMMHCFMMFPQQMFYLQMCFFQMMMMHMZNFHHJGTTHHKHSLNCHHYQDXTMMQDCYZYXYQMYQYLTDCYYYZAZZCYMZYDLZFFFMMYCQZWZZMABTBYZTDMNZZGGDFTYPCGQYTTSSFFWFDTZQSSYSTWXJHXYTSXXYLBYQHWWKXHZXWZNNZZJZJJQJCCCHYYXBZXZCYZTLLCQXYNJYCYYCYNZZQYYYEWYCZDCJYCCHYJLBTZYYCQWMPWPYMLGKDLDLGKQQBGYCHJXY";
        return a;
    },
    oMultiDiff: function oMultiDiff() {
        var _b;

        var b = (_b = { "19969": "DZ", "19975": "WM", "19988": "QJ", "20048": "YL", "20056": "SC", "20060": "NM", "20094": "QG", "20127": "QJ", "20167": "QC", "20193": "YG", "20250": "KH", "20256": "ZC", "20282": "SC", "20285": "QJG", "20291": "TD", "20314": "YD", "20340": "NE", "20375": "TD", "20389": "YJ", "20391": "CZ", "20415": "PB", "20446": "YS", "20447": "SQ", "20504": "TC", "20608": "KG", "20854": "QJ", "20857": "ZC", "20911": "PF" }, _defineProperty(_b, "20504", "TC"), _defineProperty(_b, "20608", "KG"), _defineProperty(_b, "20854", "QJ"), _defineProperty(_b, "20857", "ZC"), _defineProperty(_b, "20911", "PF"), _defineProperty(_b, "20985", "AW"), _defineProperty(_b, "21032", "PB"), _defineProperty(_b, "21048", "XQ"), _defineProperty(_b, "21049", "SC"), _defineProperty(_b, "21089", "YS"), _defineProperty(_b, "21119", "JC"), _defineProperty(_b, "21242", "SB"), _defineProperty(_b, "21273", "SC"), _defineProperty(_b, "21305", "YP"), _defineProperty(_b, "21306", "QO"), _defineProperty(_b, "21330", "ZC"), _defineProperty(_b, "21333", "SDC"), _defineProperty(_b, "21345", "QK"), _defineProperty(_b, "21378", "CA"), _defineProperty(_b, "21397", "SC"), _defineProperty(_b, "21414", "XS"), _defineProperty(_b, "21442", "SC"), _defineProperty(_b, "21477", "JG"), _defineProperty(_b, "21480", "TD"), _defineProperty(_b, "21484", "ZS"), _defineProperty(_b, "21494", "YX"), _defineProperty(_b, "21505", "YX"), _defineProperty(_b, "21512", "HG"), _defineProperty(_b, "21523", "XH"), _defineProperty(_b, "21537", "PB"), _defineProperty(_b, "21542", "PF"), _defineProperty(_b, "21549", "KH"), _defineProperty(_b, "21571", "E"), _defineProperty(_b, "21574", "DA"), _defineProperty(_b, "21588", "TD"), _defineProperty(_b, "21589", "O"), _defineProperty(_b, "21618", "ZC"), _defineProperty(_b, "21621", "KHA"), _defineProperty(_b, "21632", "ZJ"), _defineProperty(_b, "21654", "KG"), _defineProperty(_b, "21679", "LKG"), _defineProperty(_b, "21683", "KH"), _defineProperty(_b, "21710", "A"), _defineProperty(_b, "21719", "YH"), _defineProperty(_b, "21734", "WOE"), _defineProperty(_b, "21769", "A"), _defineProperty(_b, "21780", "WN"), _defineProperty(_b, "21804", "XH"), _defineProperty(_b, "21834", "A"), _defineProperty(_b, "21899", "ZD"), _defineProperty(_b, "21903", "RN"), _defineProperty(_b, "21908", "WO"), _defineProperty(_b, "21939", "ZC"), _defineProperty(_b, "21956", "SA"), _defineProperty(_b, "21964", "YA"), _defineProperty(_b, "21970", "TD"), _defineProperty(_b, "22003", "A"), _defineProperty(_b, "22031", "JG"), _defineProperty(_b, "22040", "XS"), _defineProperty(_b, "22060", "ZC"), _defineProperty(_b, "22066", "ZC"), _defineProperty(_b, "22079", "MH"), _defineProperty(_b, "22129", "XJ"), _defineProperty(_b, "22179", "XA"), _defineProperty(_b, "22237", "NJ"), _defineProperty(_b, "22244", "TD"), _defineProperty(_b, "22280", "JQ"), _defineProperty(_b, "22300", "YH"), _defineProperty(_b, "22313", "XW"), _defineProperty(_b, "22331", "YQ"), _defineProperty(_b, "22343", "YJ"), _defineProperty(_b, "22351", "PH"), _defineProperty(_b, "22395", "DC"), _defineProperty(_b, "22412", "TD"), _defineProperty(_b, "22484", "PB"), _defineProperty(_b, "22500", "PB"), _defineProperty(_b, "22534", "ZD"), _defineProperty(_b, "22549", "DH"), _defineProperty(_b, "22561", "PB"), _defineProperty(_b, "22612", "TD"), _defineProperty(_b, "22771", "KQ"), _defineProperty(_b, "22831", "HB"), _defineProperty(_b, "22841", "JG"), _defineProperty(_b, "22855", "QJ"), _defineProperty(_b, "22865", "XQ"), _defineProperty(_b, "23013", "ML"), _defineProperty(_b, "23081", "WM"), _defineProperty(_b, "23487", "SX"), _defineProperty(_b, "23558", "QJ"), _defineProperty(_b, "23561", "YW"), _defineProperty(_b, "23586", "YW"), _defineProperty(_b, "23614", "YW"), _defineProperty(_b, "23615", "SN"), _defineProperty(_b, "23631", "PB"), _defineProperty(_b, "23646", "ZS"), _defineProperty(_b, "23663", "ZT"), _defineProperty(_b, "23673", "YG"), _defineProperty(_b, "23762", "TD"), _defineProperty(_b, "23769", "ZS"), _defineProperty(_b, "23780", "QJ"), _defineProperty(_b, "23884", "QK"), _defineProperty(_b, "24055", "XH"), _defineProperty(_b, "24113", "DC"), _defineProperty(_b, "24162", "ZC"), _defineProperty(_b, "24191", "GA"), _defineProperty(_b, "24273", "QJ"), _defineProperty(_b, "24324", "NL"), _defineProperty(_b, "24377", "TD"), _defineProperty(_b, "24378", "QJ"), _defineProperty(_b, "24439", "PF"), _defineProperty(_b, "24554", "ZS"), _defineProperty(_b, "24683", "TD"), _defineProperty(_b, "24694", "WE"), _defineProperty(_b, "24733", "LK"), _defineProperty(_b, "24925", "TN"), _defineProperty(_b, "25094", "ZG"), _defineProperty(_b, "25100", "XQ"), _defineProperty(_b, "25103", "XH"), _defineProperty(_b, "25153", "PB"), _defineProperty(_b, "25170", "PB"), _defineProperty(_b, "25179", "KG"), _defineProperty(_b, "25203", "PB"), _defineProperty(_b, "25240", "ZS"), _defineProperty(_b, "25282", "FB"), _defineProperty(_b, "25303", "NA"), _defineProperty(_b, "25324", "KG"), _defineProperty(_b, "25341", "ZY"), _defineProperty(_b, "25373", "WZ"), _defineProperty(_b, "25375", "XJ"), _defineProperty(_b, "25384", "A"), _defineProperty(_b, "25457", "A"), _defineProperty(_b, "25528", "SD"), _defineProperty(_b, "25530", "SC"), _defineProperty(_b, "25552", "TD"), _defineProperty(_b, "25774", "ZC"), _defineProperty(_b, "25874", "ZC"), _defineProperty(_b, "26044", "YW"), _defineProperty(_b, "26080", "WM"), _defineProperty(_b, "26292", "PB"), _defineProperty(_b, "26333", "PB"), _defineProperty(_b, "26355", "ZY"), _defineProperty(_b, "26366", "CZ"), _defineProperty(_b, "26397", "ZC"), _defineProperty(_b, "26399", "QJ"), _defineProperty(_b, "26415", "ZS"), _defineProperty(_b, "26451", "SB"), _defineProperty(_b, "26526", "ZC"), _defineProperty(_b, "26552", "JG"), _defineProperty(_b, "26561", "TD"), _defineProperty(_b, "26588", "JG"), _defineProperty(_b, "26597", "CZ"), _defineProperty(_b, "26629", "ZS"), _defineProperty(_b, "26638", "YL"), _defineProperty(_b, "26646", "XQ"), _defineProperty(_b, "26653", "KG"), _defineProperty(_b, "26657", "XJ"), _defineProperty(_b, "26727", "HG"), _defineProperty(_b, "26894", "ZC"), _defineProperty(_b, "26937", "ZS"), _defineProperty(_b, "26946", "ZC"), _defineProperty(_b, "26999", "KJ"), _defineProperty(_b, "27099", "KJ"), _defineProperty(_b, "27449", "YQ"), _defineProperty(_b, "27481", "XS"), _defineProperty(_b, "27542", "ZS"), _defineProperty(_b, "27663", "ZS"), _defineProperty(_b, "27748", "TS"), _defineProperty(_b, "27784", "SC"), _defineProperty(_b, "27788", "ZD"), _defineProperty(_b, "27795", "TD"), _defineProperty(_b, "27812", "O"), _defineProperty(_b, "27850", "PB"), _defineProperty(_b, "27852", "MB"), _defineProperty(_b, "27895", "SL"), _defineProperty(_b, "27898", "PL"), _defineProperty(_b, "27973", "QJ"), _defineProperty(_b, "27981", "KH"), _defineProperty(_b, "27986", "HX"), _defineProperty(_b, "27994", "XJ"), _defineProperty(_b, "28044", "YC"), _defineProperty(_b, "28065", "WG"), _defineProperty(_b, "28177", "SM"), _defineProperty(_b, "28267", "QJ"), _defineProperty(_b, "28291", "KH"), _defineProperty(_b, "28337", "ZQ"), _defineProperty(_b, "28463", "TL"), _defineProperty(_b, "28548", "DC"), _defineProperty(_b, "28601", "TD"), _defineProperty(_b, "28689", "PB"), _defineProperty(_b, "28805", "JG"), _defineProperty(_b, "28820", "QG"), _defineProperty(_b, "28846", "PB"), _defineProperty(_b, "28952", "TD"), _defineProperty(_b, "28975", "ZC"), _defineProperty(_b, "29100", "A"), _defineProperty(_b, "29325", "QJ"), _defineProperty(_b, "29575", "SL"), _defineProperty(_b, "29602", "FB"), _defineProperty(_b, "30010", "TD"), _defineProperty(_b, "30044", "CX"), _defineProperty(_b, "30058", "PF"), _defineProperty(_b, "30091", "YSP"), _defineProperty(_b, "30111", "YN"), _defineProperty(_b, "30229", "XJ"), _defineProperty(_b, "30427", "SC"), _defineProperty(_b, "30465", "SX"), _defineProperty(_b, "30631", "YQ"), _defineProperty(_b, "30655", "QJ"), _defineProperty(_b, "30684", "QJG"), _defineProperty(_b, "30707", "SD"), _defineProperty(_b, "30729", "XH"), _defineProperty(_b, "30796", "LG"), _defineProperty(_b, "30917", "PB"), _defineProperty(_b, "31074", "NM"), _defineProperty(_b, "31085", "JZ"), _defineProperty(_b, "31109", "SC"), _defineProperty(_b, "31181", "ZC"), _defineProperty(_b, "31192", "MLB"), _defineProperty(_b, "31293", "JQ"), _defineProperty(_b, "31400", "YX"), _defineProperty(_b, "31584", "YJ"), _defineProperty(_b, "31896", "ZN"), _defineProperty(_b, "31909", "ZY"), _defineProperty(_b, "31995", "XJ"), _defineProperty(_b, "32321", "PF"), _defineProperty(_b, "32327", "ZY"), _defineProperty(_b, "32418", "HG"), _defineProperty(_b, "32420", "XQ"), _defineProperty(_b, "32421", "HG"), _defineProperty(_b, "32438", "LG"), _defineProperty(_b, "32473", "GJ"), _defineProperty(_b, "32488", "TD"), _defineProperty(_b, "32521", "QJ"), _defineProperty(_b, "32527", "PB"), _defineProperty(_b, "32562", "ZSQ"), _defineProperty(_b, "32564", "JZ"), _defineProperty(_b, "32735", "ZD"), _defineProperty(_b, "32793", "PB"), _defineProperty(_b, "33071", "PF"), _defineProperty(_b, "33098", "XL"), _defineProperty(_b, "33100", "YA"), _defineProperty(_b, "33152", "PB"), _defineProperty(_b, "33261", "CX"), _defineProperty(_b, "33324", "BP"), _defineProperty(_b, "33333", "TD"), _defineProperty(_b, "33406", "YA"), _defineProperty(_b, "33426", "WM"), _defineProperty(_b, "33432", "PB"), _defineProperty(_b, "33445", "JG"), _defineProperty(_b, "33486", "ZN"), _defineProperty(_b, "33493", "TS"), _defineProperty(_b, "33507", "QJ"), _defineProperty(_b, "33540", "QJ"), _defineProperty(_b, "33544", "ZC"), _defineProperty(_b, "33564", "XQ"), _defineProperty(_b, "33617", "YT"), _defineProperty(_b, "33632", "QJ"), _defineProperty(_b, "33636", "XH"), _defineProperty(_b, "33637", "YX"), _defineProperty(_b, "33694", "WG"), _defineProperty(_b, "33705", "PF"), _defineProperty(_b, "33728", "YW"), _defineProperty(_b, "33882", "SR"), _defineProperty(_b, "34067", "WM"), _defineProperty(_b, "34074", "YW"), _defineProperty(_b, "34121", "QJ"), _defineProperty(_b, "34255", "ZC"), _defineProperty(_b, "34259", "XL"), _defineProperty(_b, "34425", "JH"), _defineProperty(_b, "34430", "XH"), _defineProperty(_b, "34485", "KH"), _defineProperty(_b, "34503", "YS"), _defineProperty(_b, "34532", "HG"), _defineProperty(_b, "34552", "XS"), _defineProperty(_b, "34558", "YE"), _defineProperty(_b, "34593", "ZL"), _defineProperty(_b, "34660", "YQ"), _defineProperty(_b, "34892", "XH"), _defineProperty(_b, "34928", "SC"), _defineProperty(_b, "34999", "QJ"), _defineProperty(_b, "35048", "PB"), _defineProperty(_b, "35059", "SC"), _defineProperty(_b, "35098", "ZC"), _defineProperty(_b, "35203", "TQ"), _defineProperty(_b, "35265", "JX"), _defineProperty(_b, "35299", "JX"), _defineProperty(_b, "35782", "SZ"), _defineProperty(_b, "35828", "YS"), _defineProperty(_b, "35830", "E"), _defineProperty(_b, "35843", "TD"), _defineProperty(_b, "35895", "YG"), _defineProperty(_b, "35977", "MH"), _defineProperty(_b, "36158", "JG"), _defineProperty(_b, "36228", "QJ"), _defineProperty(_b, "36426", "XQ"), _defineProperty(_b, "36466", "DC"), _defineProperty(_b, "36710", "JC"), _defineProperty(_b, "36711", "ZYG"), _defineProperty(_b, "36767", "PB"), _defineProperty(_b, "36866", "SK"), _defineProperty(_b, "36951", "YW"), _defineProperty(_b, "37034", "YX"), _defineProperty(_b, "37063", "XH"), _defineProperty(_b, "37218", "ZC"), _defineProperty(_b, "37325", "ZC"), _defineProperty(_b, "38063", "PB"), _defineProperty(_b, "38079", "TD"), _defineProperty(_b, "38085", "QY"), _defineProperty(_b, "38107", "DC"), _defineProperty(_b, "38116", "TD"), _defineProperty(_b, "38123", "YD"), _defineProperty(_b, "38224", "HG"), _defineProperty(_b, "38241", "XTC"), _defineProperty(_b, "38271", "ZC"), _defineProperty(_b, "38415", "YE"), _defineProperty(_b, "38426", "KH"), _defineProperty(_b, "38461", "YD"), _defineProperty(_b, "38463", "AE"), _defineProperty(_b, "38466", "PB"), _defineProperty(_b, "38477", "XJ"), _defineProperty(_b, "38518", "YT"), _defineProperty(_b, "38551", "WK"), _defineProperty(_b, "38585", "ZC"), _defineProperty(_b, "38704", "XS"), _defineProperty(_b, "38739", "LJ"), _defineProperty(_b, "38761", "GJ"), _defineProperty(_b, "38808", "SQ"), _defineProperty(_b, "39048", "JG"), _defineProperty(_b, "39049", "XJ"), _defineProperty(_b, "39052", "HG"), _defineProperty(_b, "39076", "CZ"), _defineProperty(_b, "39271", "XT"), _defineProperty(_b, "39534", "TD"), _defineProperty(_b, "39552", "TD"), _defineProperty(_b, "39584", "PB"), _defineProperty(_b, "39647", "SB"), _defineProperty(_b, "39730", "LG"), _defineProperty(_b, "39748", "TPB"), _defineProperty(_b, "40109", "ZQ"), _defineProperty(_b, "40479", "ND"), _defineProperty(_b, "40516", "HG"), _defineProperty(_b, "40536", "HG"), _defineProperty(_b, "40583", "QJ"), _defineProperty(_b, "40765", "YQ"), _defineProperty(_b, "40784", "QJ"), _defineProperty(_b, "40840", "YK"), _defineProperty(_b, "40863", "QJG"), _b);
        return b;
    }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"choosepeople"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.choosedStatus),expression:"choosedStatus"}],staticStyle:{"width":"100%","height":"100%","overflow":"auto"}},[_c('van-nav-bar',{attrs:{"title":"请选择","fixed":"","left-arrow":"","z-index":"3"},on:{"click-left":_vm.goBack}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.status),expression:"status"}],staticClass:"big_box"},[_c('div',{staticClass:"myList"},[_c('ul',{staticClass:"myUl"},[_c('li',{staticClass:"myLi",on:{"click":_vm.getMyFriend}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v("我的好友")])]),_vm._v(" "),(!_vm.ban_org)?_c('li',{staticClass:"myLi",on:{"click":_vm.getMyGroup}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v("我的群组")])]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"myLi",on:{"click":function($event){_vm.getMyOrg()}}},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v("我的组织")])]),_vm._v(" "),_c('li',{staticClass:"myLi",on:{"click":function($event){_vm.getdq()}}},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v("地区")])]),_vm._v(" "),_c('li',{staticClass:"myLi",on:{"click":function($event){_vm.gethy()}}},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v("行业")])])])]),_vm._v(" "),_c('div',{staticClass:"recent"},[_vm._v("常用")]),_vm._v(" "),_c('div',{staticClass:"recentList"},[_c('el-checkbox-group',{model:{value:(_vm.result),callback:function ($$v) {_vm.result=$$v},expression:"result"}},_vm._l((_vm.slist),function(item,index){return (item.type == 1 || (item.type == 2 && _vm.showRecentGroup && !_vm.ban_org))?_c('el-checkbox',{key:index,attrs:{"label":item.unit.unitId},on:{"change":function($event){_vm.recentChange($event, item)}}},[(item.type == 1&&item.users.avatar)?_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":item.users.avatar,"alt":""}})]):_vm._e(),_vm._v(" "),(item.type == 2)?_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":item.roominfo.logopath,"alt":""}})]):_vm._e(),_vm._v(" "),(!item.users.avatar&&item.type == 1)?_c('div',{staticClass:"no_avatar"},[_vm._v(_vm._s(item.users.sumname.substr(-2, 2)))]):_vm._e(),_vm._v(" "),(item.type == 1)?_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.users.sumname))]):_vm._e(),_vm._v(" "),(item.type == 2)?_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.roominfo.roomname))]):_vm._e()]):_vm._e()}))],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.status),expression:"!status"}],staticClass:"bread"},[_c('ul',{staticClass:"bread_ul"},[_c('li',{on:{"click":_vm.changeStatus}},[_vm._v("联系人")]),_vm._v(" "),_vm._l((_vm.breadArr),function(item,index){return (!_vm.org_status)?_c('li',{key:index,on:{"click":function($event){_vm.goSon($event, item)}}},[_vm._v(_vm._s('>' + item.name))]):_vm._e()}),_vm._v(" "),_vm._l((_vm.breadArr),function(item,index){return (!_vm.hy_status)?_c('li',{key:index,on:{"click":function($event){_vm.gohySon($event, item)}}},[_vm._v(_vm._s('>' + item.name))]):_vm._e()}),_vm._v(" "),_vm._l((_vm.breadArr),function(item,index){return (!_vm.dq_status)?_c('li',{key:index,on:{"click":function($event){_vm.godqSon($event, item)}}},[_vm._v(_vm._s('>' + item.name))]):_vm._e()})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.friend_status),expression:"!friend_status"}],staticClass:"people_list"},[_c('div',{staticClass:"member_list"},[_c('ul',{staticClass:"list_ul"},_vm._l((_vm.letters),function(itemSort,index){return _c('li',{key:index,staticClass:"section"},[_c('p',{staticClass:"letter",attrs:{"id":itemSort}},[_vm._v(_vm._s(itemSort))]),_vm._v(" "),_c('el-checkbox-group',{attrs:{"max":_vm.limit==-1?99999999:_vm.limit},model:{value:(_vm.peopleList),callback:function ($$v) {_vm.peopleList=$$v},expression:"peopleList"}},_vm._l((_vm.friend_list),function(item,index){return (item.capitalize == itemSort)?_c('el-checkbox',{key:index,attrs:{"label":parseInt(item.umid)},on:{"change":function($event){_vm.chooseCheck($event, item)}}},[_c('div',{staticClass:"avatar"},[(item.avatar)?_c('img',{attrs:{"src":item.avatar,"alt":""}}):_vm._e(),_vm._v(" "),(!item.avatar)?_c('div',{staticClass:"noAvatar"},[_vm._v(_vm._s(item.name.substr(-2, 2)))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"name_phone"},[_c('p',{staticClass:"name"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',{staticClass:"phone"},[_vm._v(_vm._s(item.sphone))])]),_vm._v(" "),_c('div',{staticClass:"company"},[_c('p',[_vm._v(_vm._s(item.job))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.company))])])]):_vm._e()}))],1)}))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.group_status),expression:"!group_status"}],staticClass:"group_list"},[_c('div',{staticClass:"groupUl"},[_c('el-checkbox-group',{model:{value:(_vm.groupList),callback:function ($$v) {_vm.groupList=$$v},expression:"groupList"}},_vm._l((_vm.group_list),function(item,index){return _c('el-checkbox',{key:index,attrs:{"label":item.id},on:{"change":function($event){_vm.chooseCheck($event, item)}}},[_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":item.avatar,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(item.name))])])])}))],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.org_status),expression:"!org_status"}],staticClass:"org_list"},[_c('div',{staticClass:"orglist"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.orgRoot),expression:"orgRoot"}],staticClass:"org_ul"},[_c('el-checkbox-group',{attrs:{"disabled":_vm.ban_org},model:{value:(_vm.orgList),callback:function ($$v) {_vm.orgList=$$v},expression:"orgList"}},_vm._l((_vm.org_list),function(item,index){return _c('li',{key:index},[_c('el-checkbox',{attrs:{"label":parseInt(item.id)},on:{"change":function($event){_vm.chooseCheck($event, item)}}},[(!item.avatar)?_c('div',{staticClass:"noAvatar"}):_vm._e(),_vm._v(" "),(item.avatar)?_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":item.avatar,"alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"name"},[_c('span',[_vm._v(_vm._s(item.name))])])]),_vm._v(" "),_c('div',{staticClass:"next",on:{"click":function($event){$event.stopPropagation();_vm.getBranch(item)}}},[_c('img',{attrs:{"src":"/img/nextBranch.png","alt":""}}),_vm._v("\n                下级\n              ")])],1)}))],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.orgRoot && _vm.branchStatus),expression:"!orgRoot && branchStatus"}],staticClass:"org_ul"},[_c('el-checkbox-group',{attrs:{"disabled":_vm.ban_org},model:{value:(_vm.branchList),callback:function ($$v) {_vm.branchList=$$v},expression:"branchList"}},_vm._l((_vm.orgmember),function(item,index){return _c('li',{key:index},[(item.type == '2')?_c('el-checkbox',{attrs:{"label":parseInt(item.id)},on:{"change":function($event){_vm.chooseCheck($event, item)}}},[_c('div',{staticClass:"rightBox orgBox"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.name))])])]):_vm._e(),_vm._v(" "),(item.type == '2')?_c('div',{staticClass:"next",on:{"click":function($event){$event.stopPropagation();_vm.getBranch(item)}}},[_c('img',{attrs:{"src":"/img/nextBranch.png","alt":""}}),_vm._v(" "),_c('span',[_vm._v("下级")])]):_vm._e()],1)}))],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.orgRoot && _vm.peopleStatus),expression:"!orgRoot && peopleStatus"}],staticClass:"org_ul manList"},[_c('el-checkbox-group',{model:{value:(_vm.peopleList),callback:function ($$v) {_vm.peopleList=$$v},expression:"peopleList"}},_vm._l((_vm.orgmember),function(item,index){return (item.type != '2')?_c('el-checkbox',{key:index,attrs:{"label":parseInt(item.umid)},on:{"change":function($event){_vm.chooseCheck($event, item)}}},[_c('div',{staticClass:"rightBox orgBox"},[(item.avatar)?_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":item.avatar,"alt":""}})]):_vm._e(),_vm._v(" "),(!item.avatar)?_c('div',{staticClass:"noAvatar"},[_vm._v(_vm._s(item.name.substr(-2, 2)))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.name))])])]):_vm._e()}))],1)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hy_status),expression:"!hy_status"}],staticClass:"org_list"},[_c('div',{staticClass:"orglist"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hyRoot),expression:"hyRoot"}],staticClass:"org_ul"},[_c('el-checkbox-group',{model:{value:(_vm.hyList),callback:function ($$v) {_vm.hyList=$$v},expression:"hyList"}},_vm._l((_vm.hy_list),function(item,index){return _c('li',{key:index},[_c('el-checkbox',{attrs:{"label":item.id},on:{"change":function($event){_vm.chooseCheck($event, item)}}},[_c('div',{staticClass:"name"},[_c('span',[_vm._v(_vm._s(item.name))])])]),_vm._v(" "),_c('div',{staticClass:"next",on:{"click":function($event){$event.stopPropagation();_vm.getBranchhy(item)}}},[_c('img',{attrs:{"src":"/img/nextBranch.png","alt":""}}),_vm._v("\n                下级\n              ")])],1)}))],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hyRoot),expression:"!hyRoot"}],staticClass:"org_ul"},[_c('el-checkbox-group',{attrs:{"disabled":_vm.ban_org},model:{value:(_vm.hyList),callback:function ($$v) {_vm.hyList=$$v},expression:"hyList"}},_vm._l((_vm.hymember),function(item,index){return _c('li',{key:index},[_c('el-checkbox',{attrs:{"label":item.id},on:{"change":function($event){_vm.chooseCheck($event, item)}}},[_c('div',{staticClass:"rightBox orgBox"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.name))])])]),_vm._v(" "),_c('div',{staticClass:"next",on:{"click":function($event){$event.stopPropagation();_vm.getBranchhy(item)}}},[_c('img',{attrs:{"src":"/img/nextBranch.png","alt":""}}),_vm._v(" "),_c('span',[_vm._v("下级")])])],1)}))],1)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.dq_status),expression:"!dq_status"}],staticClass:"org_list"},[_c('div',{staticClass:"orglist"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dqRoot),expression:"dqRoot"}],staticClass:"org_ul"},[_c('el-checkbox-group',{model:{value:(_vm.dqList),callback:function ($$v) {_vm.dqList=$$v},expression:"dqList"}},_vm._l((_vm.dq_list),function(item,index){return _c('li',{key:index},[_c('el-checkbox',{attrs:{"label":item.id},on:{"change":function($event){_vm.chooseCheck($event, item)}}},[_c('div',{staticClass:"name"},[_c('span',[_vm._v(_vm._s(item.name))])])]),_vm._v(" "),_c('div',{staticClass:"next",on:{"click":function($event){$event.stopPropagation();_vm.getBranchdq(item)}}},[_c('img',{attrs:{"src":"/img/nextBranch.png","alt":""}}),_vm._v("\n                下级\n              ")])],1)}))],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.dqRoot),expression:"!dqRoot"}],staticClass:"org_ul"},[_c('el-checkbox-group',{attrs:{"disabled":_vm.ban_org},model:{value:(_vm.dqList),callback:function ($$v) {_vm.dqList=$$v},expression:"dqList"}},_vm._l((_vm.dqmember),function(item,index){return _c('li',{key:index},[_c('el-checkbox',{attrs:{"label":item.id},on:{"change":function($event){_vm.chooseCheck($event, item)}}},[_c('div',{staticClass:"rightBox orgBox"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.name))])])]),_vm._v(" "),_c('div',{staticClass:"next",on:{"click":function($event){$event.stopPropagation();_vm.getBranchdq(item)}}},[_c('img',{attrs:{"src":"/img/nextBranch.png","alt":""}}),_vm._v(" "),_c('span',[_vm._v("下级")])])],1)}))],1)])]),_vm._v(" "),_c('div',{staticClass:"sure"},[_c('div',{staticClass:"left",on:{"click":_vm.toChoosedPeople}},[_vm._v("已选择:"+_vm._s(_vm.peopleTotal)+"人")]),_vm._v(" "),_c('div',{staticClass:"left",on:{"click":_vm.toChoosedPeople}},[_vm._v(","+_vm._s(_vm.dqTotal)+"地区")]),_vm._v(" "),_c('div',{staticClass:"left",on:{"click":_vm.toChoosedPeople}},[_vm._v(","+_vm._s(_vm.hyTotal)+"行业")]),_vm._v(" "),(_vm.groupTotal > 0)?_c('div',{staticClass:"choosedPeople",on:{"click":_vm.toChoosedPeople}},[_vm._v(","+_vm._s(_vm.groupTotal)+"个群")]):_vm._e(),_vm._v(" "),(_vm.orgTotal > 0)?_c('div',{staticClass:"choosedPeople",on:{"click":_vm.toChoosedPeople}},[_vm._v(","+_vm._s(_vm.orgTotal)+"个组织")]):_vm._e(),_vm._v(" "),(_vm.branchTotal > 0)?_c('div',{staticClass:"choosedPeople",on:{"click":_vm.toChoosedPeople}},[_vm._v(","+_vm._s(_vm.branchTotal)+"个部门")]):_vm._e(),_vm._v(" "),(!_vm.trueBtnStatus)?_c('el-button',{staticClass:"right",attrs:{"type":"primary","size":"small"},on:{"click":_vm.submit}},[_vm._v("确定("+_vm._s(_vm.allTotal)+"/999)")]):_vm._e(),_vm._v(" "),(_vm.trueBtnStatus)?_c('el-button',{staticClass:"right",attrs:{"type":"primary","size":"small","disabled":_vm.peopleTotal < 2},on:{"click":_vm.submit}},[_vm._v("确定("+_vm._s(_vm.allTotal)+"/999)")]):_vm._e()],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.choosedStatus),expression:"!choosedStatus"}],staticClass:"special"},[_c('van-nav-bar',{attrs:{"title":"已选择","fixed":"","left-arrow":"","z-index":"2"},on:{"click-left":_vm.goBack1}}),_vm._v(" "),_c('div',{staticClass:"big_box"},[_c('ul',{staticClass:"listUl"},[(_vm.choosedPeople.length > 0)?_c('div',{staticClass:"classify"},[_vm._v("\n          好友\n          "),_c('span',{staticStyle:{"float":"right","color":"#fb6155"},on:{"click":function($event){_vm.removeAll(1)}}},[_vm._v("移除所有好友")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.choosedPeople),function(item,index){return _c('li',{key:index,staticClass:"listLi"},[(item.avatar&&!item.users)?_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":item.avatar,"alt":""}})]):_vm._e(),_vm._v(" "),(item.users&&item.users.avatar)?_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":item.users.avatar,"alt":""}})]):_vm._e(),_vm._v(" "),(!item.avatar&&item.name)?_c('div',{staticClass:"no_avatar"},[_vm._v(_vm._s(item.name.substr(-2, 2)))]):_vm._e(),_vm._v(" "),(item.users&&!item.users.avatar)?_c('div',{staticClass:"no_avatar"},[_vm._v(_vm._s(item.users.sumname.substr(-2, 2)))]):_vm._e(),_vm._v(" "),(item.name)?_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.name))]):_vm._e(),_vm._v(" "),(item.users)?_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.users.sumname))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"remove",on:{"click":function($event){_vm.removeThis(item, index)}}},[_vm._v("移除")])])}),_vm._v(" "),(_vm.choosedRoomuser.length > 0)?_c('div',{staticClass:"classify"},[_vm._v("\n          管理员\n          "),_c('span',{staticStyle:{"float":"right","color":"#fb6155"},on:{"click":function($event){_vm.removeAll(1)}}},[_vm._v("移除所有管理员")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.choosedRoomuser),function(item,index){return _c('li',{key:index,staticClass:"listLi"},[(item.avatar&&!item.users)?_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":item.avatar,"alt":""}})]):_vm._e(),_vm._v(" "),(item.users&&item.users.avatar)?_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":item.users.avatar,"alt":""}})]):_vm._e(),_vm._v(" "),(!item.avatar&&item.name)?_c('div',{staticClass:"no_avatar"},[_vm._v(_vm._s(item.name.substr(-2, 2)))]):_vm._e(),_vm._v(" "),(item.users&&!item.users.avatar)?_c('div',{staticClass:"no_avatar"},[_vm._v(_vm._s(item.users.sumname.substr(-2, 2)))]):_vm._e(),_vm._v(" "),(item.name)?_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.name))]):_vm._e(),_vm._v(" "),(item.users)?_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.users.sumname))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"remove",on:{"click":function($event){_vm.removeThis(item, index,3)}}},[_vm._v("移除")])])}),_vm._v(" "),(_vm.choosedGroup.length > 0)?_c('div',{staticClass:"classify"},[_vm._v("\n          群\n          "),_c('span',{staticStyle:{"float":"right","color":"#fb6155"},on:{"click":function($event){_vm.removeAll(2)}}},[_vm._v("移除所有群")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.choosedGroup),function(item,index){return _c('li',{key:index,staticClass:"listLi"},[(item.roominfo)?_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":item.roominfo.logopath,"alt":""}})]):_vm._e(),_vm._v(" "),(!item.roominfo)?_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":item.avatar,"alt":""}})]):_vm._e(),_vm._v(" "),(item.roominfo)?_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.roominfo.roomname))]):_vm._e(),_vm._v(" "),(!item.roominfo)?_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.name))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"remove",on:{"click":function($event){_vm.removeThis(item, index)}}},[_vm._v("移除")])])}),_vm._v(" "),(_vm.choosedOrg.length > 0)?_c('div',{staticClass:"classify"},[_vm._v("\n          组织\n          "),_c('span',{staticStyle:{"float":"right","color":"#fb6155"},on:{"click":function($event){_vm.removeAll(3)}}},[_vm._v("移除所有组织")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.choosedOrg),function(item,index){return _c('li',{key:index,staticClass:"listLi"},[(item.avatar&&!item.users)?_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":item.avatar,"alt":""}})]):_vm._e(),_vm._v(" "),(item.name)?_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.name))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"remove",on:{"click":function($event){_vm.removeThis(item, index)}}},[_vm._v("移除")])])}),_vm._v(" "),(_vm.choosedBranch.length > 0)?_c('div',{staticClass:"classify"},[_vm._v("\n          部门\n          "),_c('span',{staticStyle:{"float":"right","color":"#fb6155"},on:{"click":function($event){_vm.removeAll(4)}}},[_vm._v("移除所有部门")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.choosedBranch),function(item,index){return _c('li',{key:index,staticClass:"listLi"},[(item.name)?_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.name))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"remove",on:{"click":function($event){_vm.removeThis(item, index)}}},[_vm._v("移除")])])}),_vm._v(" "),(_vm.choosedhy.length > 0)?_c('div',{staticClass:"classify"},[_vm._v("\n          行业\n          "),_c('span',{staticStyle:{"float":"right","color":"#fb6155"},on:{"click":function($event){_vm.removeAll(5)}}},[_vm._v("移除所有行业")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.choosedhy),function(item,index){return _c('li',{key:index,staticClass:"listLi"},[(item.name)?_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.name))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"remove",on:{"click":function($event){_vm.removeThis(item, index,0)}}},[_vm._v("移除")])])}),_vm._v(" "),(_vm.chooseddq.length > 0)?_c('div',{staticClass:"classify"},[_vm._v("\n          地区\n          "),_c('span',{staticStyle:{"float":"right","color":"#fb6155"},on:{"click":function($event){_vm.removeAll(6)}}},[_vm._v("移除所有地区")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.chooseddq),function(item,index){return _c('li',{key:index,staticClass:"listLi"},[(item.name)?_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.name))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"remove",on:{"click":function($event){_vm.removeThis(item, index,1)}}},[_vm._v("移除")])])})],2)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchBox"},[_c('div',{staticClass:"search"},[_c('i'),_vm._v(" "),_c('span',[_vm._v("搜索")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"/img/myfriend.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"/img/room.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"/img/org.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"/img/org.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"/img/org.png","alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__um_zan__ = __webpack_require__(94);

__WEBPACK_IMPORTED_MODULE_0__um_zan__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__um_zan__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__um_zan__["a" /* default */]);
}; //注册组件
// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) { 
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__um_zan__["a" /* default */]);

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_zan_vue__ = __webpack_require__(14);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36180886_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_zan_vue__ = __webpack_require__(97);
function injectStyle (ssrContext) {
  __webpack_require__(95)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36180886"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_zan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36180886_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_zan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(96);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("7bffb8da", content, true, {});

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".zanbtndiv[data-v-36180886]{cursor:pointer;margin-left:16px}.zanbtndiv img[data-v-36180886]{width:16px;height:16px}.zanbtndiv .btntext[data-v-36180886]{margin-left:4px;font-size:12px;color:#999}", ""]);

// exports


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vCenter zanbtndiv",on:{"click":function($event){_vm.praise()}}},[_c('img',{attrs:{"src":_vm.minezan=='0'?'/img/icon/zan.png':'/img/icon/zaned.png',"alt":""}}),_vm._v(" "),(_vm.praisecount==0)?_c('div',{staticClass:"btntext"},[_vm._v("\n    赞\n  ")]):_c('div',{staticClass:"btntext"},[_vm._v("\n    "+_vm._s(_vm.praisecount)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__um_readcount__ = __webpack_require__(99);

__WEBPACK_IMPORTED_MODULE_0__um_readcount__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__um_readcount__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__um_readcount__["a" /* default */]);
}; //注册组件
// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) { 
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__um_readcount__["a" /* default */]);

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_readcount_vue__ = __webpack_require__(15);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4fa4afa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_readcount_vue__ = __webpack_require__(102);
function injectStyle (ssrContext) {
  __webpack_require__(100)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b4fa4afa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_readcount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4fa4afa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_readcount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(101);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("6b60ab20", content, true, {});

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".read[data-v-b4fa4afa]{font-size:12px;color:#999}.read>div[data-v-b4fa4afa]{margin-left:4px}", ""]);

// exports


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vCenter read"},[_c('img',{attrs:{"src":"/img/icon/read.png","alt":""}}),_vm._v(" "),_c('div',[_vm._v("\n    "+_vm._s(_vm.readcount)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__um_mcomment__ = __webpack_require__(104);

__WEBPACK_IMPORTED_MODULE_0__um_mcomment__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__um_mcomment__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__um_mcomment__["a" /* default */]);
}; //注册组件
// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) { 
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__um_mcomment__["a" /* default */]);

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_mcomment_vue__ = __webpack_require__(16);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_474da984_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_mcomment_vue__ = __webpack_require__(107);
function injectStyle (ssrContext) {
  __webpack_require__(105)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-474da984"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_mcomment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_474da984_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_mcomment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(106);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("0b052feb", content, true, {});

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".usercomments .commenttitle[data-v-474da984]{justify-content:space-between;font-size:16px;color:#444}.usercomments .commenttitle .totalNumber[data-v-474da984]{font-size:14px;color:#0e8de6}.usercomments .minecomments[data-v-474da984]{margin:20px 0;box-sizing:border-box;display:flex}.usercomments .minecomments .cuseravatar[data-v-474da984]{float:left;display:block;width:50px}.usercomments .othercomments[data-v-474da984]{margin-top:20px}.usercomments .othercomments ul[data-v-474da984]{border-top:1px solid #dcdcdc;padding:10px 0}.usercomments .othercomments ul li[data-v-474da984]{border-bottom:1px dashed #dcdcdc;padding:10px 0}.usercomments .othercomments .left img[data-v-474da984]{width:40px;height:40px;border-radius:50%;margin-right:10px;object-fit:cover}.usercomments .othercomments .right[data-v-474da984]{width:calc(100% - 50px)}.usercomments .othercomments .right .replyname[data-v-474da984]{margin-right:10px;font-size:14px;color:#0e8de6;display:inline-block;margin-bottom:10px}.usercomments .othercomments .right .replytime[data-v-474da984]{font-size:14px;color:#999;display:inline-block;margin-bottom:10px;float:right}.usercomments .othercomments .right .replycontent[data-v-474da984]{font-size:14px;color:#333;width:100%;margin-bottom:10px}.usercomments .othercomments .right .replyoperation[data-v-474da984]{justify-content:space-between;margin-bottom:10px}.usercomments .othercomments .right .replyoperation .replyBtn[data-v-474da984]{color:#3064ea;font-size:14px;margin-right:10px;cursor:pointer}.usercomments .othercomments .right .replyoperation .replynum[data-v-474da984]{color:#999;margin-right:10px}.usercomments .othercomments .right .replyoperation .evaluation img[data-v-474da984]{width:14px;height:14px}.usercomments .othercomments .right .replyoperation .evaluation div[data-v-474da984]{color:#999;margin-left:10px;cursor:pointer}.usercomments .othercomments .right .replyoperation .evaluation span[data-v-474da984]{margin-left:6px}.defaultAvatar[data-v-474da984]{line-height:40px;font-size:12px;background:#0e8de6;opacity:.85}.defaultAvatar[data-v-474da984],.useravatar40[data-v-474da984]{width:40px;height:40px;color:#fff;text-align:center;border-radius:50%}.useravatar40[data-v-474da984]{line-height:42px;margin-right:10px;display:inline-block}.useravatar[data-v-474da984]{width:40px;height:40px;border-radius:50%;object-fit:cover;text-align:center;line-height:40px}.sendcommentdiv[data-v-474da984]{border:1px solid #dcdcdc;border-radius:5px;position:relative;font-size:16px;color:#bababa;background:#fff;box-sizing:content-box;flex:1;min-height:40px;height:100%;overflow:hidden}.sendcommentdiv .input-wrap textarea[data-v-474da984]{transition:all .4s}.sendcommentdiv .input-wrap .tafocus[data-v-474da984]{width:100%;border:0;resize:none;outline:none;padding:10px;color:#666}.sendcommentdiv .input-wrap .tanotfocus[data-v-474da984]{display:block;font-size:16px;width:100%;height:30px;resize:none;border:0;outline:0;padding:10px;border:0 solid #dcdcdc}.sendcommentdiv .cbtnsdiv[data-v-474da984]{position:absolute;bottom:0;right:0;padding:0;border:none;height:30px}.sendcommentdiv .cbtnsdiv .send[data-v-474da984]{float:right;width:80px;height:30px;line-height:30px;text-align:center;font-size:14px;color:#fff;background:#0e8de6;cursor:pointer;border-radius:0 0 5px 0}.cbtnsdiv.focus[data-v-474da984]{position:relative;background-color:#f4f5f6;bottom:0;right:0;padding:0;border:none;height:30px}.input-wrap.focus textarea[data-v-474da984]{height:80px}", ""]);

// exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usercomments"},[_c('div',{staticClass:"commenttitle vCenter"},[_c('div',{staticClass:"ctitle"},[_vm._v("留下您的评论")]),_vm._v(" "),_c('div',{staticClass:"totalNumber"},[_c('span',[_vm._v(_vm._s(_vm.total))]),_vm._v("条评论")])]),_vm._v(" "),_c('div',{staticClass:"minecomments clearfix"},[_c('div',{staticClass:"cuseravatar"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.avatar==''||_vm.avatar==undefined),expression:"avatar==''||avatar==undefined"}],staticClass:"defaultAvatar useravatar40"},[_vm._v(_vm._s(_vm.getShortName(_vm.sumname)))]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.avatar!=''&&_vm.avatar!=undefined),expression:"avatar!=''&&avatar!=undefined"}],staticClass:"useravatar40",attrs:{"src":_vm.avatar,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"sendcommentdiv"},[_c('div',{staticClass:"input-wrap focus"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.usercomments),expression:"usercomments"}],staticClass:"tafocus",attrs:{"name":"","placeholder":"写下您的评论..."},domProps:{"value":(_vm.usercomments)},on:{"input":function($event){if($event.target.composing){ return; }_vm.usercomments=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"clearfix cbtnsdiv focus"},[_c('div',{staticClass:"send fr",on:{"click":function($event){_vm.send()}}},[_vm._v("发送")])])])]),_vm._v(" "),(_vm.showNewComment)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.total>0),expression:"total>0"}],staticClass:"commenttitle vCenter"},[_c('div',{staticClass:"ctitle"},[_vm._v("最新评论")])]):_vm._e(),_vm._v(" "),(_vm.showNewComment)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.total>0),expression:"total>0"}],staticClass:"othercomments"},[_c('ul',_vm._l((_vm.review),function(item,index){return _c('li',{staticClass:"clearfix",attrs:{"data-dappuuid":item.dappuuid}},[_c('div',{staticClass:"fl left"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.avatar==''||item.avatar==undefined),expression:"item.avatar==''||item.avatar==undefined"}],staticClass:"defaultAvatar"},[_vm._v(_vm._s(_vm.getShortName(item.sumname)))]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(item.avatar!=''&&item.avatar!=undefined),expression:"item.avatar!=''&&item.avatar!=undefined"}],attrs:{"src":item.avatar,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"fl right"},[_c('div',[_c('span',{staticClass:"replyname"},[_vm._v(_vm._s(item.sumname))]),_vm._v(" "),_c('span',{staticClass:"replytime"},[_vm._v(_vm._s(item.createdate))])]),_vm._v(" "),_c('div',{staticClass:"replycontent"},[_vm._v("\n                    "+_vm._s(item.stext)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"replyoperation clearfix"},[_c('div',{staticClass:"fr"},[_c('div',{staticClass:"clearfix evaluation"},[_c('div',{staticClass:"fl vCenter",on:{"click":function($event){_vm.ding(item.sid)}}},[_c('img',{attrs:{"src":item.mineding=='1'? '/img/icon/zaned.png' : '/img/icon/zan.png',"alt":""}}),_vm._v(" "),_c('span',[_vm._v("\n                                  "+_vm._s(parseInt(item.dingcount))+"\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"fl vCenter",on:{"click":function($event){_vm.cai(item.sid)}}},[_c('img',{attrs:{"src":item.minecai=='1'? '/img/icon/caied.png' : '/img/icon/cai.png',"alt":""}}),_vm._v(" "),_c('span',[_vm._v("\n                                  "+_vm._s(parseInt(item.caicount))+"\n                                ")])])])])])])])}))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__um_collect__ = __webpack_require__(109);

__WEBPACK_IMPORTED_MODULE_0__um_collect__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__um_collect__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__um_collect__["a" /* default */]);
}; //注册组件
// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) { 
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__um_collect__["a" /* default */]);

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_collect_vue__ = __webpack_require__(17);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5aa53e2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_collect_vue__ = __webpack_require__(112);
function injectStyle (ssrContext) {
  __webpack_require__(110)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b5aa53e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_collect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5aa53e2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_collect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(111);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("257ef888", content, true, {});

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".collectbtndiv[data-v-b5aa53e2]{cursor:pointer;margin-left:16px}.collectbtndiv img[data-v-b5aa53e2]{width:16px;height:16px}.collectbtndiv .btntext[data-v-b5aa53e2]{margin-left:4px;font-size:12px;color:#999}", ""]);

// exports


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vCenter collectbtndiv",on:{"click":function($event){_vm.collect()}}},[_c('img',{attrs:{"src":_vm.favorites==0?'/img/icon/collect.png':'/img/icon/collected.png',"alt":""}}),_vm._v(" "),(_vm.favorites==0)?_c('div',{staticClass:"btntext"},[_vm._v("\n    收藏\n  ")]):_c('div',{staticClass:"btntext"},[_vm._v("\n    取消\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__um_share__ = __webpack_require__(114);

__WEBPACK_IMPORTED_MODULE_0__um_share__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__um_share__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__um_share__["a" /* default */]);
}; //注册组件
// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) { 
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__um_share__["a" /* default */]);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_share_vue__ = __webpack_require__(18);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69dac82c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_share_vue__ = __webpack_require__(117);
function injectStyle (ssrContext) {
  __webpack_require__(115)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69dac82c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_share_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69dac82c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_share_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(116);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4d36cd16", content, true, {});

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".btndiv[data-v-69dac82c]{cursor:pointer;margin-left:16px}.btndiv img[data-v-69dac82c]{width:16px;height:16px}.btndiv .btntext[data-v-69dac82c]{margin-left:4px;font-size:12px;color:#999}.shareImg[data-v-69dac82c]{position:fixed;z-index:200;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.7)}.shareImg img[data-v-69dac82c]{width:230px;float:right;margin-right:20px}#mask1[data-v-69dac82c]{position:fixed;width:100vw;height:100vh;left:0;top:0;background:rgba(0,0,0,.2);z-index:99}#login[data-v-69dac82c]{position:absolute;width:290px;height:330px;top:0;left:0;right:0;bottom:0;margin:auto}.indexCloseBtn[data-v-69dac82c]{position:absolute;width:25px;height:25px;display:inline-block;right:-10px;top:-10px;z-index:2;cursor:pointer}#login .loginBox[data-v-69dac82c]{margin:auto!important}.qrcodebox[data-v-69dac82c]{position:relative;background:#fff;width:290px;border-radius:6px;line-height:normal;padding:0 30px;height:330px}.codetitle[data-v-69dac82c]{padding:40px 0 20px;font-size:16px}", ""]);

// exports


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"vCenter btndiv",on:{"click":function($event){_vm.share()}}},[_c('img',{attrs:{"src":"/img/icon/share.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"btntext"},[_vm._v("\n          分享\n        ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mask),expression:"mask"}],attrs:{"id":"mask1"}},[_c('div',{attrs:{"id":"login"}},[_c('img',{staticClass:"indexCloseBtn",attrs:{"src":"/img/close1.png","alt":""},on:{"click":function($event){_vm.mask=false}}}),_vm._v(" "),_c('div',{staticClass:"qrcodebox",attrs:{"align":"center"}},[_c('div',{staticClass:"codetitle"},[_vm._v("请扫描下面的二维码")]),_vm._v(" "),_c('div',{ref:"sharecanvas2",attrs:{"id":"sharecanvas2"}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showShareImg),expression:"showShareImg"}],staticClass:"shareImg",on:{"click":function($event){_vm.showShareImg=false}}},[_c('img',{attrs:{"src":"/img/icon/shareimg.png","alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__um_download_app__ = __webpack_require__(119);

__WEBPACK_IMPORTED_MODULE_0__um_download_app__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__um_download_app__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__um_download_app__["a" /* default */]);
}; //注册组件
// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) { 
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__um_download_app__["a" /* default */]);

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_download_app_vue__ = __webpack_require__(19);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1f04b0c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_download_app_vue__ = __webpack_require__(122);
function injectStyle (ssrContext) {
  __webpack_require__(120)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b1f04b0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_download_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1f04b0c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_download_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(121);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2097d6a2", content, true, {});

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".downloadApp[data-v-b1f04b0c]{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.7);z-index:2000;display:flex;justify-content:center;align-items:center}.downloadApp .dl_box[data-v-b1f04b0c]{background:#fff;padding:15px 25px;border-radius:5px;position:relative}.downloadApp .dl_box .title[data-v-b1f04b0c]{font-size:16px;color:#333;text-align:center}.downloadApp .dl_box .close[data-v-b1f04b0c]{position:absolute;right:11px;top:8px}.downloadApp .dl_box .close img[data-v-b1f04b0c]{width:15px;height:15px}.downloadApp .dl_box .tip[data-v-b1f04b0c]{margin-top:20px;font-size:15px;color:#333}.downloadApp .dl_box .qr #downloadApp[data-v-b1f04b0c]{width:225px;height:225px}.downloadApp .dl_box .d_btn .btn[data-v-b1f04b0c]{width:80%;height:45px;background:#2e9cf1;color:#fff;border:none;font-size:15px;text-align:center;line-height:45px;border-radius:3px;margin:0 auto;margin-top:15px;display:block}", ""]);

// exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"downloadApp"},[_c('div',{staticClass:"dl_box"},[_c('div',{staticClass:"title"},[_vm._v("\n          须在APP下使用，请安装\n      ")]),_vm._v(" "),_c('div',{staticClass:"close",on:{"click":_vm.changeStatus}},[_c('img',{attrs:{"src":"/img/closeicon.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"tip qr"},[_c('div',{staticClass:"qr_t"},[_vm._v("\n              1.扫码下载安装\n          ")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('div',{ref:"downloadAppQR",staticClass:"downloadAppQR",attrs:{"id":"downloadAppQR"}})])]),_vm._v(" "),_c('div',{staticClass:"d_btn"},[_c('div',[_vm._v("\n              2.点击按钮下载安装\n          ")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.downloadUrl,"target":"_blank"}},[_c('button',{staticClass:"btn"},[_vm._v("\n                  立即下载\n              ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__um_recharge__ = __webpack_require__(124);

__WEBPACK_IMPORTED_MODULE_0__um_recharge__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__um_recharge__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__um_recharge__["a" /* default */]);
}; //注册组件
// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) { 
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__um_recharge__["a" /* default */]);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_recharge_vue__ = __webpack_require__(20);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82cb94ac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_recharge_vue__ = __webpack_require__(127);
function injectStyle (ssrContext) {
  __webpack_require__(125)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-82cb94ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_recharge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82cb94ac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_recharge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(126);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("5769934e", content, true, {});

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".paylist[data-v-82cb94ac]{margin-top:20px}.paylist li[data-v-82cb94ac]{min-width:110px;min-height:90px;border:1px solid #dedede;border-radius:5px;margin:0 10px 10px 0;display:inline-block;text-align:center;position:relative;cursor:pointer;padding:0 10px}.paylist li>div[data-v-82cb94ac]{position:absolute;top:50%;transform:translateY(-50%);width:calc(100% - 20px)}.paylist li>div .jfNum[data-v-82cb94ac]{font-size:16px;font-weight:700;color:#2e9cf1;margin-bottom:10px}.paylist li>div .moneyNum[data-v-82cb94ac]{color:#999}.paylist li.active[data-v-82cb94ac]{border:1px solid #2e9cf1}.paylist .otherNum[data-v-82cb94ac]{width:270px;color:#999;margin-right:0}.paylist .otherNum .vCenter[data-v-82cb94ac]{justify-content:center}.paylist .otherNum .moneyNum[data-v-82cb94ac]{margin-top:10px}.paylist .otherNum input[data-v-82cb94ac]{border:0;max-width:70px;margin:0 10px;color:#999;font-size:14px;border-bottom:1px solid #ddd;text-align:center;padding:3px}.paytypeList li[data-v-82cb94ac]{width:200px;height:70px;background:#fff;border:1px solid #eee;text-align:center;line-height:70px;font-size:16px;margin-right:10px;cursor:pointer}.paytypeList li img[data-v-82cb94ac]{margin-right:10px}.paytypeList li.payactive[data-v-82cb94ac]{border:1px solid #2e9cf1}.payTips[data-v-82cb94ac]{text-align:center;margin-top:10px}.payTips img[data-v-82cb94ac]{width:16px;margin-right:10px}.exchange[data-v-82cb94ac]{width:200px;height:40px;background:#2e9cf1;color:#fff;border-radius:5px;border:0;cursor:pointer;margin-top:40px}.qrcodeBox[data-v-82cb94ac]{display:flex;justify-content:center;background:url(\"/img/wxcodebg.png\") no-repeat;padding:20px;width:200px;height:200px;margin:20px auto 0}.qrcodeBox .creatcodeBtn[data-v-82cb94ac]{width:200px;height:40px;background:#22ac38;color:#fff;border-radius:5px;border:0;cursor:pointer}.qrcodeBox .wxpaylogo[data-v-82cb94ac]{width:160px;height:37px}", ""]);

// exports


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.payMod=='integral'?'积分充值':'UM币兑换',"width":"61.8%","custom-class":"payDialog","visible":_vm.payDialog,"close-on-click-modal":false,"close-on-press-escape":false,"modal-append-to-body":false,"before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.payDialog=$event},"close":function($event){_vm.close()}}},[(_vm.payMod=='integral')?_c('div',[_c('div',[_vm._v("请选择充值金额（当前余额："+_vm._s(_vm.allAccount)+"积分）")]),_vm._v(" "),_c('ul',{staticClass:"paylist"},[_vm._l((_vm.paylist),function(item,index){return _c('li',{key:index,class:{'active':_vm.activeNum==item.moneyNum&&!_vm.otherNumChoose},on:{"click":function($event){_vm.chooseNum(item.moneyNum,false)}}},[_c('div',[_c('div',{staticClass:"jfNum"},[_vm._v(_vm._s(item.jfNum)+" 积分")]),_vm._v(" "),_c('div',{staticClass:"moneyNum"},[_vm._v(_vm._s(item.moneyNum)+" 元")])])])}),_vm._v(" "),_c('li',{staticClass:"otherNum",class:{'active':_vm.otherNumChoose},on:{"click":function($event){_vm.chooseNum(0,true)}}},[_c('div',[_c('div',{staticClass:"vCenter"},[_c('span',[_vm._v("其他金额：")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.otherNum),expression:"otherNum"}],ref:"otherNum",attrs:{"type":"number"},domProps:{"value":(_vm.otherNum)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.otherNum=$event.target.value},_vm.oninput]}}),_vm._v("元\n          ")]),_vm._v(" "),_c('div',{staticClass:"moneyNum"},[_vm._v(_vm._s(_vm.accMul(_vm.otherNum,100))+" 积分")])])])],2),_vm._v(" "),_c('ul',{staticClass:"clearfix paytypeList"},[_c('li',{class:_vm.paytype==2?'payactive fl':'fl',on:{"click":function($event){_vm.qrcode();_vm.paytype=2}}},[_c('img',{attrs:{"src":"/img/payicon/wechat.png","alt":""}}),_vm._v("微信支付\n      ")]),_vm._v(" "),_c('li',{class:_vm.paytype==1?'payactive fl':'fl',on:{"click":function($event){_vm.paytype=1;_vm.alipayUrl()}}},[_c('img',{attrs:{"src":"/img/payicon/alipay.png","alt":""}}),_vm._v("支付宝支付\n      ")])]),_vm._v(" "),(_vm.paytype==2&&_vm.showcode)?_c('div',{staticClass:"center qrcodeBox vCenter"},[_c('button',{staticClass:"creatcodeBtn",on:{"click":function($event){_vm.qrcode()}}},[_vm._v("生成二维码")])]):_vm._e(),_vm._v(" "),(_vm.paytype==2&&!_vm.showcode)?_c('div',{staticClass:"center qrcodeBox vCenter"},[_c('div',{ref:"qrcode",staticClass:"qrcode",attrs:{"id":"qrcode"}})]):_vm._e(),_vm._v(" "),(_vm.paytype==2)?_c('div',{staticClass:"payTips"},[_c('img',{attrs:{"src":"/img/payicon/wechat.png","alt":""}}),_vm._v("请使用微信支付完成付款\n    ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.payMod=='umcoin')?_c('div',[_c('div',[_vm._v("请选择兑换数量（当前余额："+_vm._s(_vm.umallAccount)+"UM币）")]),_vm._v(" "),_c('ul',{staticClass:"paylist"},[_vm._l((_vm.umpaylist),function(item,index){return _c('li',{key:index,class:{'active':_vm.activeumNum==item.moneyNum&&!_vm.otherUmNumChoose},on:{"click":function($event){_vm.chooseumNum(item.moneyNum,false)}}},[_c('div',[_c('div',{staticClass:"jfNum"},[_vm._v(_vm._s(item.umNum)+" UM币")]),_vm._v(" "),_c('div',{staticClass:"moneyNum"},[_vm._v("∮ "+_vm._s(item.moneyNum))])])])}),_vm._v(" "),_c('li',{staticClass:"otherNum",class:{'active':_vm.otherUmNumChoose},on:{"click":function($event){_vm.chooseumNum(0,true)}}},[_c('div',[_c('div',{staticClass:"vCenter"},[_c('span',[_vm._v("其他金额：")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.otherumNum),expression:"otherumNum"}],ref:"otherNum",attrs:{"type":"number"},domProps:{"value":(_vm.otherumNum)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.otherumNum=$event.target.value},_vm.onuminput]}}),_vm._v(" UM币\n          ")]),_vm._v(" "),_c('div',{staticClass:"moneyNum"},[_vm._v("∮ "+_vm._s(_vm.accMul(_vm.otherumNum,100)))])])])],2),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"20px"}},[_vm._v("当前比率：1UMBit=100积分（100UMGrid）")]),_vm._v(" "),_c('ul',{staticClass:"clearfix paytypeList"},[_c('li',{staticClass:"payactive fl"},[_c('img',{attrs:{"src":"/img/payicon/jf.png","alt":""}}),_vm._v("积分兑换\n      ")])]),_vm._v(" "),_c('div',{staticClass:"center"},[_c('button',{staticClass:"exchange",on:{"click":function($event){_vm.exchange()}}},[_vm._v("立即兑换")])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__um_range__ = __webpack_require__(129);

__WEBPACK_IMPORTED_MODULE_0__um_range__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__um_range__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__um_range__["a" /* default */]);
}; //注册组件
// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) { 
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__um_range__["a" /* default */]);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_range_vue__ = __webpack_require__(21);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c42dd1f4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_range_vue__ = __webpack_require__(132);
function injectStyle (ssrContext) {
  __webpack_require__(130)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c42dd1f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_range_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c42dd1f4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_range_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(131);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4f430d0a", content, true, {});

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".rangeselect[data-v-c42dd1f4]{height:40px;justify-content:space-between}", ""]);

// exports


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form-item',{attrs:{"label":"发布范围","label-width":"80px"}},[_c('div',{staticClass:"vCenter rangeselect"},[_c('div',{staticClass:"vCenter"},[_c('el-radio',{staticClass:"elradio",attrs:{"label":"0"},model:{value:(_vm.formdapp.rangetype),callback:function ($$v) {_vm.$set(_vm.formdapp, "rangetype", $$v)},expression:"formdapp.rangetype"}},[_vm._v("仅个人可见（草稿）")]),_vm._v(" "),_c('el-radio',{staticClass:"elradio",attrs:{"label":"1"},model:{value:(_vm.formdapp.rangetype),callback:function ($$v) {_vm.$set(_vm.formdapp, "rangetype", $$v)},expression:"formdapp.rangetype"}},[_vm._v("所有人可见")]),_vm._v(" "),_c('el-radio',{staticClass:"elradio",attrs:{"label":"2"},on:{"change":_vm.rangeChange},model:{value:(_vm.formdapp.rangetype),callback:function ($$v) {_vm.$set(_vm.formdapp, "rangetype", $$v)},expression:"formdapp.rangetype"}},[_vm._v("范围可见")])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.formdapp.rangetype=='2'),expression:"formdapp.rangetype=='2'"}]},[_c('el-button',{staticClass:"adduser",attrs:{"type":"primary","plain":"","size":"small"},on:{"click":function($event){_vm.opencandidate('12378')}}},[_vm._v("选择")])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.formdapp.rangetype=='2'),expression:"formdapp.rangetype=='2'"}]},[_c('div',[_c('div',[_vm._v("已选好友：")]),_vm._v(" "),_c('div',_vm._l((_vm.tagsFriend),function(item,index){return _c('el-tag',{key:index,attrs:{"closable":""},on:{"close":function($event){_vm.handleClose(item,index,'f')}}},[_vm._v(_vm._s(item.name))])}))]),_vm._v(" "),_c('div',[_c('div',[_vm._v("已选群组：")]),_vm._v(" "),_c('div',_vm._l((_vm.tagsGroup),function(item,index){return _c('el-tag',{key:index,attrs:{"closable":""},on:{"close":function($event){_vm.handleClose(item,index,'g')}}},[_vm._v(_vm._s(item.name))])}))]),_vm._v(" "),_c('div',[_c('div',[_vm._v("已选组织：")]),_vm._v(" "),_c('div',_vm._l((_vm.tagsOrg),function(item,index){return _c('el-tag',{key:index,attrs:{"closable":""},on:{"close":function($event){_vm.handleClose(item,index,'o')}}},[_vm._v(_vm._s(item.name))])}))]),_vm._v(" "),_c('div',[_c('div',[_vm._v("已选行业：")]),_vm._v(" "),_c('div',_vm._l((_vm.tagshy),function(item,index){return _c('el-tag',{key:index,attrs:{"closable":""},on:{"close":function($event){_vm.handleClose(item,index,'h')}}},[_vm._v(_vm._s(item.name))])}))]),_vm._v(" "),_c('div',[_c('div',[_vm._v("已选地区：")]),_vm._v(" "),_c('div',_vm._l((_vm.tagsdq),function(item,index){return _c('el-tag',{key:index,attrs:{"closable":""},on:{"close":function($event){_vm.handleClose(item,index,'d')}}},[_vm._v(_vm._s(item.name))])}))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__um_identity__ = __webpack_require__(134);

__WEBPACK_IMPORTED_MODULE_0__um_identity__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__um_identity__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__um_identity__["a" /* default */]);
}; //注册组件
// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) { 
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__um_identity__["a" /* default */]);

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_identity_vue__ = __webpack_require__(22);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e48d93b4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_identity_vue__ = __webpack_require__(137);
function injectStyle (ssrContext) {
  __webpack_require__(135)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e48d93b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_identity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e48d93b4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_identity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(136);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("a10c1162", content, true, {});

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".addlist .rangeselect[data-v-e48d93b4]{padding:14px 0}.rangeselect[data-v-e48d93b4]{height:40px}", ""]);

// exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form-item',{attrs:{"label":"发布身份","required":"","label-width":"80px"}},[_c('div',{staticClass:"vCenter rangeselect"},[_c('el-radio',{staticClass:"elradio",attrs:{"label":"1","disabled":_vm.formdapp.distype==1},on:{"change":_vm.setItem},model:{value:(_vm.formdapp.identitytype),callback:function ($$v) {_vm.$set(_vm.formdapp, "identitytype", $$v)},expression:"formdapp.identitytype"}},[_vm._v("个人身份")]),_vm._v(" "),_c('el-radio',{staticClass:"elradio",attrs:{"label":"3"},on:{"change":_vm.setItem},model:{value:(_vm.formdapp.identitytype),callback:function ($$v) {_vm.$set(_vm.formdapp, "identitytype", $$v)},expression:"formdapp.identitytype"}},[_vm._v("组织身份")])],1)]),_vm._v(" "),(_vm.formdapp.identitytype=='3')?_c('el-form-item',{attrs:{"label":"代表组织","required":"","label-width":"80px"}},[_c('el-select',{attrs:{"placeholder":"请选择代表组织","popper-append-to-body":false},on:{"change":_vm.curOrgChanged},model:{value:(_vm.formdapp.item),callback:function ($$v) {_vm.$set(_vm.formdapp, "item", $$v)},expression:"formdapp.item"}},_vm._l((_vm.orglist),function(item){return _c('el-option',{key:item.orgid,attrs:{"label":item.orgname,"value":item.orgid}})}))],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__um_mrange__ = __webpack_require__(139);

__WEBPACK_IMPORTED_MODULE_0__um_mrange__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__um_mrange__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__um_mrange__["a" /* default */]);
}; //注册组件
// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) { 
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__um_mrange__["a" /* default */]);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_mrange_vue__ = __webpack_require__(23);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f55a421_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_mrange_vue__ = __webpack_require__(142);
function injectStyle (ssrContext) {
  __webpack_require__(140)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f55a421"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_mrange_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f55a421_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_mrange_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(141);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("9054e6f6", content, true, {});

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".choosed[data-v-1f55a421]{float:left;width:100%;padding:10px 15px}.choosed .c_fr[data-v-1f55a421]{font-size:15px}.choosed .choosed_friend[data-v-1f55a421]{margin-top:10px}.choosed .choosed_friend li[data-v-1f55a421]{display:inline-block;border:1px solid #d9ecff;background:#ecf5ff;border-radius:3px;padding:0 10px;height:30px;color:#409eff;line-height:30px;font-size:14px;margin-bottom:8px;margin-left:3px}.choosed .choose_re[data-v-1f55a421]{background:#2e9cf1;border-color:#2e9cf1;color:#fff;padding:10px;text-align:center;height:40px;line-height:20px;border-radius:5px;width:100px}.mask[data-v-1f55a421]{position:fixed;width:100vw;height:100vh;left:0;top:0;background:rgba(0,0,0,.7);z-index:2000;display:flex;justify-content:center;align-items:center}.mask .boxtitle[data-v-1f55a421]{text-align:center;line-height:40px;width:73.3%;background:#fff;font-size:16px;margin:0 auto;border-radius:3px 3px 0 0}.mask .selrangebox[data-v-1f55a421]{height:220px;width:73.3%;margin:auto;background:#fff;border-radius:0 0 3px 3px;padding:0 15px 20px;font-size:15px;overflow-y:auto}.check_box[data-v-1f55a421]{display:flex}.check_box div[data-v-1f55a421]{flex:1;font-size:15px;text-align:center}.check_box div .check_in[data-v-1f55a421]{opacity:0}.check_box div .inner[data-v-1f55a421]{width:14px;height:14px;display:inline-block;border-radius:50%;position:relative;border:1px solid #ccc}.check_box div .inner .inner_in[data-v-1f55a421]{width:8px;height:8px;display:inline-block;background:#2e9cf1;padding:3px;border-radius:50%;position:absolute;left:0;right:0;top:0;bottom:0;margin:auto}.check_box div .inner_active[data-v-1f55a421]{border:1px solid #2e9cf1!important}.check_box .active[data-v-1f55a421]{color:#2e9cf1}.as_li[data-v-1f55a421]{width:100%;float:left;font-size:15px;padding:15px;border-bottom:1px solid #ededed}", ""]);

// exports


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('li',{staticClass:"as_li",on:{"click":_vm.changeScope}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"fr"},[_c('span',[_vm._v(_vm._s(_vm.scope))]),_vm._v(" "),_c('div',{staticClass:"jt"})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reset_choose),expression:"reset_choose"}],staticClass:"choosed clearfix"},[_c('div',{staticClass:"c_fr"},[_vm._v("已选人:")]),_vm._v(" "),_c('div',{staticClass:"choosed_friend"},_vm._l((_vm.friendArr),function(item,index){return _c('el-tag',{key:index,staticStyle:{"margin":"0 10px 10px 0"},attrs:{"closable":""},on:{"close":function($event){_vm.handleClose(item,index,'f')}}},[_vm._v(_vm._s(item.name))])})),_vm._v(" "),_c('div',{staticClass:"c_fr"},[_vm._v("已选群:")]),_vm._v(" "),_c('div',{staticClass:"choosed_friend"},_vm._l((_vm.groupArr),function(item,index){return _c('el-tag',{key:index,staticStyle:{"margin":"0 10px 10px 0"},attrs:{"closable":""},on:{"close":function($event){_vm.handleClose(item,index,'g')}}},[_vm._v(_vm._s(item.name))])})),_vm._v(" "),_c('div',{staticClass:"c_fr"},[_vm._v("已选组织:")]),_vm._v(" "),_c('div',{staticClass:"choosed_friend"},_vm._l((_vm.orgArr),function(item,index){return _c('el-tag',{key:index,staticStyle:{"margin":"0 10px 10px 0"},attrs:{"closable":""},on:{"close":function($event){_vm.handleClose(item,index,'o')}}},[_vm._v(_vm._s(item.name))])})),_vm._v(" "),_c('div',{staticClass:"c_fr"},[_vm._v("已选行业:")]),_vm._v(" "),_c('div',{staticClass:"choosed_friend"},_vm._l((_vm.hyArr),function(item,index){return _c('el-tag',{key:index,staticStyle:{"margin":"0 10px 10px 0"},attrs:{"closable":""},on:{"close":function($event){_vm.handleClose(item,index,'h')}}},[_vm._v(_vm._s(item.name))])})),_vm._v(" "),_c('div',{staticClass:"c_fr"},[_vm._v("已选地区:")]),_vm._v(" "),_c('div',{staticClass:"choosed_friend"},_vm._l((_vm.dqArr),function(item,index){return _c('el-tag',{key:index,staticStyle:{"margin":"0 10px 10px 0"},attrs:{"closable":""},on:{"close":function($event){_vm.handleClose(item,index,'d')}}},[_vm._v(_vm._s(item.name))])})),_vm._v(" "),_c('div',{staticClass:"choose_re fr",on:{"click":_vm.choose}},[_vm._v("继续选择")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.muta_status),expression:"muta_status"}],staticClass:"mask",on:{"click":_vm.mask_status}},[_c('div',{staticStyle:{"width":"100%"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scope_status),expression:"scope_status"}],staticClass:"boxtitle"},[_vm._v("请选择发布范围")]),_vm._v(" "),_c('div',{staticClass:"selrangebox",attrs:{"id":"selrangebox"}},[_c('el-radio-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.scope_status),expression:"scope_status"}],attrs:{"size":"medium"},on:{"change":_vm.changeRa},model:{value:(_vm.radio1),callback:function ($$v) {_vm.radio1=$$v},expression:"radio1"}},_vm._l((_vm.scope_arr),function(item,index){return _c('el-radio',{key:index,attrs:{"label":index,"border":""}},[_vm._v(_vm._s(item))])}))],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fl"},[_c('i',{staticClass:"iconfont"},[_vm._v("")]),_vm._v(" "),_c('span',[_vm._v("发布范围")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__um_midentity__ = __webpack_require__(144);

__WEBPACK_IMPORTED_MODULE_0__um_midentity__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__um_midentity__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__um_midentity__["a" /* default */]);
}; //注册组件
// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) { 
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__um_midentity__["a" /* default */]);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_midentity_vue__ = __webpack_require__(24);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5594a757_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_midentity_vue__ = __webpack_require__(147);
function injectStyle (ssrContext) {
  __webpack_require__(145)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5594a757"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_midentity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5594a757_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_midentity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(146);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("41283a98", content, true, {});

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".mask[data-v-5594a757]{position:fixed;width:100vw;height:100vh;left:0;top:0;background:rgba(0,0,0,.7);z-index:2000;display:flex;justify-content:center;align-items:center}.mask .boxtitle[data-v-5594a757]{text-align:center;line-height:40px;width:73.3%;background:#fff;font-size:16px;margin:0 auto;border-radius:3px 3px 0 0}.mask .selidbox[data-v-5594a757]{height:220px;width:73.3%;margin:auto;background:#fff;border-radius:0 0 3px 3px;padding:0 15px 20px;font-size:15px;overflow-y:auto}.check_box[data-v-5594a757]{display:flex}.check_box div[data-v-5594a757]{flex:1;font-size:15px;text-align:center}.check_box div .check_in[data-v-5594a757]{opacity:0}.check_box div .inner[data-v-5594a757]{width:14px;height:14px;display:inline-block;border-radius:50%;position:relative;border:1px solid #ccc}.check_box div .inner .inner_in[data-v-5594a757]{width:8px;height:8px;display:inline-block;background:#2e9cf1;padding:3px;border-radius:50%;position:absolute;left:0;right:0;top:0;bottom:0;margin:auto}.check_box div .inner_active[data-v-5594a757]{border:1px solid #2e9cf1!important}.check_box .active[data-v-5594a757]{color:#2e9cf1}.as_li[data-v-5594a757]{width:100%;float:left;font-size:15px;padding:15px;border-bottom:1px solid #ededed}", ""]);

// exports


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('li',{staticClass:"as_li"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"check_box fr"},[_c('div',{class:{ active: _vm.change_status },on:{"click":_vm.changeP}},[_c('input',{staticClass:"check_in",attrs:{"type":"radio","name":"radio","id":"ra1","value":"1"}}),_vm._v(" "),_c('label',{attrs:{"for":"ra1"}},[_c('span',{class:{ inner: true, inner_active: _vm.change_status }},[_c('span',{class:{ inner_in: _vm.change_status }})]),_vm._v("\n          个人身份\n        ")])]),_vm._v(" "),_c('div',{class:{ active: !_vm.change_status },on:{"click":_vm.changeO}},[_c('input',{staticClass:"check_in",attrs:{"type":"radio","name":"radio","id":"ra2","value":"3"}}),_vm._v(" "),_c('label',{attrs:{"for":"ra2"}},[_c('span',{class:{ inner: true, inner_active: !_vm.change_status }},[_c('span',{class:{ inner_in: !_vm.change_status }})]),_vm._v("\n          组织身份\n        ")])])])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.change_status),expression:"!change_status"}],staticClass:"as_li",on:{"click":_vm.changeOrg}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"fr"},[_c('span',[_vm._v(_vm._s(_vm.org_name))]),_vm._v(" "),_c('div',{staticClass:"jt"})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.muta_status),expression:"muta_status"}],staticClass:"mask",on:{"click":_vm.mask_status}},[_c('div',{staticStyle:{"width":"100%"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.choose_org_status),expression:"choose_org_status"}],staticClass:"boxtitle"},[_vm._v("请选择代表组织")]),_vm._v(" "),_c('div',{staticClass:"selidbox",attrs:{"id":"selidbox"}},[_c('el-radio-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.choose_org_status),expression:"choose_org_status"}],attrs:{"size":"medium"},on:{"change":_vm.change_org},model:{value:(_vm.radio2),callback:function ($$v) {_vm.radio2=$$v},expression:"radio2"}},_vm._l((_vm.orgArr),function(item,index){return _c('el-radio',{key:index,attrs:{"label":parseInt(item.orgid),"border":""}},[_vm._v(_vm._s(item.orgname))])}))],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fl"},[_c('i',{staticClass:"iconfont"},[_vm._v("")]),_vm._v(" "),_c('span',[_vm._v("发布身份")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fl"},[_c('i',{staticClass:"iconfont"},[_vm._v("")]),_vm._v(" "),_c('span',[_vm._v("代表组织")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__um_edituser__ = __webpack_require__(149);

__WEBPACK_IMPORTED_MODULE_0__um_edituser__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__um_edituser__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__um_edituser__["a" /* default */]);
}; //注册组件
// 标签的方式引入，留到后面再另开新篇讨论
//const install = function(Vue, opts = {}) { 
//　　Vue.component(sumFunction.name, sumFunction);
//}

/* 支持使用标签的方式引入 Vue是全局变量时，自动install */
//if (typeof window !== 'undefined' && window.Vue) {
//  install(window.Vue);
//}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__um_edituser__["a" /* default */]);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_edituser_vue__ = __webpack_require__(25);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66687203_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_edituser_vue__ = __webpack_require__(154);
function injectStyle (ssrContext) {
  __webpack_require__(150)
  __webpack_require__(152)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66687203"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_um_edituser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66687203_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_um_edituser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(151);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2898649f", content, true, {});

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".editava{top:50%;transform:translateY(-50%);margin-top:0!important}.editava .avatar-uploader{width:40px;height:40px}.editava .el-upload-dragger{height:38px;width:38px}.editava .el-upload-dragger img{height:40px}.editava .avatar-uploader-icon{width:36px;height:36px;line-height:36px!important}.editava .distpicker-address-wrapper{width:60%;float:left}.editava .distpicker-address-wrapper select{width:32%}.editava .address{width:40%;float:left}#city,#district,#province{padding:.5rem .75rem;height:40px;font-size:1rem;line-height:1.25;color:#464a4c;background-color:#fff;background-image:none;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem;-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;float:left;margin-right:10px}", ""]);

// exports


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(153);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("56962824", content, true, {});

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".chooselist li[data-v-66687203]{margin:0 10px 10px 0;position:relative}.chooselist li img[data-v-66687203]{width:40px;height:40px;border-radius:50%;overflow:hidden}.chooselist li .selectcolor[data-v-66687203]{position:absolute;width:16px;height:16px;bottom:0;right:0}.chooselist li[data-v-66687203]:first-child{border-radius:0}.logopath[data-v-66687203]{width:80px;height:80px;border-radius:50%;overflow:hidden;cursor:pointer}", ""]);

// exports


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"编辑我的资料","visible":_vm.editava,"custom-class":"editava","close-on-click-modal":false,"close-on-press-escape":false,"width":"61.8%"},on:{"update:visible":function($event){_vm.editava=$event},"closed":_vm.editavaClose}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"头像：","prop":"avatar"}},[_c('div',{staticClass:"vCenter"},[_c('img',{staticClass:"logopath",attrs:{"src":_vm.form.avatar,"alt":""},on:{"click":_vm.upload1}}),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"20px","flex":"1"}},[_c('p',[_vm._v("点击头像进行选择，点击上传按钮可上传本地图片。")]),_vm._v(" "),_c('ul',{staticClass:"clearfix chooselist"},[_c('li',{staticClass:"fl"},[_c('um-img',{attrs:{"submitStatus":_vm.submitImgStatus,"uploadlogo":_vm.editupload},on:{"submit-file":_vm.submitava,"getImgSrc":_vm.editImg}})],1),_vm._v(" "),_vm._l((_vm.defaultIcon),function(item){return _c('li',{staticClass:"fl"},[_c('img',{attrs:{"src":item.path,"alt":""},on:{"click":function($event){_vm.choosecolor(item)}}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(item.id==_vm.selectcolor),expression:"item.id==selectcolor"}],staticClass:"selectcolor",attrs:{"src":"/img/select.png","alt":""}})])})],2)])])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"姓名：","prop":"sumname"}},[_c('el-input',{model:{value:(_vm.form.sumname),callback:function ($$v) {_vm.$set(_vm.form, "sumname", $$v)},expression:"form.sumname"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"职位：","prop":"job"}},[_c('el-input',{model:{value:(_vm.form.job),callback:function ($$v) {_vm.$set(_vm.form, "job", $$v)},expression:"form.job"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"单位：","prop":"company"}},[_c('el-input',{model:{value:(_vm.form.company),callback:function ($$v) {_vm.$set(_vm.form, "company", $$v)},expression:"form.company"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"固定电话：","prop":"company"}},[_c('el-input',{model:{value:(_vm.form.stel),callback:function ($$v) {_vm.$set(_vm.form, "stel", $$v)},expression:"form.stel"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"邮箱：","prop":"email"}},[_c('el-input',{model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"个性签名："}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.form.signature),callback:function ($$v) {_vm.$set(_vm.form, "signature", $$v)},expression:"form.signature"}})],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.editavaClose}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.submit}},[_vm._v("确 定")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// UmUI.js